webpackJsonp([923280921217],{

/***/ 404:
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// from https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-autocomplete
	// see also:
	//  - https://developers.google.com/web/fundamentals/design-and-ui/input/forms/#use_metadata_to_enable_auto-complete
	//  - https://cloudfour.com/thinks/autofill-what-web-devs-should-know-but-dont/
	var autoCompleteTypes = ['name', 'honorific-prefix', 'given-name', 'additional-name', 'family-name', 'honorific-suffix', 'nickname', 'email', 'username', 'new-password', 'current-password', 'organization-title', 'organization', 'street-address', 'address-line1', 'address-line2', 'address-line3', 'address-level4', 'address-level3', 'address-level2', 'address-level1', 'country', 'country-name', 'postal-code', 'cc-name', 'cc-given-name', 'cc-additional-name', 'cc-family-name', 'cc-number', 'cc-exp', 'cc-exp-month', 'cc-exp-year', 'cc-csc', 'cc-type', 'transaction-currency', 'transaction-amount', 'language', 'bday', 'bday-day', 'bday-month', 'bday-year', 'sex', 'tel', 'url', 'photo'];
	
	exports['default'] = autoCompleteTypes;

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var inputTypes = {
	  DATE: 'date',
	  DATETIME: 'datetime-local',
	  EMAIL: 'email',
	  PASSWORD: 'password',
	  TEL: 'tel',
	  TEXT: 'text'
	};
	
	exports['default'] = inputTypes;

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.lineTypePropType = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var lineTypes = {
	  FULL: 'full',
	  NONE: 'none'
	};
	
	var lineTypePropType = exports.lineTypePropType = _propTypes2['default'].oneOf(Object.values(lineTypes));
	exports['default'] = lineTypes;

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withStyles = __webpack_require__(5);
	
	var _textlike = __webpack_require__(24);
	
	var _textlike2 = _interopRequireDefault(_textlike);
	
	var _idProp = __webpack_require__(40);
	
	var _idProp2 = _interopRequireDefault(_idProp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
	  children: _textlike2['default'],
	  errorRef: _propTypes2['default'].func,
	  id: _idProp2['default'],
	  small: _propTypes2['default'].bool
	}));
	
	var defaultProps = {
	  errorRef: undefined,
	  small: false
	};
	
	function ErrorMessage(_ref) {
	  var children = _ref.children,
	      css = _ref.css,
	      errorRef = _ref.errorRef,
	      id = _ref.id,
	      small = _ref.small,
	      styles = _ref.styles;
	
	  return _react2['default'].createElement(
	    'div',
	    _extends({
	      id: id,
	      'aria-live': 'polite',
	      ref: errorRef
	    }, css(small ? styles.size_small : styles.size_default, styles.errorMessage)),
	    children
	  );
	}
	
	ErrorMessage.componentCategory = 'Core';
	ErrorMessage.displayName = 'ErrorMessage';
	ErrorMessage.propTypes = propTypes;
	ErrorMessage.defaultProps = defaultProps;
	
	exports['default'] = (0, _withStyles.withStyles)(function (_ref2) {
	  var color = _ref2.color,
	      font = _ref2.font;
	  return {
	    size_default: Object.assign({}, font.formErrorMessage),
	
	    size_small: Object.assign({}, font.formErrorMessageSmall),
	
	    errorMessage: Object.assign({}, font.book, {
	      color: color.inputErrorMessage
	    })
	
	  };
	})(ErrorMessage);

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.propTypes = exports.inputTypes = exports.defaultProps = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	var _inputTypes = __webpack_require__(241);
	
	var _inputTypes2 = _interopRequireDefault(_inputTypes);
	
	var _FormElement = __webpack_require__(429);
	
	var _FormElement2 = _interopRequireDefault(_FormElement);
	
	var _InputOnly = __webpack_require__(430);
	
	var _InputOnly2 = _interopRequireDefault(_InputOnly);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = Object.assign({}, _FormElement.propTypes, _InputOnly.propTypes);
	
	var defaultProps = exports.defaultProps = Object.assign({}, _FormElement.defaultProps, _InputOnly.defaultProps);
	
	var Input = function (_React$PureComponent) {
	  _inherits(Input, _React$PureComponent);
	
	  function Input() {
	    _classCallCheck(this, Input);
	
	    return _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
	  }
	
	  _createClass(Input, [{
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props = this.props,
	            actionLink = _props.actionLink,
	            autoCapitalize = _props.autoCapitalize,
	            autoComplete = _props.autoComplete,
	            autoCorrect = _props.autoCorrect,
	            autoFocus = _props.autoFocus,
	            spellCheck = _props.spellCheck,
	            book = _props.book,
	            borderless = _props.borderless,
	            focusBorderless = _props.focusBorderless,
	            disabled = _props.disabled,
	            errorMessage = _props.errorMessage,
	            hasExternalLabel = _props.hasExternalLabel,
	            hideLabel = _props.hideLabel,
	            lightLabel = _props.lightLabel,
	            id = _props.id,
	            inline = _props.inline,
	            invalid = _props.invalid,
	            inputRef = _props.inputRef,
	            inverse = _props.inverse,
	            label = _props.label,
	            labelDescription = _props.labelDescription,
	            maxLength = _props.maxLength,
	            name = _props.name,
	            onChange = _props.onChange,
	            onClear = _props.onClear,
	            onBlur = _props.onBlur,
	            onFocus = _props.onFocus,
	            onKeyDown = _props.onKeyDown,
	            placeholder = _props.placeholder,
	            showFakeValuePlaceholder = _props.showFakeValuePlaceholder,
	            prefix = _props.prefix,
	            readOnly = _props.readOnly,
	            refForFocus = _props.refForFocus,
	            role = _props.role,
	            value = _props.value,
	            small = _props.small,
	            large = _props.large,
	            type = _props.type,
	            underlineFocus = _props.underlineFocus,
	            removeMargins = _props.removeMargins,
	            showOverflowEllipsis = _props.showOverflowEllipsis,
	            suffix = _props.suffix,
	            suffixText = _props.suffixText,
	            ampVarsInputName = _props.ampVarsInputName,
	            velouteId = _props.velouteId;
	
	
	        var errorMessageID = errorMessage ? String(id) + '_error' : undefined;
	        return _react2['default'].createElement(
	          _FormElement2['default'],
	          _extends({}, invalid && { errorMessage: errorMessage, errorMessageID: errorMessageID }, hasExternalLabel && { hasExternalLabel: hasExternalLabel }, !hasExternalLabel && { label: label, labelDescription: labelDescription, lightLabel: lightLabel, hideLabel: hideLabel }, {
	            actionLink: actionLink,
	            id: id,
	            inline: inline,
	            invalid: invalid,
	            inverse: inverse,
	            large: large,
	            small: small
	          }),
	          _react2['default'].createElement(_InputOnly2['default'], _extends({}, invalid && { errorMessageID: errorMessageID }, {
	            autoCapitalize: autoCapitalize,
	            autoComplete: autoComplete,
	            autoCorrect: autoCorrect,
	            autoFocus: autoFocus,
	            spellCheck: spellCheck,
	            book: book,
	            borderless: borderless,
	            focusBorderless: focusBorderless,
	            disabled: disabled,
	            id: id,
	            inline: inline,
	            inverse: inverse,
	            inputRef: inputRef,
	            invalid: invalid,
	            maxLength: maxLength,
	            name: name,
	            onBlur: onBlur,
	            onChange: onChange,
	            onClear: onClear,
	            onFocus: onFocus,
	            onKeyDown: onKeyDown,
	            placeholder: placeholder,
	            showFakeValuePlaceholder: showFakeValuePlaceholder,
	            prefix: prefix,
	            readOnly: readOnly,
	            refForFocus: refForFocus,
	            role: role,
	            value: value,
	            small: small,
	            large: large,
	            type: type,
	            underlineFocus: underlineFocus,
	            removeMargins: removeMargins,
	            showOverflowEllipsis: showOverflowEllipsis,
	            suffixText: suffixText,
	            suffix: suffix,
	            ampVarsInputName: ampVarsInputName,
	            velouteId: velouteId
	          }))
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return Input;
	}(_react2['default'].PureComponent);
	
	Input.componentCategory = 'Core';
	Input.displayName = 'Input';
	exports['default'] = Input;
	
	
	Input.propTypes = (0, _airbnbPropTypes.forbidExtraProps)(propTypes);
	Input.defaultProps = defaultProps;
	Input.inputTypes = _inputTypes2['default'];
	
	exports.inputTypes = _inputTypes2['default'];
	exports.propTypes = propTypes;

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	var _withStyles = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint jsx-a11y/label-has-for: 1 */
	
	var POSITION_OPTIONS = ['static', 'absolute', 'fixed', 'relative', 'initial', 'inherit'];
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
	  children: _propTypes2['default'].node.isRequired,
	  htmlFor: _propTypes2['default'].string.isRequired,
	  id: _propTypes2['default'].string,
	  inline: _propTypes2['default'].bool,
	  table: _propTypes2['default'].bool,
	  position: _propTypes2['default'].oneOf(POSITION_OPTIONS)
	}));
	
	var defaultProps = {
	  id: undefined,
	  inline: false,
	  table: false,
	  position: undefined
	};
	
	function Label(_ref) {
	  var css = _ref.css,
	      htmlFor = _ref.htmlFor,
	      id = _ref.id,
	      inline = _ref.inline,
	      table = _ref.table,
	      position = _ref.position,
	      children = _ref.children,
	      styles = _ref.styles;
	
	  var labelContent = children;
	
	  if (table) {
	    labelContent = _react2['default'].createElement(
	      'div',
	      css(styles.tableRow),
	      children
	    );
	  }
	
	  return _react2['default'].createElement(
	    'label',
	    _extends({}, css(styles.container, inline && styles.inline, table && styles.table, position && { position: position }), {
	      htmlFor: htmlFor,
	      id: id
	    }),
	    labelContent
	  );
	}
	
	Label.componentCategory = 'Core';
	Label.displayName = 'Label';
	Label.propTypes = propTypes;
	Label.defaultProps = defaultProps;
	
	exports['default'] = (0, _withStyles.withStyles)(function (_ref2) {
	  var color = _ref2.color;
	  return {
	    container: {
	      background: color.clear,
	      border: 0,
	      cursor: 'pointer',
	      display: 'block',
	      padding: 0
	    },
	
	    inline: {
	      display: 'inline-block',
	      whiteSpace: 'nowrap'
	    },
	
	    table: {
	      display: 'table'
	    },
	
	    tableRow: {
	      display: 'table-row'
	    }
	  };
	})(Label);

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	var _lineTypes = __webpack_require__(87);
	
	var _lineTypes2 = _interopRequireDefault(_lineTypes);
	
	var _BaseRow = __webpack_require__(151);
	
	var _BaseRow2 = _interopRequireDefault(_BaseRow);
	
	var _HeadingSection = __webpack_require__(54);
	
	var _HeadingSection2 = _interopRequireDefault(_HeadingSection);
	
	var _Title = __webpack_require__(39);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _textlike = __webpack_require__(24);
	
	var _textlike2 = _interopRequireDefault(_textlike);
	
	var _withStyles = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
	  children: _propTypes2['default'].node,
	  title: _textlike2['default']
	}));
	
	var defaultProps = {
	  title: null
	};
	
	function Panel(_ref) {
	  var css = _ref.css,
	      title = _ref.title,
	      children = _ref.children,
	      styles = _ref.styles;
	
	  return _react2['default'].createElement(
	    'div',
	    css(styles.container),
	    title && _react2['default'].createElement(
	      _HeadingSection2['default'],
	      null,
	      _react2['default'].createElement(
	        _BaseRow2['default'],
	        { baseline: _lineTypes2['default'].NONE },
	        _react2['default'].createElement(
	          _Title2['default'],
	          { level: 2 },
	          title
	        )
	      ),
	      children
	    ),
	    !title && children
	  );
	}
	
	Panel.componentCategory = 'Core';
	Panel.displayName = 'Panel';
	Panel.propTypes = propTypes;
	Panel.defaultProps = defaultProps;
	
	exports['default'] = (0, _withStyles.withStyles)(function (_ref2) {
	  var color = _ref2.color,
	      unit = _ref2.unit;
	  return {
	    container: {
	      paddingLeft: unit * 3,
	      paddingRight: unit * 3,
	      margin: 0,
	      border: '1px solid ' + String(color.panelBorder),
	      backgroundColor: color.white
	    }
	  };
	})(Panel);

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	var _Spacing = __webpack_require__(8);
	
	var _Spacing2 = _interopRequireDefault(_Spacing);
	
	var _withStyles = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
	  hero: _propTypes2['default'].bool,
	  spacing: _propTypes2['default'].number,
	  spacingBottom: _propTypes2['default'].number,
	  spacingTop: _propTypes2['default'].number
	}));
	
	var defaultProps = {
	  hero: false,
	  spacing: 2,
	  spacingBottom: _Spacing.defaultProps.bottom,
	  spacingTop: _Spacing.defaultProps.top
	};
	
	function Rule(_ref) {
	  var css = _ref.css,
	      spacingBottom = _ref.spacingBottom,
	      spacingTop = _ref.spacingTop,
	      spacing = _ref.spacing,
	      hero = _ref.hero,
	      styles = _ref.styles;
	
	  return _react2['default'].createElement(
	    _Spacing2['default'],
	    {
	      bottom: spacingBottom,
	      top: spacingTop,
	      vertical: spacing
	    },
	    _react2['default'].createElement('div', css(styles.rule, hero && styles.hero))
	  );
	}
	
	Rule.componentCategory = 'Core';
	Rule.displayName = 'Rule';
	Rule.propTypes = propTypes;
	Rule.defaultProps = defaultProps;
	
	exports['default'] = (0, _withStyles.withStyles)(function (_ref2) {
	  var unit = _ref2.unit,
	      color = _ref2.color;
	  return {
	    rule: {
	      borderBottom: '1px solid ' + String(color.divider)
	    },
	
	    hero: {
	      width: 6 * unit
	    }
	  };
	}, { pureComponent: true })(Rule);

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	var _withStyles = __webpack_require__(5);
	
	var _textlike = __webpack_require__(24);
	
	var _textlike2 = _interopRequireDefault(_textlike);
	
	var _withBrand = __webpack_require__(76);
	
	var _withBrand2 = _interopRequireDefault(_withBrand);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var FLAGS = ['info', 'danger', 'warning'];
	var flagValidator = _airbnbPropTypes.mutuallyExclusiveTrueProps.apply(undefined, FLAGS);
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
	  children: _textlike2['default'].isRequired,
	  book: _propTypes2['default'].bool,
	  brand: _withBrand.requiredBrandPropType,
	  secondary: _propTypes2['default'].bool
	}, FLAGS.reduce(function (obj, flag) {
	  return Object.assign({}, obj, _defineProperty({}, flag, flagValidator));
	}, {})));
	
	var defaultProps = {
	  children: undefined,
	  info: false,
	  danger: false,
	  warning: false,
	  secondary: false,
	  book: false
	};
	
	function StatusLabel(_ref) {
	  var css = _ref.css,
	      children = _ref.children,
	      styles = _ref.styles,
	      info = _ref.info,
	      danger = _ref.danger,
	      warning = _ref.warning,
	      secondary = _ref.secondary,
	      book = _ref.book,
	      brand = _ref.brand;
	
	  var additionalStyles = Object.assign({}, info && styles.info, danger && styles.danger, warning && styles.warning);
	
	  var isSelectBrand = brand === _withBrand.BRAND_SELECT;
	
	  return _react2['default'].createElement(
	    'div',
	    css(styles.container),
	    (info || danger || warning) && _react2['default'].createElement('div', css(styles.leftColorBar, additionalStyles)),
	    _react2['default'].createElement(
	      'div',
	      css(styles.content, secondary && styles.content_secondary, isSelectBrand && styles.content_select, book && styles.content_book, (info || danger || warning) && styles.content_hasColorBar),
	      children
	    )
	  );
	}
	
	StatusLabel.componentCategory = 'Core';
	StatusLabel.displayName = 'StatusLabel';
	StatusLabel.propTypes = propTypes;
	StatusLabel.defaultProps = defaultProps;
	
	exports['default'] = (0, _withBrand2['default'])((0, _withStyles.withStyles)(function (_ref2) {
	  var unit = _ref2.unit,
	      color = _ref2.color,
	      font = _ref2.font;
	  return {
	    container: {
	      display: 'inline-block',
	      marginRight: 4,
	      verticalAlign: 'middle'
	    },
	
	    content: Object.assign({}, font.textMicro, font.bold, {
	      display: 'table-cell',
	      backgroundColor: color.white,
	      border: '1px solid ' + String(color.accent.lightGray),
	      borderRadius: 2,
	      padding: '3px ' + unit * 0.75 + 'px'
	    }),
	
	    content_secondary: {
	      border: '1px solid ' + String(color.accent.bgGray),
	      backgroundColor: color.accent.bgGray
	    },
	
	    content_select: {
	      color: color.core.hackberry,
	      border: '1px solid ' + String(color.core.hackberry),
	      backgroundColor: color.white
	    },
	
	    content_book: Object.assign({}, font.book),
	
	    content_hasColorBar: {
	      borderLeft: 'none',
	      borderRadius: '0 2px 2px 0'
	    },
	
	    leftColorBar: {
	      display: 'table-cell',
	      borderRadius: '2px 0 0 2px',
	      border: '1px solid ' + String(color.accent.lightGray),
	      borderRight: 'none',
	      height: '100%',
	      width: 0.5 * unit,
	      verticalAlign: 'top'
	    },
	
	    info: {
	      backgroundColor: color.core.babu,
	      border: '1px solid ' + String(color.core.babu)
	    },
	
	    danger: {
	      backgroundColor: color.core.arches,
	      border: '1px solid ' + String(color.core.arches)
	    },
	
	    warning: {
	      backgroundColor: color.accent.beach,
	      border: '1px solid ' + String(color.accent.beach)
	    }
	
	  };
	}, { pureComponent: true })(StatusLabel));

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _airbnbWithTracking = __webpack_require__(62);
	
	var _airbnbWithTracking2 = _interopRequireDefault(_airbnbWithTracking);
	
	var _withStyles = __webpack_require__(5);
	
	var _DOMButtonOrA = __webpack_require__(121);
	
	var _DOMButtonOrA2 = _interopRequireDefault(_DOMButtonOrA);
	
	var _Spacing = __webpack_require__(8);
	
	var _Spacing2 = _interopRequireDefault(_Spacing);
	
	var _StatusLabel = __webpack_require__(144);
	
	var _StatusLabel2 = _interopRequireDefault(_StatusLabel);
	
	var _href = __webpack_require__(123);
	
	var _href2 = _interopRequireDefault(_href);
	
	var _textlike = __webpack_require__(24);
	
	var _textlike2 = _interopRequireDefault(_textlike);
	
	var _removeFirefoxButtonPadding = __webpack_require__(93);
	
	var _removeFirefoxButtonPadding2 = _interopRequireDefault(_removeFirefoxButtonPadding);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ANIMATION_DURATION_MS = 300;
	var TIMING_FUNCTION = 'ease-out';
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
	  label: _textlike2['default'].isRequired,
	  children: (0, _airbnbPropTypes.and)([_propTypes2['default'].node, (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes2['default'].any, 'href', 'children')]),
	  href: (0, _airbnbPropTypes.and)([_href2['default'], (0, _airbnbPropTypes.mutuallyExclusiveProps)(_propTypes2['default'].any, 'href', 'children')]),
	  onPress: _propTypes2['default'].func,
	  selected: _propTypes2['default'].bool,
	  micro: (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('micro', 'small'),
	  muted: _propTypes2['default'].bool,
	  navigationOnly: _propTypes2['default'].bool,
	  small: (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('micro', 'small'),
	  spacedTabs: _propTypes2['default'].bool,
	  statusLabel: function () {
	    function statusLabel(props) {
	      for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        rest[_key - 1] = arguments[_key];
	      }
	
	      if (props.micro && props.statusLabel != null) {
	        return new Error('A Tab cannot use both of these props: micro and statusLabel');
	      }
	      return _textlike2['default'].apply(undefined, [props].concat(rest));
	    }
	
	    return statusLabel;
	  }(),
	  ampVarsClickType: _propTypes2['default'].string,
	  ampReplace: _propTypes2['default'].string,
	  disabled: _propTypes2['default'].bool
	}));
	
	var defaultProps = {
	  children: undefined,
	  href: undefined,
	  onPress: function () {
	    function onPress() {}
	
	    return onPress;
	  }(),
	
	  selected: false,
	  micro: false,
	  muted: false,
	  navigationOnly: false,
	  small: false,
	  spacedTabs: false,
	  statusLabel: null,
	  ampVarsClickType: undefined,
	  ampReplace: undefined,
	  disabled: false
	};
	
	function Tab(_ref) {
	  var css = _ref.css,
	      href = _ref.href,
	      label = _ref.label,
	      micro = _ref.micro,
	      muted = _ref.muted,
	      navigationOnly = _ref.navigationOnly,
	      onPress = _ref.onPress,
	      selected = _ref.selected,
	      small = _ref.small,
	      spacedTabs = _ref.spacedTabs,
	      statusLabel = _ref.statusLabel,
	      styles = _ref.styles,
	      ampVarsClickType = _ref.ampVarsClickType,
	      ampReplace = _ref.ampReplace,
	      disabled = _ref.disabled;
	
	  return _react2['default'].createElement(
	    _DOMButtonOrA2['default'],
	    _extends({}, css(styles.text, styles.tab, micro && styles.tab_micro, muted && styles.text_muted, small && styles.tab_small, spacedTabs && styles.text_spacedTabs, selected && styles.tab_selected, disabled && styles.text_disabled), {
	      href: href,
	      onClick: onPress,
	      onMouseUp: function () {
	        function onMouseUp(e) {
	          // Remove focus ring on buttons after clicking, but not when keyboard
	          // tabbing around.
	          e.currentTarget.blur();
	        }
	
	        return onMouseUp;
	      }(),
	      role: navigationOnly ? null : 'tab',
	      ariaSelected: navigationOnly ? null : selected,
	      ampVarsClickType: ampVarsClickType,
	      ampReplace: ampReplace,
	      disabled: disabled
	    }),
	    label,
	    statusLabel && _react2['default'].createElement(
	      _Spacing2['default'],
	      { left: 1, vertical: -1, inline: true },
	      _react2['default'].createElement(
	        _StatusLabel2['default'],
	        { book: true },
	        statusLabel
	      )
	    )
	  );
	}
	
	Tab.componentCategory = 'Core';
	Tab.displayName = 'Tab';
	Tab.propTypes = propTypes;
	Tab.defaultProps = defaultProps;
	
	exports['default'] = (0, _airbnbWithTracking2['default'])('Tab', ['onPress'])((0, _withStyles.withStyles)(function (_ref2) {
	  var _text_spacedTabs;
	
	  var unit = _ref2.unit,
	      color = _ref2.color,
	      font = _ref2.font,
	      responsive = _ref2.responsive;
	  return {
	    tab: Object.assign({
	      backgroundColor: color.clear,
	      borderRadius: 0,
	      borderWidth: 0,
	      borderBottom: '2px solid ' + String(color.clear),
	      bottom: '-1px',
	      cursor: 'pointer',
	      display: 'inline-block',
	      margin: '0 ' + 4 * unit + 'px 0 0',
	      paddingLeft: 0,
	      paddingRight: 0,
	      paddingTop: 3 * unit,
	      paddingBottom: 3 * unit,
	      textDecoration: 'none',
	      whiteSpace: 'nowrap',
	
	      ':active': {
	        // Remove focus ring while clicking, but not when keyboard tabbing around.
	        outline: 0
	      }
	
	    }, (0, _removeFirefoxButtonPadding2['default'])()),
	
	    text: Object.assign({}, font.textRegular, font.book),
	
	    text_muted: {
	      color: color.textMuted,
	
	      '@media print': {
	        color: color.printOverrides.textMuted
	      }
	    },
	
	    text_disabled: {
	      color: color.textDisabled
	    },
	
	    text_spacedTabs: (_text_spacedTabs = {}, _defineProperty(_text_spacedTabs, responsive.mediumAndAbove, {
	      margin: '0 ' + 3 * unit + 'px 0 0'
	    }), _defineProperty(_text_spacedTabs, responsive.largeAndAbove, {
	      margin: '0 ' + 4 * unit + 'px 0 0'
	    }), _text_spacedTabs),
	
	    tab_selected: {
	      borderBottom: '2px solid ' + String(color.textLink),
	      color: color.textLink,
	      transitionProperty: 'color',
	      transitionDuration: ANIMATION_DURATION_MS + 'ms',
	      transitionTimingFunction: TIMING_FUNCTION
	    },
	
	    tab_micro: Object.assign({}, font.textMicro, font.bold, {
	      color: color.textDark, // This is in sync with <Link navigation>
	      margin: '0 ' + 2 * unit + 'px 0 0',
	      paddingTop: 1.5 * unit,
	      paddingBottom: 1.5 * unit
	    }),
	
	    tab_small: Object.assign({}, font.textSmall, {
	      margin: '0 ' + 3 * unit + 'px 0 0',
	      paddingTop: 2 * unit,
	      paddingBottom: 2 * unit
	    })
	  };
	}, { pureComponent: true })(Tab));

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tab = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	var _shallowElementEquals = __webpack_require__(1605);
	
	var _shallowElementEquals2 = _interopRequireDefault(_shallowElementEquals);
	
	var _index = __webpack_require__(120);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _tab = __webpack_require__(124);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
	  children: _tab2['default'],
	  initialValue: _propTypes2['default'].number,
	  micro: (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('micro', 'small'),
	  // set to true when performing default browser navigation without dynamic tab panel content
	  navigationOnly: _propTypes2['default'].bool,
	
	  onPressTab: _propTypes2['default'].func,
	  scrollable: _propTypes2['default'].bool,
	  small: (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('micro', 'small')
	});
	
	var defaultProps = {
	  initialValue: 0,
	  micro: false,
	  navigationOnly: false,
	  onPressTab: null,
	  scrollable: false,
	  small: false
	};
	
	/**
	 * TabsController is an uncontrolled component for a tab interface.
	 * You should use this if you want the tabs to just work out of the box.
	
	 * For the controlled component equivalent, where you have full
	 * control over the component state, use Tabs.
	 */
	
	var TabsController = function (_React$Component) {
	  _inherits(TabsController, _React$Component);
	
	  function TabsController(props) {
	    _classCallCheck(this, TabsController);
	
	    var _this = _possibleConstructorReturn(this, (TabsController.__proto__ || Object.getPrototypeOf(TabsController)).call(this, props));
	
	    _this.state = {
	      value: props.initialValue < _react2['default'].Children.count(props.children) ? props.initialValue : defaultProps.initialValue
	    };
	
	    _this.onPressTab = _this.onPressTab.bind(_this);
	    return _this;
	  }
	
	  _createClass(TabsController, [{
	    key: 'shouldComponentUpdate',
	    value: function () {
	      function shouldComponentUpdate(nextProps, nextState) {
	        var currentTabIndex = this.state.value;
	        var nextTabIndex = nextState.value;
	        var currentTab = this.props.children[currentTabIndex];
	        var nextTab = nextProps.children[nextTabIndex];
	        return currentTabIndex !== nextTabIndex || !(0, _shallowElementEquals2['default'])(currentTab.props, nextTab.props);
	      }
	
	      return shouldComponentUpdate;
	    }()
	  }, {
	    key: 'onPressTab',
	    value: function () {
	      function onPressTab(tabIndex, e) {
	        this.setState({
	          value: tabIndex
	        });
	
	        if (this.props.onPressTab) {
	          this.props.onPressTab(tabIndex, e);
	        }
	      }
	
	      return onPressTab;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        return _react2['default'].createElement(
	          _index2['default'],
	          {
	            navigationOnly: this.props.navigationOnly,
	            onPressTab: this.onPressTab,
	            scrollable: this.props.scrollable,
	            value: this.state.value,
	            small: this.props.small,
	            micro: this.props.micro
	          },
	          this.props.children
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return TabsController;
	}(_react2['default'].Component);
	
	TabsController.componentCategory = 'Core';
	TabsController.displayName = 'TabsController';
	exports['default'] = TabsController;
	
	
	TabsController.propTypes = propTypes;
	TabsController.defaultProps = defaultProps;
	TabsController.Tab = _index.Tab;
	
	exports.Tab = _index.Tab;

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Tab = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	var _airbnbWithTracking = __webpack_require__(62);
	
	var _airbnbWithTracking2 = _interopRequireDefault(_airbnbWithTracking);
	
	var _Tab = __webpack_require__(145);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _HorizontalScroll = __webpack_require__(152);
	
	var _HorizontalScroll2 = _interopRequireDefault(_HorizontalScroll);
	
	var _withStyles = __webpack_require__(5);
	
	var _tab = __webpack_require__(124);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
	
	  children: _tab2['default'],
	  onPressTab: _propTypes2['default'].func,
	  micro: (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('micro', 'small'),
	  muted: _propTypes2['default'].bool,
	
	  // set to true when performing default browser navigation without dynamic tab panel content
	  navigationOnly: _propTypes2['default'].bool,
	
	  scrollable: _propTypes2['default'].bool,
	  small: (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('micro', 'small'),
	  spacedTabs: _propTypes2['default'].bool,
	  value: _propTypes2['default'].number
	}));
	
	var defaultProps = {
	  children: undefined,
	  onPressTab: function () {
	    function onPressTab() {}
	
	    return onPressTab;
	  }(),
	
	  micro: false,
	  muted: false,
	  navigationOnly: false,
	  scrollable: false,
	  small: false,
	  spacedTabs: false,
	  value: 0
	};
	
	/**
	 * Tabs is a controlled component for a tab interface.
	 * You should use this if you want to have full control
	 * over the state of the component.
	
	 * For the uncontrolled component equivalent, where it
	 * just works out of the box, use TabsController.
	 */
	function Tabs(_ref) {
	  var css = _ref.css,
	      children = _ref.children,
	      value = _ref.value,
	      onPressTab = _ref.onPressTab,
	      micro = _ref.micro,
	      muted = _ref.muted,
	      navigationOnly = _ref.navigationOnly,
	      small = _ref.small,
	      spacedTabs = _ref.spacedTabs,
	      scrollable = _ref.scrollable,
	      styles = _ref.styles;
	
	  var chevronSize = small || micro ? 14 : 16;
	  var tabs = _react2['default'].Children.map(children, function (tab, i) {
	    return tab && _react2['default'].cloneElement(tab, {
	      selected: value === i,
	      onPress: function () {
	        function onPress(e) {
	          onPressTab(i, e);
	        }
	
	        return onPress;
	      }(),
	
	      micro: micro,
	      muted: muted,
	      navigationOnly: navigationOnly,
	      small: small,
	      spacedTabs: spacedTabs
	    });
	  });
	  var tabsSection = tabs;
	  if (scrollable) {
	    tabsSection = _react2['default'].createElement(
	      _HorizontalScroll2['default'],
	      { chevronSize: chevronSize },
	      tabs
	    );
	  }
	
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      'div',
	      _extends({
	        role: navigationOnly ? null : 'tablist'
	      }, css(styles.tabs, micro && styles.tabs_micro)),
	      tabsSection
	    ),
	    _react2['default'].createElement(
	      'div',
	      null,
	      _react2['default'].Children.map(children, function (tab, i) {
	        if (tab && tab.props.children) {
	          return _react2['default'].createElement(
	            'div',
	            _extends({
	              role: 'tabpanel'
	            }, css(i === value ? styles.show : styles.hide)),
	            tab.props.children
	          );
	        }
	
	        return null;
	      })
	    )
	  );
	}
	
	Tabs.componentCategory = 'Core';
	Tabs.displayName = 'Tabs';
	Tabs.propTypes = propTypes;
	Tabs.defaultProps = defaultProps;
	Tabs.Tab = _Tab2['default'];
	
	exports['default'] = (0, _airbnbWithTracking2['default'])('Tabs', ['onPressTab'])((0, _withStyles.withStyles)(function (_ref2) {
	  var color = _ref2.color;
	  return {
	    tabs: {
	      borderBottom: '1px solid ' + String(color.accent.hrGray),
	      position: 'relative'
	    },
	
	    tabs_micro: {
	      borderBottom: 'none'
	    },
	
	    hide: {
	      display: 'none'
	    },
	
	    show: {
	      display: 'block'
	    }
	  };
	})(Tabs));
	exports.Tab = _Tab2['default'];

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	var _withStyles = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var alignmentProps = ['top', 'middle', 'bottom'];
	
	var topMiddleOrBottom = (0, _airbnbPropTypes.and)([_airbnbPropTypes.booleanSome.apply(undefined, alignmentProps), _airbnbPropTypes.mutuallyExclusiveTrueProps.apply(undefined, alignmentProps)]);
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
	  children: _propTypes2['default'].node.isRequired,
	  top: topMiddleOrBottom,
	  middle: topMiddleOrBottom,
	  bottom: topMiddleOrBottom
	}));
	
	var defaultProps = {
	  top: false,
	  middle: false,
	  bottom: false
	};
	
	function VerticalAlign(_ref) {
	  var css = _ref.css,
	      children = _ref.children,
	      styles = _ref.styles,
	      top = _ref.top,
	      middle = _ref.middle,
	      bottom = _ref.bottom;
	
	  return _react2['default'].createElement(
	    'div',
	    css(styles.container, top && styles.top, middle && styles.middle, bottom && styles.bottom),
	    children
	  );
	}
	
	VerticalAlign.componentCategory = 'Core';
	VerticalAlign.displayName = 'VerticalAlign';
	VerticalAlign.propTypes = propTypes;
	VerticalAlign.defaultProps = defaultProps;
	
	exports['default'] = (0, _withStyles.withStyles)(function () {
	  return {
	    container: {
	      display: 'table-cell'
	    },
	
	    top: {
	      verticalAlign: 'top'
	    },
	
	    middle: {
	      verticalAlign: 'middle'
	    },
	
	    bottom: {
	      verticalAlign: 'bottom'
	    }
	  };
	})(VerticalAlign);

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VerticalAlign = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	var _VerticalAlign = __webpack_require__(146);
	
	var _VerticalAlign2 = _interopRequireDefault(_VerticalAlign);
	
	var _withStyles = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
	  children: (0, _airbnbPropTypes.childrenOfType)(_VerticalAlign2['default']),
	  fillVertical: _propTypes2['default'].bool,
	  fillHorizontal: _propTypes2['default'].bool
	}));
	
	var defaultProps = {
	  fillVertical: false,
	  fillHorizontal: false
	};
	
	function VerticalAlignmentContainer(_ref) {
	  var css = _ref.css,
	      children = _ref.children,
	      styles = _ref.styles,
	      fillVertical = _ref.fillVertical,
	      fillHorizontal = _ref.fillHorizontal;
	
	  return _react2['default'].createElement(
	    'div',
	    css(styles.container, fillVertical && styles.fillVertical, fillHorizontal && styles.fillHorizontal),
	    children
	  );
	}
	
	VerticalAlignmentContainer.componentCategory = 'Core';
	VerticalAlignmentContainer.displayName = 'VerticalAlignmentContainer';
	VerticalAlignmentContainer.propTypes = propTypes;
	VerticalAlignmentContainer.defaultProps = defaultProps;
	
	exports['default'] = (0, _withStyles.withStyles)(function () {
	  return {
	    container: {
	      display: 'table',
	      position: 'relative'
	    },
	
	    fillVertical: {
	      height: '100%'
	    },
	
	    fillHorizontal: {
	      width: '100%'
	    }
	  };
	})(VerticalAlignmentContainer);
	exports.VerticalAlign = _VerticalAlign2['default'];

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _iconCategories = __webpack_require__(17);
	
	var _makeIconWithDirectionMirroring = __webpack_require__(61);
	
	var _makeIconWithDirectionMirroring2 = _interopRequireDefault(_makeIconWithDirectionMirroring);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ChevronRightSvg = function () {
	  function ChevronRightSvg(props) {
	    return _react2['default'].createElement(
	      'svg',
	      props,
	      _react2['default'].createElement('path', {
	        d: 'm4.29 1.71a1 1 0 1 1 1.42-1.41l8 8a1 1 0 0 1 0 1.41l-8 8a1 1 0 1 1 -1.42-1.41l7.29-7.29z',
	        fillRule: 'evenodd'
	      })
	    );
	  }
	
	  return ChevronRightSvg;
	}();
	
	ChevronRightSvg.componentCategory = 'Core';
	ChevronRightSvg.displayName = 'ChevronRightSvg';
	ChevronRightSvg.defaultProps = {
	  viewBox: '0 0 18 18'
	};
	
	
	var IconChevronNext = (0, _makeIconWithDirectionMirroring2['default'])(ChevronRightSvg, 'IconChevronNext');
	exports['default'] = IconChevronNext;
	
	
	if (false) {
	  IconChevronNext.categories = [_iconCategories.DIRECTIONS];
	}

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _iconCategories = __webpack_require__(17);
	
	var _makeIconWithDirectionMirroring = __webpack_require__(61);
	
	var _makeIconWithDirectionMirroring2 = _interopRequireDefault(_makeIconWithDirectionMirroring);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ChevronLeftSvg = function () {
	  function ChevronLeftSvg(props) {
	    return _react2['default'].createElement(
	      'svg',
	      props,
	      _react2['default'].createElement('path', {
	        d: 'm13.7 16.29a1 1 0 1 1 -1.42 1.41l-8-8a1 1 0 0 1 0-1.41l8-8a1 1 0 1 1 1.42 1.41l-7.29 7.29z',
	        fillRule: 'evenodd'
	      })
	    );
	  }
	
	  return ChevronLeftSvg;
	}();
	
	ChevronLeftSvg.componentCategory = 'Core';
	ChevronLeftSvg.displayName = 'ChevronLeftSvg';
	ChevronLeftSvg.defaultProps = {
	  viewBox: '0 0 18 18'
	};
	
	
	var IconChevronPrevious = (0, _makeIconWithDirectionMirroring2['default'])(ChevronLeftSvg, 'IconChevronPrevious');
	exports['default'] = IconChevronPrevious;
	
	
	if (false) {
	  IconChevronPrevious.categories = [_iconCategories.DIRECTIONS];
	}

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _makeIcon = __webpack_require__(22);
	
	var _makeIcon2 = _interopRequireDefault(_makeIcon);
	
	var _iconCategories = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CloseSvg = function () {
	  function CloseSvg(props) {
	    return _react2['default'].createElement(
	      'svg',
	      props,
	      _react2['default'].createElement('path', {
	        d: 'm23.25 24c-.19 0-.38-.07-.53-.22l-10.72-10.72-10.72 10.72c-.29.29-.77.29-1.06 0s-.29-.77 0-1.06l10.72-10.72-10.72-10.72c-.29-.29-.29-.77 0-1.06s.77-.29 1.06 0l10.72 10.72 10.72-10.72c.29-.29.77-.29 1.06 0s .29.77 0 1.06l-10.72 10.72 10.72 10.72c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22',
	        fillRule: 'evenodd'
	      })
	    );
	  }
	
	  return CloseSvg;
	}();
	
	CloseSvg.componentCategory = 'Core';
	CloseSvg.displayName = 'CloseSvg';
	CloseSvg.defaultProps = {
	  viewBox: '0 0 24 24'
	};
	
	
	var IconClose = (0, _makeIcon2['default'])(CloseSvg, 'IconClose');
	exports['default'] = IconClose;
	
	
	if (false) {
	  IconClose.categories = [_iconCategories.MISCELLANEOUS];
	}

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _animated = __webpack_require__(95);
	
	var _animated2 = _interopRequireDefault(_animated);
	
	var _ScrollContainer = __webpack_require__(154);
	
	var _ScrollContainer2 = _interopRequireDefault(_ScrollContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// the difference between this component and the pure `ScrollContainer` is that
	// this component can understand an Animated.Value as a prop type, e.g. for `scrollLeft`
	exports['default'] = _animated2['default'].createAnimatedComponent(_ScrollContainer2['default']);

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.rowDefaultProps = exports.rowPropTypes = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	var _withStyles = __webpack_require__(5);
	
	var _lineTypes = __webpack_require__(87);
	
	var _lineTypes2 = _interopRequireDefault(_lineTypes);
	
	var _adjustableSpacing = __webpack_require__(119);
	
	var _adjustableSpacing2 = _interopRequireDefault(_adjustableSpacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var rowPropTypes = exports.rowPropTypes = {
	  baseline: _lineTypes.lineTypePropType,
	  topline: _lineTypes.lineTypePropType,
	
	  top: _adjustableSpacing.adjustableSpacingShape,
	  topMediumAndAbove: _adjustableSpacing.adjustableSpacingShape,
	  topLargeAndAbove: _adjustableSpacing.adjustableSpacingShape,
	  bottom: _adjustableSpacing.adjustableSpacingShape,
	  bottomMediumAndAbove: _adjustableSpacing.adjustableSpacingShape,
	  bottomLargeAndAbove: _adjustableSpacing.adjustableSpacingShape,
	  vertical: _adjustableSpacing.adjustableSpacingShape,
	  verticalMediumAndAbove: _adjustableSpacing.adjustableSpacingShape,
	  verticalLargeAndAbove: _adjustableSpacing.adjustableSpacingShape
	};
	
	var rowDefaultProps = exports.rowDefaultProps = {
	  baseline: _lineTypes2['default'].NONE,
	  topline: _lineTypes2['default'].NONE,
	
	  top: null,
	  topMediumAndAbove: null,
	  topLargeAndAbove: null,
	  bottom: null,
	  bottomMediumAndAbove: null,
	  bottomLargeAndAbove: null,
	  vertical: _adjustableSpacing2['default'].NORMAL,
	  verticalMediumAndAbove: null,
	  verticalLargeAndAbove: null
	};
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, rowPropTypes, {
	  children: _propTypes2['default'].node
	}));
	
	var defaultProps = Object.assign({}, rowDefaultProps);
	
	function getSpacingStyleName(spacingType, spacingValue) {
	  return (String(spacingType) + '-' + String(spacingValue)).replace('.', '_');
	}
	
	function BaseRow(_ref) {
	  var css = _ref.css,
	      baseline = _ref.baseline,
	      children = _ref.children,
	      styles = _ref.styles,
	      topline = _ref.topline,
	      top = _ref.top,
	      topMediumAndAbove = _ref.topMediumAndAbove,
	      topLargeAndAbove = _ref.topLargeAndAbove,
	      bottom = _ref.bottom,
	      bottomMediumAndAbove = _ref.bottomMediumAndAbove,
	      bottomLargeAndAbove = _ref.bottomLargeAndAbove,
	      vertical = _ref.vertical,
	      verticalMediumAndAbove = _ref.verticalMediumAndAbove,
	      verticalLargeAndAbove = _ref.verticalLargeAndAbove;
	
	  return _react2['default'].createElement(
	    'div',
	    css(baseline === _lineTypes2['default'].FULL && styles.baseline_full, baseline === _lineTypes2['default'].NONE && styles.baseline_none, topline === _lineTypes2['default'].FULL && styles.topline_full, vertical != null && styles[getSpacingStyleName('vertical', vertical)], verticalMediumAndAbove != null && styles[getSpacingStyleName('verticalMediumAndAbove', verticalMediumAndAbove)], verticalLargeAndAbove != null && styles[getSpacingStyleName('verticalLargeAndAbove', verticalLargeAndAbove)], top != null && styles[getSpacingStyleName('top', top)], topMediumAndAbove != null && styles[getSpacingStyleName('topMediumAndAbove', topMediumAndAbove)], topLargeAndAbove != null && styles[getSpacingStyleName('topLargeAndAbove', topLargeAndAbove)], bottom != null && styles[getSpacingStyleName('bottom', bottom)], bottomMediumAndAbove != null && styles[getSpacingStyleName('bottomMediumAndAbove', bottomMediumAndAbove)], bottomLargeAndAbove != null && styles[getSpacingStyleName('bottomLargeAndAbove', bottomLargeAndAbove)]),
	    children
	  );
	}
	
	BaseRow.componentCategory = 'Private';
	BaseRow.displayName = 'BaseRow';
	BaseRow.defaultProps = defaultProps;
	BaseRow.propTypes = propTypes;
	
	exports['default'] = (0, _withStyles.withStyles)(function (_ref2) {
	  var color = _ref2.color,
	      responsive = _ref2.responsive,
	      unit = _ref2.unit;
	
	  var responsiveUnits = [0, 0.5, 1, 1.5, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
	
	  var paddingStyles = {};
	
	  responsiveUnits.forEach(function (size) {
	    var sizeString = ('' + String(size)).replace('.', '_');
	    paddingStyles['top-' + String(sizeString)] = {
	      paddingTop: size * unit
	    };
	    paddingStyles['topMediumAndAbove-' + String(sizeString)] = _defineProperty({}, responsive.mediumAndAbove, {
	      paddingTop: size * unit
	    });
	    paddingStyles['topLargeAndAbove-' + String(sizeString)] = _defineProperty({}, responsive.largeAndAbove, {
	      paddingTop: size * unit
	    });
	    paddingStyles['bottom-' + String(sizeString)] = {
	      paddingBottom: size * unit
	    };
	    paddingStyles['bottomMediumAndAbove-' + String(sizeString)] = _defineProperty({}, responsive.mediumAndAbove, {
	      paddingBottom: size * unit
	    });
	    paddingStyles['bottomLargeAndAbove-' + String(sizeString)] = _defineProperty({}, responsive.largeAndAbove, {
	      paddingBottom: size * unit
	    });
	    paddingStyles['vertical-' + String(sizeString)] = {
	      paddingTop: size * unit,
	      paddingBottom: size * unit
	    };
	    paddingStyles['verticalMediumAndAbove-' + String(sizeString)] = _defineProperty({}, responsive.mediumAndAbove, {
	      paddingTop: size * unit,
	      paddingBottom: size * unit
	    });
	    paddingStyles['verticalLargeAndAbove-' + String(sizeString)] = _defineProperty({}, responsive.largeAndAbove, {
	      paddingTop: size * unit,
	      paddingBottom: size * unit
	    });
	  });
	
	  return Object.assign({
	    baseline_full: {
	      borderBottom: '1px solid ' + String(color.divider)
	    },
	
	    baseline_none: {
	      borderBottom: 0
	    },
	
	    topline_full: {
	      borderTop: '1px solid ' + String(color.divider)
	    }
	
	  }, paddingStyles);
	})(BaseRow);

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultProps = exports.propTypes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	var _ErrorMessage = __webpack_require__(408);
	
	var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);
	
	var _Label = __webpack_require__(411);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Link = __webpack_require__(74);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Text = __webpack_require__(16);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Spacing = __webpack_require__(8);
	
	var _Spacing2 = _interopRequireDefault(_Spacing);
	
	var _mutuallyExclusiveRequired = __webpack_require__(256);
	
	var _mutuallyExclusiveRequired2 = _interopRequireDefault(_mutuallyExclusiveRequired);
	
	var _textlike = __webpack_require__(24);
	
	var _textlike2 = _interopRequireDefault(_textlike);
	
	var _componentWithNamesOfHOCs = __webpack_require__(92);
	
	var _componentWithNamesOfHOCs2 = _interopRequireDefault(_componentWithNamesOfHOCs);
	
	var _idProp = __webpack_require__(40);
	
	var _idProp2 = _interopRequireDefault(_idProp);
	
	var _visuallyHidden = __webpack_require__(159);
	
	var _visuallyHidden2 = _interopRequireDefault(_visuallyHidden);
	
	var _withStyles = __webpack_require__(5);
	
	var _mutuallyInclusive = __webpack_require__(448);
	
	var _mutuallyInclusive2 = _interopRequireDefault(_mutuallyInclusive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var exportedPropTypes = Object.assign({
	  actionLink: (0, _componentWithNamesOfHOCs2['default'])(_Link2['default']),
	  errorMessage: _textlike2['default'],
	  hideLabel: _propTypes2['default'].bool,
	  id: _idProp2['default'].isRequired,
	  inline: _propTypes2['default'].bool,
	  invalid: _propTypes2['default'].bool
	}, (0, _mutuallyExclusiveRequired2['default'])({
	  label: _textlike2['default'],
	  hasExternalLabel: _propTypes2['default'].bool
	}), {
	  inverse: _propTypes2['default'].bool,
	  labelDescription: _textlike2['default'],
	  lightLabel: _propTypes2['default'].bool,
	  small: _propTypes2['default'].bool,
	  large: _propTypes2['default'].bool
	});
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, exportedPropTypes, (0, _mutuallyInclusive2['default'])({
	  errorMessage: _textlike2['default'],
	  errorMessageID: _idProp2['default']
	}), {
	  children: _propTypes2['default'].node
	}));
	
	var defaultProps = {
	  actionLink: null,
	  errorMessage: null,
	  hideLabel: false,
	  inline: false,
	  invalid: false,
	  inverse: false,
	  labelDescription: '',
	  lightLabel: false, // design should follow up on if we want to keep this override ability
	  small: false,
	  large: false
	};
	
	function FormElement(_ref) {
	  var css = _ref.css,
	      actionLink = _ref.actionLink,
	      children = _ref.children,
	      hideLabel = _ref.hideLabel,
	      errorMessage = _ref.errorMessage,
	      errorMessageID = _ref.errorMessageID,
	      id = _ref.id,
	      inline = _ref.inline,
	      invalid = _ref.invalid,
	      inverse = _ref.inverse,
	      label = _ref.label,
	      labelDescription = _ref.labelDescription,
	      hasExternalLabel = _ref.hasExternalLabel,
	      lightLabel = _ref.lightLabel,
	      small = _ref.small,
	      large = _ref.large,
	      styles = _ref.styles;
	
	  var showErrorMessage = errorMessage && invalid;
	
	  return _react2['default'].createElement(
	    'div',
	    css(styles.container, !inline && styles.block),
	    !hasExternalLabel && !hideLabel && _react2['default'].createElement(
	      _Spacing2['default'],
	      { bottom: 1 },
	      _react2['default'].createElement(
	        _Label2['default'],
	        { htmlFor: id },
	        _react2['default'].createElement(
	          _Text2['default'],
	          { large: large, small: small, light: lightLabel && !small, inverse: inverse },
	          label
	        )
	      ),
	      (labelDescription || actionLink) && _react2['default'].createElement(
	        _Text2['default'],
	        {
	          small: !small && !large,
	          micro: small,
	          light: true,
	          inverse: inverse,
	          inline: small
	        },
	        labelDescription,
	        labelDescription && actionLink && ' ',
	        actionLink
	      )
	    ),
	    !hasExternalLabel && hideLabel && // eslint-disable-next-line jsx-a11y/label-has-for
	    _react2['default'].createElement(
	      'label',
	      _extends({}, css(styles.label_hidden), { htmlFor: id }),
	      label
	    ),
	    children,
	    showErrorMessage && _react2['default'].createElement(
	      _ErrorMessage2['default'],
	      { id: errorMessageID, small: small },
	      errorMessage
	    )
	  );
	}
	
	FormElement.componentCategory = 'Private';
	FormElement.displayName = 'FormElement';
	FormElement.propTypes = propTypes;
	
	FormElement.defaultProps = Object.assign({}, defaultProps, {
	  children: null
	});
	
	exports['default'] = (0, _withStyles.withStyles)(function () {
	  return {
	    container: {
	      display: 'inline-block'
	    },
	
	    block: {
	      display: 'block',
	      width: '100%'
	    },
	
	    label_hidden: Object.assign({}, _visuallyHidden2['default'])
	  };
	})(FormElement);
	exports.propTypes = exportedPropTypes;
	exports.defaultProps = defaultProps;

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.propTypes = exports.inputTypes = exports.defaultProps = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	var _airbnbI18n = __webpack_require__(160);
	
	var _airbnbI18n2 = _interopRequireDefault(_airbnbI18n);
	
	var _AutoDirectionProvider = __webpack_require__(1574);
	
	var _AutoDirectionProvider2 = _interopRequireDefault(_AutoDirectionProvider);
	
	var _accessibilityLabel = __webpack_require__(122);
	
	var _accessibilityLabel2 = _interopRequireDefault(_accessibilityLabel);
	
	var _autoCompleteTypes = __webpack_require__(404);
	
	var _autoCompleteTypes2 = _interopRequireDefault(_autoCompleteTypes);
	
	var _idProp = __webpack_require__(40);
	
	var _idProp2 = _interopRequireDefault(_idProp);
	
	var _inputTypes = __webpack_require__(241);
	
	var _inputTypes2 = _interopRequireDefault(_inputTypes);
	
	var _placeholderStyle = __webpack_require__(445);
	
	var _placeholderStyle2 = _interopRequireDefault(_placeholderStyle);
	
	var _visuallyHidden = __webpack_require__(159);
	
	var _visuallyHidden2 = _interopRequireDefault(_visuallyHidden);
	
	var _IconClose = __webpack_require__(421);
	
	var _IconClose2 = _interopRequireDefault(_IconClose);
	
	var _withStyles = __webpack_require__(5);
	
	var _withBrand = __webpack_require__(76);
	
	var _withBrand2 = _interopRequireDefault(_withBrand);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  ampVarsInputName: _propTypes2['default'].string,
	  autoCapitalize: _propTypes2['default'].oneOf(['none', 'sentences', 'words', 'characters']),
	  autoComplete: (0, _airbnbPropTypes.or)([_propTypes2['default'].oneOf(['on', 'off']), _propTypes2['default'].arrayOf((0, _airbnbPropTypes.or)([_propTypes2['default'].oneOf(_autoCompleteTypes2['default']), (0, _airbnbPropTypes.stringStartsWith)('section-')], 'list of (valid categories or section-*)'))], 'on/off, or list of (valid categories or section-*)'),
	  autoCorrect: _propTypes2['default'].bool,
	  autoFocus: _propTypes2['default'].bool,
	  book: _propTypes2['default'].bool,
	  borderless: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  errorMessageID: _idProp2['default'],
	  focusBorderless: _propTypes2['default'].bool,
	  inputRef: _propTypes2['default'].func,
	  invalid: _propTypes2['default'].bool,
	  inverse: _propTypes2['default'].bool,
	  large: _propTypes2['default'].bool,
	  maxLength: (0, _airbnbPropTypes.integer)(),
	  id: _propTypes2['default'].string.isRequired,
	  inline: _propTypes2['default'].bool,
	  name: _propTypes2['default'].string.isRequired,
	  onBlur: _propTypes2['default'].func,
	  onChange: _propTypes2['default'].func,
	  onClear: _propTypes2['default'].func,
	  onFocus: _propTypes2['default'].func,
	  onKeyDown: _propTypes2['default'].func,
	  placeholder: _accessibilityLabel2['default'],
	  prefix: _propTypes2['default'].node,
	  readOnly: _propTypes2['default'].bool,
	  refForFocus: _propTypes2['default'].func,
	  removeMargins: _propTypes2['default'].bool,
	  role: _propTypes2['default'].string,
	  showFakeValuePlaceholder: _propTypes2['default'].bool,
	  showOverflowEllipsis: _propTypes2['default'].bool,
	  small: _propTypes2['default'].bool,
	  spellCheck: _propTypes2['default'].bool,
	  suffix: _propTypes2['default'].node,
	  suffixText: _propTypes2['default'].node,
	  type: _propTypes2['default'].oneOf(Object.values(_inputTypes2['default'])),
	  underlineFocus: _propTypes2['default'].bool,
	  value: _propTypes2['default'].string,
	  velouteId: _propTypes2['default'].string,
	  // a11y
	  'aria-owns': _propTypes2['default'].string
	};
	
	var finalPropTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, propTypes, {
	  brand: _withBrand.requiredBrandPropType
	}));
	
	var defaultProps = exports.defaultProps = {
	  ampVarsInputName: undefined,
	  autoCapitalize: null,
	  autoComplete: null,
	  autoCorrect: null,
	  autoFocus: false,
	  book: false,
	  borderless: false,
	  disabled: false,
	  errorMessageID: undefined,
	  focusBorderless: false,
	  inputRef: function () {
	    function inputRef() {}
	
	    return inputRef;
	  }(),
	
	  invalid: false,
	  inverse: false,
	  inline: false,
	  large: false,
	  maxLength: null,
	  onBlur: function () {
	    function onBlur() {}
	
	    return onBlur;
	  }(),
	  onChange: function () {
	    function onChange() {}
	
	    return onChange;
	  }(),
	
	  onClear: null,
	  onFocus: function () {
	    function onFocus() {}
	
	    return onFocus;
	  }(),
	  onKeyDown: function () {
	    function onKeyDown() {}
	
	    return onKeyDown;
	  }(),
	
	  prefix: null,
	  readOnly: false,
	  refForFocus: function () {
	    function refForFocus() {}
	
	    return refForFocus;
	  }(),
	
	  removeMargins: false,
	  showFakeValuePlaceholder: false,
	  showOverflowEllipsis: false,
	  small: false,
	  spellCheck: null,
	  suffix: null,
	  suffixText: null,
	  type: _inputTypes2['default'].TEXT,
	  underlineFocus: false,
	  value: '',
	  velouteId: undefined
	};
	
	var InputOnly = function (_React$Component) {
	  _inherits(InputOnly, _React$Component);
	
	  function InputOnly(props) {
	    _classCallCheck(this, InputOnly);
	
	    var _this = _possibleConstructorReturn(this, (InputOnly.__proto__ || Object.getPrototypeOf(InputOnly)).call(this, props));
	
	    _this.state = {
	      isFocused: false,
	      measuredContentWidth: -1
	    };
	
	    _this.onBlur = _this.onBlur.bind(_this);
	    _this.onFocus = _this.onFocus.bind(_this);
	    _this.onClear = _this.onClear.bind(_this);
	    _this.prepareToClear = _this.prepareToClear.bind(_this);
	    _this.onInputBlur = _this.onInputBlur.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.setInputRef = _this.setInputRef.bind(_this);
	
	    _this.isGoingToClear = false;
	    return _this;
	  }
	
	  _createClass(InputOnly, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        var _this2 = this;
	
	        var suffixText = this.props.suffixText;
	
	        if (suffixText) {
	          this.updateMeasuredContentWidth();
	          this.updateMeasuredContentTimeout = setTimeout(function () {
	            _this2.updateMeasuredContentWidth();
	          }, 0);
	        }
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var _props = this.props,
	            suffixText = _props.suffixText,
	            value = _props.value;
	
	        if (suffixText && prevProps.value !== value) {
	          this.updateMeasuredContentWidth();
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        clearTimeout(this.updateMeasuredContentTimeout);
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: 'onBlur',
	    value: function () {
	      function onBlur() {
	        this.setState({
	          isFocused: false
	        });
	      }
	
	      return onBlur;
	    }()
	  }, {
	    key: 'onFocus',
	    value: function () {
	      function onFocus() {
	        this.setState({
	          isFocused: true
	        });
	      }
	
	      return onFocus;
	    }()
	  }, {
	    key: 'onClear',
	    value: function () {
	      function onClear(e) {
	        var onClear = this.props.onClear;
	
	        this.inputRef.focus();
	        onClear(e);
	      }
	
	      return onClear;
	    }()
	  }, {
	    key: 'onInputBlur',
	    value: function () {
	      function onInputBlur(e) {
	        var onBlur = this.props.onBlur;
	
	        onBlur(e);
	        if (this.isGoingToClear) {
	          // we call stopPropagation to prevent the onBlur event bubbling up
	          //  This prevents the onBlur on the div wrapper to fire
	          //  allowing onMouseUp and onClick to work on Safari and Firefox
	          e.stopPropagation();
	          this.isGoingToClear = false;
	        }
	      }
	
	      return onInputBlur;
	    }()
	  }, {
	    key: 'onInputChange',
	    value: function () {
	      function onInputChange(e) {
	        var onChange = this.props.onChange;
	
	        onChange(e.target.value);
	      }
	
	      return onInputChange;
	    }()
	  }, {
	    key: 'setInputRef',
	    value: function () {
	      function setInputRef(ref) {
	        this.inputRef = ref;
	
	        var _props2 = this.props,
	            inputRef = _props2.inputRef,
	            refForFocus = _props2.refForFocus;
	
	        inputRef(ref);
	        refForFocus(ref);
	      }
	
	      return setInputRef;
	    }()
	  }, {
	    key: 'prepareToClear',
	    value: function () {
	      function prepareToClear() {
	        // In some browsers, clicking on a button won't trigger a focus event.
	        // This makes it so that when the user tries to click on the clear button,
	        // it blurs the input and hides the clear button before the click event can continue.
	        // To avoid that problem, we're tracking whether the user intends to clear the input
	        //  so that we can avoid hiding the clear button before the click event fires.
	        this.isGoingToClear = true;
	      }
	
	      return prepareToClear;
	    }()
	
	    // Measures width of Input's content to position suffixText correctly
	
	  }, {
	    key: 'updateMeasuredContentWidth',
	    value: function () {
	      function updateMeasuredContentWidth() {
	        if (this.contentMeasurer) {
	          var contentWidth = this.contentMeasurer.getBoundingClientRect().width;
	          this.setState({
	            measuredContentWidth: contentWidth
	          });
	        }
	      }
	
	      return updateMeasuredContentWidth;
	    }()
	  }, {
	    key: 'suffixTextStyles',
	    value: function () {
	      function suffixTextStyles() {
	        var measuredContentWidth = this.state.measuredContentWidth;
	
	        return {
	          left: measuredContentWidth,
	          // suffixText should be hidden unless content measurement is performed
	          visibility: measuredContentWidth >= 0 ? 'visible' : 'hidden'
	        };
	      }
	
	      return suffixTextStyles;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this3 = this;
	
	        var _props3 = this.props,
	            css = _props3.css,
	            ampVarsInputName = _props3.ampVarsInputName,
	            ariaOwns = _props3['aria-owns'],
	            autoCapitalize = _props3.autoCapitalize,
	            autoComplete = _props3.autoComplete,
	            autoCorrect = _props3.autoCorrect,
	            autoFocus = _props3.autoFocus,
	            book = _props3.book,
	            borderless = _props3.borderless,
	            brand = _props3.brand,
	            disabled = _props3.disabled,
	            errorMessageID = _props3.errorMessageID,
	            focusBorderless = _props3.focusBorderless,
	            id = _props3.id,
	            inline = _props3.inline,
	            invalid = _props3.invalid,
	            inverse = _props3.inverse,
	            large = _props3.large,
	            maxLength = _props3.maxLength,
	            name = _props3.name,
	            onClear = _props3.onClear,
	            onFocus = _props3.onFocus,
	            onKeyDown = _props3.onKeyDown,
	            placeholder = _props3.placeholder,
	            prefix = _props3.prefix,
	            readOnly = _props3.readOnly,
	            removeMargins = _props3.removeMargins,
	            role = _props3.role,
	            showFakeValuePlaceholder = _props3.showFakeValuePlaceholder,
	            showOverflowEllipsis = _props3.showOverflowEllipsis,
	            small = _props3.small,
	            spellCheck = _props3.spellCheck,
	            styles = _props3.styles,
	            suffix = _props3.suffix,
	            suffixText = _props3.suffixText,
	            type = _props3.type,
	            underlineFocus = _props3.underlineFocus,
	            value = _props3.value,
	            velouteId = _props3.velouteId;
	        var isFocused = this.state.isFocused;
	
	        var isSelectBrand = brand === _withBrand.BRAND_SELECT;
	
	        var autoCapitalizeProps = autoCapitalize && { autoCapitalize: autoCapitalize } || {};
	        var autoCorrectProps = autoCorrect === true && { autoCorrect: 'on' } || autoCorrect === false && { autoCorrect: 'off' } || {};
	        var spellCheckProps = spellCheck === true && { spellCheck: 'true' } || spellCheck === false && { spellCheck: 'false' } || {};
	
	        return _react2['default'].createElement(
	          _AutoDirectionProvider2['default'],
	          {
	            inline: inline,
	            text: value || ''
	          },
	          _react2['default'].createElement(
	            'div',
	            _extends({
	              onBlur: this.onBlur,
	              onFocus: this.onFocus
	            }, css(styles.container, removeMargins && styles.container_noMargins, small && styles.container_small, inverse && styles.container_inverse, borderless && !isFocused && styles.borderless, inverse && borderless && styles.container_inverseBorderless, !inline && styles.block, isFocused && styles.focus, isFocused && isSelectBrand && styles.focus_select, isFocused && underlineFocus && !focusBorderless && styles.focus_underline, isFocused && focusBorderless && styles.focus_borderless, invalid && styles.invalid, disabled && styles.container_disabled)),
	            !!prefix && _react2['default'].createElement(
	              'div',
	              css(styles.prefixContainer),
	              _react2['default'].createElement(
	                'div',
	                css(styles.prefix, large && styles.prefix_large, small && styles.prefix_small),
	                prefix
	              )
	            ),
	            !!suffix && _react2['default'].createElement(
	              'div',
	              css(styles.suffixContainer),
	              _react2['default'].createElement(
	                'div',
	                css(styles.suffix, large && styles.suffix_large, small && styles.suffix_small),
	                suffix
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              css(styles.inputContainer),
	              _react2['default'].createElement('input', _extends({}, invalid && { 'aria-invalid': 'true' }, {
	                autoComplete: autoComplete && [].concat(autoComplete).join(' '),
	                autoFocus: autoFocus,
	                'aria-describedby': invalid ? errorMessageID : null,
	                'aria-owns': ariaOwns
	              }, css(styles.input, small && styles.input_small, book && styles.input_book, large && styles.input_large, showOverflowEllipsis && styles.input_ellipsis, showFakeValuePlaceholder ? styles.input_fakeValuePlaceholder : styles.input_defaultPlaceholder, inverse && styles.textInverse, inverse && styles.placeholderInverse), {
	                'data-veloute': velouteId,
	                'data-vars-input-name': ampVarsInputName,
	                disabled: disabled,
	                readOnly: readOnly,
	                ref: this.setInputRef,
	                id: id,
	                maxLength: maxLength,
	                name: name,
	                onBlur: this.onInputBlur,
	                onChange: this.onInputChange,
	                onFocus: onFocus,
	                onKeyDown: onKeyDown,
	                placeholder: placeholder,
	                role: role,
	                value: value,
	                type: type
	              }, autoCapitalizeProps, autoCorrectProps, spellCheckProps)),
	              suffixText && _react2['default'].createElement(
	                'div',
	                css(styles.suffixTextContainer),
	                _react2['default'].createElement(
	                  'span',
	                  css(styles.input, small && styles.input_small, large && styles.input_large, styles.suffixText, this.suffixTextStyles(), inverse && styles.textInverse),
	                  suffixText
	                ),
	                _react2['default'].createElement(
	                  'span',
	                  _extends({
	                    ref: function () {
	                      function ref(elt) {
	                        _this3.contentMeasurer = elt;
	                      }
	
	                      return ref;
	                    }()
	                  }, css(styles.input, small && styles.input_small, styles.contentMeasurer)),
	                  value || placeholder
	                )
	              ),
	              onClear && value.length > 0 && _react2['default'].createElement(
	                'div',
	                _extends({
	                  'data-veloute': String(velouteId) + '__clearButton'
	                }, css(styles.clearInputBtnWrapper, !isFocused && styles.clearInputBtnWrapper_hidden)),
	                _react2['default'].createElement(
	                  'div',
	                  css(styles.vertMiddle),
	                  _react2['default'].createElement(
	                    'button',
	                    _extends({}, css(styles.clearInputBtn, small && styles.clearInputBtn_small, large && styles.clearInputBtn_large, inverse && styles.textInverse), {
	                      onClick: this.onClear,
	                      onMouseDown: this.prepareToClear,
	                      onTouchStart: this.prepareToClear,
	                      type: 'button'
	                    }),
	                    _react2['default'].createElement(_IconClose2['default'], {
	                      size: 12,
	                      accessibilityLabel: _airbnbI18n2['default'].t('Shared.clearInput', { 'default': 'Clear Input' })
	                    })
	                  )
	                )
	              )
	            ),
	            underlineFocus && isFocused && _react2['default'].createElement('div', css(styles.focusUnderline, isSelectBrand && styles.focusUnderlineColor_select))
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return InputOnly;
	}(_react2['default'].Component);
	
	InputOnly.componentCategory = 'Private';
	InputOnly.displayName = 'InputOnly';
	
	
	InputOnly.propTypes = finalPropTypes;
	InputOnly.defaultProps = defaultProps;
	
	var borderWidth = 1;
	
	exports['default'] = (0, _withBrand2['default'])((0, _withStyles.withStyles)(function (_ref) {
	  var unit = _ref.unit,
	      color = _ref.color,
	      font = _ref.font;
	
	  var basePaddingSmall = unit;
	  var basePadding = 1.5 * unit;
	  var basePaddingLarge = 2 * unit;
	
	  return {
	    container: Object.assign({}, font.formInput, {
	      borderWidth: borderWidth,
	      borderStyle: 'solid',
	      borderColor: color.inputBorder,
	      borderRadius: unit / 4,
	      backgroundColor: color.inputBackground,
	      marginBottom: 1 * unit,
	      position: 'relative',
	      zIndex: 0 // To position suffixTextContainer underneath the input
	    }),
	
	    container_disabled: {
	      backgroundColor: color.inputDisabled
	    },
	
	    container_noMargins: {
	      // written individually to overwrite existing values
	      marginBottom: 0,
	      marginTop: 0,
	      marginLeft: 0,
	      marginRight: 0
	    },
	
	    container_small: Object.assign({}, font.textSmall),
	
	    container_inverse: {
	      backgroundColor: 'transparent'
	    },
	
	    container_inverseBorderless: {
	      borderColor: 'transparent'
	    },
	
	    textInverse: {
	      color: color.white
	    },
	
	    block: {
	      display: 'block',
	      width: '100%'
	    },
	
	    borderless: {
	      // use the background color as the border color to appear borderless while preserving size
	      borderColor: color.inputBackground
	    },
	
	    focus: {
	      borderWidth: borderWidth,
	      borderStyle: 'solid',
	      borderColor: color.inputFocusedBorder
	    },
	
	    focus_select: {
	      borderColor: color.core.hackberry
	    },
	
	    focus_underline: {
	      // use the background color as the border color to appear borderless while preserving size
	      borderColor: color.inputBorder
	    },
	
	    focus_borderless: {
	      // use the background color as the border color to appear borderless while preserving size
	      borderColor: color.inputBackground
	    },
	
	    focusUnderline: {
	      // -1 to offset the border inputBackground border color
	      left: -1,
	      right: -1,
	      bottom: -1,
	      position: 'absolute',
	      height: 2,
	      background: color.inputFocusedUnderlineBorder
	    },
	
	    focusUnderlineColor_select: {
	      background: color.core.hackberry
	    },
	
	    prefixContainer: {
	      float: 'left'
	    },
	
	    prefix: Object.assign({}, font.book, {
	      paddingLeft: basePadding,
	      paddingTop: basePadding - borderWidth
	    }),
	
	    prefix_large: Object.assign({}, font.textLarge, {
	      paddingLeft: basePaddingLarge,
	      paddingTop: basePaddingLarge - borderWidth
	    }),
	
	    prefix_small: Object.assign({}, font.textSmall, {
	      paddingLeft: basePaddingSmall,
	      paddingTop: basePaddingSmall - borderWidth
	    }),
	
	    suffixContainer: {
	      float: 'right'
	    },
	
	    suffix: {
	      paddingRight: basePadding,
	      paddingTop: basePadding - borderWidth
	    },
	
	    suffix_large: Object.assign({}, font.textLarge, {
	      paddingRight: basePaddingLarge,
	      paddingTop: basePaddingLarge - borderWidth
	    }),
	
	    suffix_small: Object.assign({}, font.textSmall, {
	      paddingRight: basePaddingSmall,
	      paddingTop: basePaddingSmall - borderWidth
	    }),
	
	    suffixTextContainer: {
	      bottom: 0,
	      left: 0,
	      pointerEvents: 'none',
	      position: 'absolute',
	      right: 0,
	      top: 0,
	      zIndex: -1 // We want it under the input because IE9 does not support pointerEvents
	    },
	
	    suffixText: {
	      color: color.placeholder,
	      position: 'absolute',
	      whiteSpace: 'nowrap',
	      transform: 'translateX(' + -1.5 * unit + 'px)'
	    },
	
	    contentMeasurer: {
	      border: 0,
	      display: 'inline',
	      position: 'absolute',
	      top: 0,
	      transform: 'translateY(-100px)',
	      whiteSpace: 'pre',
	      width: 'auto'
	    },
	
	    inputContainer: {
	      overflow: 'hidden',
	      position: 'relative'
	    },
	
	    input: Object.assign({}, font.formInput, font.light, {
	      backgroundColor: color.clear,
	      border: 0,
	      padding: basePadding - borderWidth,
	      width: '100%',
	
	      ':focus': {
	        outline: 'none'
	      },
	
	      '::-ms-clear': {
	        display: 'none'
	      }
	    }),
	
	    input_defaultPlaceholder: (0, _placeholderStyle2['default'])({
	      color: color.placeholder,
	      opacity: 1
	    }),
	
	    input_small: Object.assign({}, font.textSmall, font.book, {
	      padding: basePaddingSmall - borderWidth
	    }),
	
	    input_large: Object.assign({}, font.textLarge, {
	      padding: basePaddingLarge - borderWidth
	    }),
	
	    input_book: Object.assign({}, font.book),
	
	    input_ellipsis: {
	      textOverflow: 'ellipsis'
	    },
	
	    input_fakeValuePlaceholder: (0, _placeholderStyle2['default'])({
	      color: font.formInput.color,
	      opacity: 1
	    }),
	
	    placeholderInverse: (0, _placeholderStyle2['default'])({
	      color: color.white
	    }),
	
	    invalid: {
	      backgroundColor: color.inputInvalidBackground,
	      border: borderWidth + 'px solid ' + String(color.inputInvalidBorder),
	
	      ':focus': {
	        border: borderWidth + 'px solid ' + String(color.inputInvalidBorder)
	      }
	    },
	
	    clearInputBtnWrapper: {
	      position: 'absolute',
	      right: 0,
	      top: 0,
	      bottom: 0,
	      height: '100%',
	
	      // vertical alignment for children
	      ':before': {
	        content: '""',
	        display: 'inline-block',
	        verticalAlign: 'middle',
	        height: '100%'
	      }
	    },
	
	    clearInputBtnWrapper_hidden: Object.assign({}, _visuallyHidden2['default']),
	
	    vertMiddle: {
	      verticalAlign: 'middle',
	      display: 'inline-block'
	    },
	
	    clearInputBtn: {
	      color: color.placeholder,
	      cursor: 'pointer',
	      background: 'transparent',
	      border: 0,
	      padding: basePadding,
	
	      ':active': {
	        outline: 0
	      }
	    },
	
	    clearInputBtn_small: {
	      padding: basePaddingSmall
	    },
	
	    clearInputBtn_large: {
	      padding: basePaddingLarge
	    }
	  };
	})(InputOnly));
	exports.inputTypes = _inputTypes2['default'];
	exports.propTypes = propTypes;

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	var _animated = __webpack_require__(95);
	
	var _animated2 = _interopRequireDefault(_animated);
	
	var _reactWithDirection = __webpack_require__(84);
	
	var _reactWithDirection2 = _interopRequireDefault(_reactWithDirection);
	
	var _IconChevronNext = __webpack_require__(148);
	
	var _IconChevronNext2 = _interopRequireDefault(_IconChevronNext);
	
	var _IconChevronPrevious = __webpack_require__(149);
	
	var _IconChevronPrevious2 = _interopRequireDefault(_IconChevronPrevious);
	
	var _withStyles = __webpack_require__(5);
	
	var _AnimatedScrollContainer = __webpack_require__(150);
	
	var _AnimatedScrollContainer2 = _interopRequireDefault(_AnimatedScrollContainer);
	
	var _removeFirefoxButtonPadding = __webpack_require__(93);
	
	var _removeFirefoxButtonPadding2 = _interopRequireDefault(_removeFirefoxButtonPadding);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/no-will-update-set-state: 1 */
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, _reactWithDirection.withDirectionPropTypes, {
	  chevronSize: _airbnbPropTypes.nonNegativeInteger,
	  children: _propTypes2['default'].node.isRequired,
	  defaultScrollLeft: _airbnbPropTypes.nonNegativeInteger,
	
	  // fraction of the scroll container viewport that will scroll per button press
	  scrollFactor: _propTypes2['default'].number
	}));
	
	var defaultProps = {
	  chevronSize: 16,
	  defaultScrollLeft: 0,
	  scrollFactor: 0.75
	};
	
	// number of pixels threshold from the ends of the scroll container
	// to determine whether or not the backwards/forwards buttons are visible
	var BUTTON_VISIBILITY_THRESHOLD = 10;
	
	var HorizontalScroll = function (_React$Component) {
	  _inherits(HorizontalScroll, _React$Component);
	
	  function HorizontalScroll(props) {
	    _classCallCheck(this, HorizontalScroll);
	
	    var _this = _possibleConstructorReturn(this, (HorizontalScroll.__proto__ || Object.getPrototypeOf(HorizontalScroll)).call(this, props));
	
	    _this.scrollLeft = props.defaultScrollLeft;
	
	    _this.state = {
	      anim: new _animated2['default'].Value(_this.scrollLeft),
	      hasScrolled: false,
	      showBackwardsButton: false,
	      showForwardsButton: false
	    };
	
	    _this.maxScrollLeft = 0;
	    _this.scrollContainerWidth = 0;
	
	    _this.onButtonBackwardsClick = _this.onButtonBackwardsClick.bind(_this);
	    _this.onButtonForwardsClick = _this.onButtonForwardsClick.bind(_this);
	    _this.onScroll = _this.onScroll.bind(_this);
	    _this.onScrollDimensionsChange = _this.onScrollDimensionsChange.bind(_this);
	
	    _this.state.anim.addListener(function (_ref) {
	      var value = _ref.value;
	
	      _this.scrollLeft = value;
	      _this.setButtonsVisibility();
	
	      if (!_this.state.hasScrolled) {
	        _this.setState({ hasScrolled: true });
	      }
	    });
	    return _this;
	  }
	
	  _createClass(HorizontalScroll, [{
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(_ref2) {
	        var newDefaultScrollLeft = _ref2.defaultScrollLeft;
	        var defaultScrollLeft = this.props.defaultScrollLeft;
	
	        if (newDefaultScrollLeft !== defaultScrollLeft && newDefaultScrollLeft !== null) {
	          this.state.anim.setValue(newDefaultScrollLeft);
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'onButtonBackwardsClick',
	    value: function () {
	      function onButtonBackwardsClick() {
	        if (this.props.direction === _reactWithDirection.DIRECTIONS.RTL) {
	          this.scrollTowardsRight();
	        } else {
	          this.scrollTowardsLeft();
	        }
	      }
	
	      return onButtonBackwardsClick;
	    }()
	  }, {
	    key: 'onButtonForwardsClick',
	    value: function () {
	      function onButtonForwardsClick() {
	        if (this.props.direction === _reactWithDirection.DIRECTIONS.RTL) {
	          this.scrollTowardsLeft();
	        } else {
	          this.scrollTowardsRight();
	        }
	      }
	
	      return onButtonForwardsClick;
	    }()
	  }, {
	    key: 'onScroll',
	    value: function () {
	      function onScroll(event) {
	        this.state.anim.setValue(event.target.scrollLeft);
	      }
	
	      return onScroll;
	    }()
	  }, {
	    key: 'onScrollDimensionsChange',
	    value: function () {
	      function onScrollDimensionsChange(_ref3) {
	        var clientWidth = _ref3.clientWidth,
	            scrollWidth = _ref3.scrollWidth;
	
	        var nextMaxScrollLeft = scrollWidth - clientWidth;
	
	        if (this.maxScrollLeft !== nextMaxScrollLeft || this.scrollContainerWidth !== clientWidth) {
	          this.maxScrollLeft = scrollWidth - clientWidth;
	          this.scrollContainerWidth = clientWidth;
	          this.setButtonsVisibility();
	        }
	      }
	
	      return onScrollDimensionsChange;
	    }()
	  }, {
	    key: 'setButtonsVisibility',
	    value: function () {
	      function setButtonsVisibility() {
	        var isRTL = this.props.direction === _reactWithDirection.DIRECTIONS.RTL;
	        var hasLeftClearance = this.scrollLeft > BUTTON_VISIBILITY_THRESHOLD;
	        var hasRightClearance = this.scrollLeft < this.maxScrollLeft - BUTTON_VISIBILITY_THRESHOLD;
	
	        var showBackwardsButton = isRTL ? hasRightClearance : hasLeftClearance;
	        var showForwardsButton = isRTL ? hasLeftClearance : hasRightClearance;
	
	        var _state = this.state,
	            prevBackwards = _state.showBackwardsButton,
	            prevForwards = _state.showForwardsButton;
	
	
	        if (prevBackwards !== showBackwardsButton || prevForwards !== showForwardsButton) {
	          this.setState({ showBackwardsButton: showBackwardsButton, showForwardsButton: showForwardsButton });
	        }
	      }
	
	      return setButtonsVisibility;
	    }()
	  }, {
	    key: 'scrollTowardsLeft',
	    value: function () {
	      function scrollTowardsLeft() {
	        var _this2 = this;
	
	        this.state.anim.stopAnimation(function (value) {
	          var delta = _this2.scrollContainerWidth * _this2.props.scrollFactor;
	          var nextValue = Math.max(value - delta, 0);
	          _animated2['default'].timing(_this2.state.anim, { toValue: nextValue }).start();
	        });
	      }
	
	      return scrollTowardsLeft;
	    }()
	  }, {
	    key: 'scrollTowardsRight',
	    value: function () {
	      function scrollTowardsRight() {
	        var _this3 = this;
	
	        this.state.anim.stopAnimation(function (value) {
	          var delta = _this3.scrollContainerWidth * _this3.props.scrollFactor;
	          var nextValue = Math.min(value + delta, _this3.maxScrollLeft);
	          _animated2['default'].timing(_this3.state.anim, { toValue: nextValue }).start();
	        });
	      }
	
	      return scrollTowardsRight;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props = this.props,
	            css = _props.css,
	            chevronSize = _props.chevronSize,
	            children = _props.children,
	            styles = _props.styles;
	        var _state2 = this.state,
	            hasScrolled = _state2.hasScrolled,
	            showBackwardsButton = _state2.showBackwardsButton,
	            showForwardsButton = _state2.showForwardsButton;
	
	
	        var iconProps = {
	          size: chevronSize
	        };
	
	        return _react2['default'].createElement(
	          'div',
	          css(styles.container),
	          _react2['default'].createElement(
	            _AnimatedScrollContainer2['default'],
	            {
	              hideHorizontalScrollbar: true,
	              onScroll: this.onScroll,
	              onScrollDimensionsChange: this.onScrollDimensionsChange,
	              scrollLeft: this.state.anim
	            },
	            children
	          ),
	          _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'button',
	              _extends({
	                type: 'button'
	              }, css(styles.button, styles.button_backwards, showBackwardsButton && styles.button_visible, !showBackwardsButton && styles.button_hidden, hasScrolled && styles.button_transition, hasScrolled && showBackwardsButton && styles.button_visible_transition, hasScrolled && !showBackwardsButton && styles.button_hidden_transition), {
	                'aria-hidden': true,
	                onClick: this.onButtonBackwardsClick
	              }),
	              _react2['default'].createElement(
	                'div',
	                css(styles.iconContainer, styles.iconContainer_backwards),
	                _react2['default'].createElement(
	                  'div',
	                  css(styles.icon),
	                  _react2['default'].createElement(_IconChevronPrevious2['default'], _extends({}, iconProps, { decorative: true }))
	                )
	              ),
	              _react2['default'].createElement('div', css(styles.gradient, styles.gradient_backwards))
	            ),
	            _react2['default'].createElement(
	              'button',
	              _extends({
	                type: 'button'
	              }, css(styles.button, styles.button_forwards, showForwardsButton && styles.button_visible, !showForwardsButton && styles.button_hidden, hasScrolled && styles.button_transition, hasScrolled && showForwardsButton && styles.button_visible_transition, hasScrolled && !showForwardsButton && styles.button_hidden_transition), {
	                'aria-hidden': true,
	                onClick: this.onButtonForwardsClick
	              }),
	              _react2['default'].createElement('div', css(styles.gradient, styles.gradient_forwards)),
	              _react2['default'].createElement(
	                'div',
	                css(styles.iconContainer, styles.iconContainer_forwards),
	                _react2['default'].createElement(
	                  'div',
	                  css(styles.icon),
	                  _react2['default'].createElement(_IconChevronNext2['default'], _extends({}, iconProps, { decorative: true }))
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return HorizontalScroll;
	}(_react2['default'].Component);
	
	HorizontalScroll.componentCategory = 'Private';
	HorizontalScroll.displayName = 'HorizontalScroll';
	
	
	HorizontalScroll.propTypes = propTypes;
	HorizontalScroll.defaultProps = defaultProps;
	
	var HorizontalScrollWithStyles = (0, _withStyles.withStyles)(function (_ref4) {
	  var color = _ref4.color,
	      unit = _ref4.unit;
	  return {
	    container: {
	      position: 'relative'
	    },
	
	    button: Object.assign({
	      background: color.clear,
	      border: 0,
	      cursor: 'pointer',
	      height: '100%',
	      margin: 0,
	      padding: 0,
	      position: 'absolute',
	      top: 0
	
	    }, (0, _removeFirefoxButtonPadding2['default'])()),
	
	    button_transition: {
	      // "transition" on z-index to avoid blocking clicks when hidden
	      transitionProperty: 'opacity, z-index',
	      transitionDuration: '300ms, 0ms',
	      transitionTimingFunction: 'ease-out'
	    },
	
	    button_backwards: {
	      left: 0
	    },
	
	    button_forwards: {
	      right: 0
	    },
	
	    button_visible: {
	      opacity: 1,
	      zIndex: 0
	    },
	
	    button_visible_transition: {
	      transitionDelay: '0ms, 0ms'
	    },
	
	    button_hidden: {
	      opacity: 0,
	      zIndex: -1
	    },
	
	    button_hidden_transition: {
	      transitionDelay: '0ms, 300ms'
	    },
	
	    iconContainer: {
	      backgroundColor: color.white,
	      display: 'inline-block',
	      height: '100%',
	      position: 'relative',
	      verticalAlign: 'top'
	    },
	
	    iconContainer_backwards: {
	      paddingRight: 0.5 * unit
	    },
	
	    iconContainer_forwards: {
	      paddingLeft: 0.5 * unit
	    },
	
	    icon: {
	      color: color.core.hof,
	      position: 'relative',
	      top: '50%',
	      transform: 'translateY(-50%)'
	    },
	
	    gradient: {
	      display: 'inline-block',
	      height: '100%',
	      verticalAlign: 'top',
	      width: 20
	    },
	
	    gradient_backwards: {
	      background: 'linear-gradient(to left, ' + String(color.opacity(color.white, 0)) + ', ' + String(color.white) + ')'
	    },
	
	    gradient_forwards: {
	      background: 'linear-gradient(to right, ' + String(color.opacity(color.white, 0)) + ', ' + String(color.white) + ')'
	    }
	  };
	})(HorizontalScroll);
	
	exports['default'] = (0, _reactWithDirection2['default'])(HorizontalScrollWithStyles);

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	var _withStyles = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
	  children: _propTypes2['default'].node.isRequired,
	  inlineBlock: _propTypes2['default'].bool
	}));
	
	var defaultProps = {
	  inlineBlock: false
	};
	
	/**
	 * Mirror is intended to flip its content as if looking into a mirror.
	 * For example, a IconStarHalf will be filled on the other side.
	 */
	
	function Mirror(_ref) {
	  var css = _ref.css,
	      children = _ref.children,
	      inlineBlock = _ref.inlineBlock,
	      styles = _ref.styles;
	
	  var Element = inlineBlock ? 'span' : 'div';
	  return _react2['default'].createElement(
	    Element,
	    css(styles.container, inlineBlock && styles.container_inlineBlock),
	    children
	  );
	}
	
	Mirror.componentCategory = 'Private';
	Mirror.displayName = 'Mirror';
	Mirror.propTypes = propTypes;
	Mirror.defaultProps = defaultProps;
	
	exports['default'] = (0, _withStyles.withStyles)(function () {
	  return {
	    container: {
	      transform: 'scaleX(-1)'
	    },
	
	    container_inlineBlock: {
	      // the scaleX transform only works on block or inline-block elements
	      display: 'inline-block',
	      verticalAlign: 'top'
	    }
	  };
	})(Mirror);

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	var _withStyles = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
	  children: _propTypes2['default'].node.isRequired,
	  hideHorizontalScrollbar: _propTypes2['default'].bool,
	  hideVerticalScrollbar: _propTypes2['default'].bool,
	  onScroll: _propTypes2['default'].func,
	  onScrollDimensionsChange: _propTypes2['default'].func,
	  scrollLeft: _propTypes2['default'].number,
	  scrollTop: _propTypes2['default'].number
	}));
	
	var defaultProps = {
	  hideHorizontalScrollbar: false,
	  hideVerticalScrollbar: false,
	  onScroll: function () {
	    function onScroll() {}
	
	    return onScroll;
	  }(),
	  onScrollDimensionsChange: function () {
	    function onScrollDimensionsChange() {}
	
	    return onScrollDimensionsChange;
	  }(),
	
	  scrollLeft: 0,
	  scrollTop: 0
	};
	
	var ScrollContainer = function (_React$Component) {
	  _inherits(ScrollContainer, _React$Component);
	
	  function ScrollContainer(props) {
	    _classCallCheck(this, ScrollContainer);
	
	    var _this = _possibleConstructorReturn(this, (ScrollContainer.__proto__ || Object.getPrototypeOf(ScrollContainer)).call(this, props));
	
	    _this.preventScrollEvent = false;
	
	    _this.onScroll = _this.onScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(ScrollContainer, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        var _this2 = this;
	
	        // Some of these calls force layout, so we want to defer this to avoid
	        // layout thrashing.
	        this.initialTimeout = setTimeout(function () {
	          _this2.initialTimeout = null;
	          var _props = _this2.props,
	              scrollLeft = _props.scrollLeft,
	              scrollTop = _props.scrollTop;
	
	          _this2.setScrollLeft(scrollLeft);
	          _this2.setScrollTop(scrollTop);
	          _this2.onScrollDimensionsChange();
	        });
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var _this3 = this;
	
	        if (this.updateTimeout) {
	          clearTimeout(this.updateTimeout);
	        }
	
	        var _props2 = this.props,
	            scrollLeft = _props2.scrollLeft,
	            scrollTop = _props2.scrollTop;
	
	        var prevScrollLeft = Math.round(prevProps.scrollLeft);
	        var prevScrollTop = Math.round(prevProps.scrollTop);
	        var scrollDidChange = scrollLeft !== prevScrollLeft || scrollTop !== prevScrollTop;
	
	        // Some of these calls force layout, so we want to defer this to avoid
	        // layout thrashing.
	        if (scrollDidChange) {
	          this.updateTimeout = setTimeout(function () {
	            _this3.updateTimeout = null;
	            if (scrollLeft !== prevScrollLeft) {
	              _this3.setScrollLeft(scrollLeft);
	            }
	            if (scrollTop !== prevScrollTop) {
	              _this3.setScrollTop(scrollTop);
	            }
	
	            _this3.onScrollDimensionsChange();
	          });
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (this.initialTimeout) {
	          clearTimeout(this.initialTimeout);
	        }
	        if (this.updateTimeout) {
	          clearTimeout(this.updateTimeout);
	        }
	        this.promise = null;
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: 'onScroll',
	    value: function () {
	      function onScroll(event) {
	        if (this.preventScrollEvent) {
	          this.preventScrollEvent = false;
	          return;
	        }
	
	        this.props.onScroll(event);
	      }
	
	      return onScroll;
	    }()
	  }, {
	    key: 'onScrollDimensionsChange',
	    value: function () {
	      function onScrollDimensionsChange() {
	        var _containerInner = this.containerInner,
	            clientHeight = _containerInner.clientHeight,
	            clientWidth = _containerInner.clientWidth,
	            scrollHeight = _containerInner.scrollHeight,
	            scrollWidth = _containerInner.scrollWidth;
	
	
	        this.props.onScrollDimensionsChange({
	          clientHeight: clientHeight,
	          clientWidth: clientWidth,
	          scrollHeight: scrollHeight,
	          scrollWidth: scrollWidth
	        });
	      }
	
	      return onScrollDimensionsChange;
	    }()
	  }, {
	    key: 'setScrollLeft',
	    value: function () {
	      function setScrollLeft(scrollLeft) {
	        // setting the `scrollLeft` property would have triggered a `scroll` event;
	        // silence the event to avoid an infinite loop of the event setting the prop, etc.
	        if (scrollLeft !== this.containerInner.scrollLeft) {
	          this.preventScrollEvent = true;
	          this.containerInner.scrollLeft = scrollLeft;
	        }
	      }
	
	      return setScrollLeft;
	    }()
	  }, {
	    key: 'setScrollTop',
	    value: function () {
	      function setScrollTop(scrollTop) {
	        // setting the `scrollTop` property would have triggered a `scroll` event;
	        // silence the event to avoid an infinite loop of the event setting the prop, etc.
	        if (scrollTop !== this.containerInner.scrollTop) {
	          this.preventScrollEvent = true;
	          this.containerInner.scrollTop = scrollTop;
	        }
	      }
	
	      return setScrollTop;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this4 = this;
	
	        var _props3 = this.props,
	            css = _props3.css,
	            children = _props3.children,
	            hideHorizontalScrollbar = _props3.hideHorizontalScrollbar,
	            hideVerticalScrollbar = _props3.hideVerticalScrollbar,
	            styles = _props3.styles;
	
	
	        return _react2['default'].createElement(
	          'div',
	          css(styles.containerOuter, hideHorizontalScrollbar && styles.containerOuter_hideHorizontalScrollbar, hideVerticalScrollbar && styles.containerOuter_hideVerticalScrollbar),
	          _react2['default'].createElement(
	            'div',
	            _extends({}, css(styles.containerInner, hideHorizontalScrollbar && styles.containerInner_hideHorizontalScrollbar, hideVerticalScrollbar && styles.containerInner_hideVerticalScrollbar), {
	              onScroll: this.onScroll,
	              ref: function () {
	                function ref(el) {
	                  _this4.containerInner = el;
	                }
	
	                return ref;
	              }()
	            }),
	            children
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return ScrollContainer;
	}(_react2['default'].Component);
	
	ScrollContainer.componentCategory = 'Private';
	ScrollContainer.displayName = 'ScrollContainer';
	
	
	ScrollContainer.propTypes = propTypes;
	ScrollContainer.defaultProps = defaultProps;
	
	// This px width is large enough to cover all standard scrollbars
	var MAX_SCROLLBAR_WIDTH = 30;
	
	exports['default'] = (0, _withStyles.withStyles)(function () {
	  return {
	    containerOuter: {
	      '-webkit-overflow-scrolling': 'touch',
	      height: '100%',
	      width: '100%'
	    },
	
	    containerOuter_hideHorizontalScrollbar: {
	      overflowY: 'hidden'
	    },
	
	    containerOuter_hideVerticalScrollbar: {
	      overflowX: 'hidden'
	    },
	
	    containerInner: {
	      height: '100%',
	      overflowX: 'auto',
	      overflowY: 'auto',
	      whiteSpace: 'nowrap'
	      // cannot specify `width:100%` because it breaks hideVerticalScrollbar
	    },
	
	    containerInner_hideHorizontalScrollbar: {
	      // force scrollbar to always show even when not overflowed
	      // because we need consistent reserved space to hide
	      overflowX: 'scroll',
	      // Add enough space to bottom to cover all types of scrollbars
	      // then just hide it using overflowY: hidden in this container
	      paddingBottom: MAX_SCROLLBAR_WIDTH,
	      marginBottom: -MAX_SCROLLBAR_WIDTH
	    },
	
	    containerInner_hideVerticalScrollbar: {
	      // force scrollbar to always show even when not overflowed
	      // because we need consistent reserved space to hide
	      overflowY: 'scroll',
	
	      // Add enough space to right to cover all types of scrollbars
	      // then just hide it using overflowX: hidden in the container
	      paddingRight: MAX_SCROLLBAR_WIDTH,
	      marginRight: -MAX_SCROLLBAR_WIDTH,
	
	      // For handling RTL
	      paddingLeft: MAX_SCROLLBAR_WIDTH,
	      marginLeft: -MAX_SCROLLBAR_WIDTH
	    }
	  };
	})(ScrollContainer);

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = makeIconWithDirectionMirroring;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	var _reactWithDirection = __webpack_require__(84);
	
	var _reactWithDirection2 = _interopRequireDefault(_reactWithDirection);
	
	var _makeIcon = __webpack_require__(22);
	
	var _makeIcon2 = _interopRequireDefault(_makeIcon);
	
	var _Mirror = __webpack_require__(153);
	
	var _Mirror2 = _interopRequireDefault(_Mirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function makeIconWithDirectionMirroring() {
	  var Icon = _makeIcon2['default'].apply(undefined, arguments);
	
	  function AnIcon(_ref) {
	    var direction = _ref.direction,
	        otherProps = _objectWithoutProperties(_ref, ['direction']);
	
	    var icon = _react2['default'].createElement(Icon, otherProps);
	    if (direction === _reactWithDirection.DIRECTIONS.RTL) {
	      return _react2['default'].createElement(
	        _Mirror2['default'],
	        { inlineBlock: true },
	        icon
	      );
	    }
	    return icon;
	  }
	
	  AnIcon.displayName = 'IconWithDirection(' + String(Icon.displayName) + ')';
	  AnIcon.propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _reactWithDirection.withDirectionPropTypes, _makeIcon.propTypes));
	  AnIcon.defaultProps = _makeIcon.defaultProps;
	
	  return (0, _reactWithDirection2['default'])(AnIcon);
	}

/***/ }),

/***/ 445:
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = placeholderStyle;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var selectors = ['::-webkit-input-placeholder', '::-moz-placeholder', ':-moz-placeholder', ':-ms-input-placeholder', '::placeholder'];
	
	var validProperties = new Set(['font', 'fontStyle', 'fontVariant', 'fontWeight', 'fontStretch', 'fontSize', 'fontFamily', 'color', 'background', 'backgroundImage', 'backgroundPosition', 'backgroundSize', 'backgroundRepeat', 'backgroundOrigin', 'backgroundClip', 'backgroundAttachment', 'backgroundColor', 'wordSpacing', 'letterSpacing', 'textDecoration', 'verticalAlign', 'textTransform', 'lineHeight', 'textIndent', 'opacity']);
	
	function placeholderStyle(styles) {
	  if (!styles) return null;
	
	  Object.keys(styles).forEach(function (prop) {
	    if (!validProperties.has(prop)) {
	      throw new Error('\u201C' + String(prop) + '\u201D is not a valid property for the ::placeholder psuedo element.');
	    }
	  });
	
	  return selectors.reduce(function (accumulatedStyles, selector) {
	    return Object.assign({}, accumulatedStyles, _defineProperty({}, selector, styles));
	  }, {});
	}

/***/ }),

/***/ 448:
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = mutuallyInclusive;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function mutuallyInclusive(propMapping) {
	  return Object.keys(propMapping).reduce(function (propTypes, prop) {
	    return Object.assign({}, propTypes, _defineProperty({}, prop, function () {
	      function validator(props, propName, componentName) {
	        // This prop wasn't present, so don't worry about checking other props
	        if (typeof props[propName] === 'undefined' || props[propName] === null) {
	          return null;
	        }
	
	        for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	          rest[_key - 3] = arguments[_key];
	        }
	
	        var currentPropResult = propMapping[prop].apply(propMapping, [props, propName, componentName].concat(rest));
	        if (currentPropResult) {
	          return currentPropResult;
	        }
	
	        var otherProps = Object.assign({}, propMapping);
	        delete otherProps[prop];
	        var missingProps = Object.keys(otherProps).reduce(function (sum, p) {
	          if (typeof props[p] !== 'undefined' && props[p] !== null) {
	            return sum;
	          }
	          return [].concat(_toConsumableArray(sum), [p]);
	        }, []);
	
	        if (missingProps.length === 0) {
	          return null;
	        }
	
	        return new TypeError(String(componentName) + ': when `' + String(prop) + '` is present, props ' + String(missingProps.map(function (p) {
	          return '`' + String(p) + '`';
	        }).join(', ')) + ' must also be present.');
	      }
	
	      return validator;
	    }()));
	  }, {});
	}

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	exports['default'] = (0, _airbnbPropTypes.childrenHavePropXorChildren)('href');

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

	
	
	
	
	
	
	
	
	
	
	'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var
	
	
	
	Animated=function(){function Animated(){_classCallCheck(this,Animated);}_createClass(Animated,[{key:'__attach',value:function __attach()
	{}},{key:'__detach',value:function __detach()
	{}},{key:'__getValue',value:function __getValue()
	{}},{key:'__getAnimatedValue',value:function __getAnimatedValue()
	{return this.__getValue();}},{key:'__addChild',value:function __addChild(
	child){}},{key:'__removeChild',value:function __removeChild(
	child){}},{key:'__getChildren',value:function __getChildren()
	{return[];}}]);return Animated;}();
	
	
	module.exports=Animated;

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	
	
	
	
	
	
	
	
	
	
	'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var AnimatedWithChildren=__webpack_require__(19);
	var Animated=__webpack_require__(13);
	var AnimatedValue=__webpack_require__(25);
	var Interpolation=__webpack_require__(33);
	var AnimatedInterpolation=__webpack_require__(45);var
	
	
	
	AnimatedAddition=function(_AnimatedWithChildren){_inherits(AnimatedAddition,_AnimatedWithChildren);
	
	
	
	
	
	
	function AnimatedAddition(a,b){_classCallCheck(this,AnimatedAddition);var _this=_possibleConstructorReturn(this,(AnimatedAddition.__proto__||Object.getPrototypeOf(AnimatedAddition)).call(this));
	
	_this._a=typeof a==='number'?new AnimatedValue(a):a;
	_this._b=typeof b==='number'?new AnimatedValue(b):b;
	_this._listeners={};return _this;
	}_createClass(AnimatedAddition,[{key:'__getValue',value:function __getValue()
	
	{
	return this._a.__getValue()+this._b.__getValue();
	}},{key:'addListener',value:function addListener(
	
	callback){var _this2=this;
	if(!this._aListener&&this._a.addListener){
	this._aListener=this._a.addListener(function(){
	for(var key in _this2._listeners){
	_this2._listeners[key]({value:_this2.__getValue()});
	}
	});
	}
	if(!this._bListener&&this._b.addListener){
	this._bListener=this._b.addListener(function(){
	for(var key in _this2._listeners){
	_this2._listeners[key]({value:_this2.__getValue()});
	}
	});
	}
	var id=guid();
	this._listeners[id]=callback;
	return id;
	}},{key:'removeListener',value:function removeListener(
	
	id){
	delete this._listeners[id];
	}},{key:'interpolate',value:function interpolate(
	
	config){
	return new AnimatedInterpolation(this,Interpolation.create(config));
	}},{key:'__attach',value:function __attach()
	
	{
	this._a.__addChild(this);
	this._b.__addChild(this);
	}},{key:'__detach',value:function __detach()
	
	{
	this._a.__removeChild(this);
	this._b.__removeChild(this);
	}}]);return AnimatedAddition;}(AnimatedWithChildren);
	
	
	module.exports=AnimatedAddition;

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	
	
	
	
	
	
	
	
	
	
	'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var Animated=__webpack_require__(13);
	var AnimatedWithChildren=__webpack_require__(19);
	var invariant=__webpack_require__(21);
	var Interpolation=__webpack_require__(33);
	var guid=__webpack_require__(63);var
	
	
	
	AnimatedInterpolation=function(_AnimatedWithChildren){_inherits(AnimatedInterpolation,_AnimatedWithChildren);
	
	
	
	
	
	function AnimatedInterpolation(parent,interpolation){_classCallCheck(this,AnimatedInterpolation);var _this=_possibleConstructorReturn(this,(AnimatedInterpolation.__proto__||Object.getPrototypeOf(AnimatedInterpolation)).call(this));
	
	_this._parent=parent;
	_this._interpolation=interpolation;
	_this._listeners={};return _this;
	}_createClass(AnimatedInterpolation,[{key:'__getValue',value:function __getValue()
	
	{
	var parentValue=this._parent.__getValue();
	invariant(
	typeof parentValue==='number',
	'Cannot interpolate an input which is not a number.');
	
	return this._interpolation(parentValue);
	}},{key:'addListener',value:function addListener(
	
	callback){var _this2=this;
	if(!this._parentListener){
	this._parentListener=this._parent.addListener(function(){
	for(var key in _this2._listeners){
	_this2._listeners[key]({value:_this2.__getValue()});
	}
	});
	}
	var id=guid();
	this._listeners[id]=callback;
	return id;
	}},{key:'removeListener',value:function removeListener(
	
	id){
	delete this._listeners[id];
	}},{key:'interpolate',value:function interpolate(
	
	config){
	return new AnimatedInterpolation(this,Interpolation.create(config));
	}},{key:'__attach',value:function __attach()
	
	{
	this._parent.__addChild(this);
	}},{key:'__detach',value:function __detach()
	
	{
	this._parent.__removeChild(this);
	this._parentListener=this._parent.removeListener(this._parentListener);
	}}]);return AnimatedInterpolation;}(AnimatedWithChildren);
	
	
	module.exports=AnimatedInterpolation;

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	
	
	
	
	
	
	
	
	
	
	'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var Animated=__webpack_require__(13);
	var AnimatedWithChildren=__webpack_require__(19);
	var AnimatedInterpolation=__webpack_require__(45);
	var Interpolation=__webpack_require__(33);var
	
	
	
	AnimatedModulo=function(_AnimatedWithChildren){_inherits(AnimatedModulo,_AnimatedWithChildren);
	
	
	
	
	
	function AnimatedModulo(a,modulus){_classCallCheck(this,AnimatedModulo);var _this=_possibleConstructorReturn(this,(AnimatedModulo.__proto__||Object.getPrototypeOf(AnimatedModulo)).call(this));
	
	_this._a=a;
	_this._modulus=modulus;
	_this._listeners={};return _this;
	}_createClass(AnimatedModulo,[{key:'__getValue',value:function __getValue()
	
	{
	return(this._a.__getValue()%this._modulus+this._modulus)%this._modulus;
	}},{key:'addListener',value:function addListener(
	
	callback){var _this2=this;
	if(!this._aListener){
	this._aListener=this._a.addListener(function(){
	for(var key in _this2._listeners){
	_this2._listeners[key]({value:_this2.__getValue()});
	}
	});
	}
	var id=guid();
	this._listeners[id]=callback;
	return id;
	}},{key:'removeListener',value:function removeListener(
	
	id){
	delete this._listeners[id];
	}},{key:'interpolate',value:function interpolate(
	
	config){
	return new AnimatedInterpolation(this,Interpolation.create(config));
	}},{key:'__attach',value:function __attach()
	
	{
	this._a.__addChild(this);
	}},{key:'__detach',value:function __detach()
	
	{
	this._a.__removeChild(this);
	}}]);return AnimatedModulo;}(AnimatedWithChildren);
	
	
	module.exports=AnimatedModulo;

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	
	
	
	
	
	
	
	
	
	
	'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var AnimatedWithChildren=__webpack_require__(19);
	var Animated=__webpack_require__(13);
	var AnimatedValue=__webpack_require__(25);
	var AnimatedInterpolation=__webpack_require__(45);
	var Interpolation=__webpack_require__(33);var
	
	
	
	AnimatedMultiplication=function(_AnimatedWithChildren){_inherits(AnimatedMultiplication,_AnimatedWithChildren);
	
	
	
	
	
	
	function AnimatedMultiplication(a,b){_classCallCheck(this,AnimatedMultiplication);var _this=_possibleConstructorReturn(this,(AnimatedMultiplication.__proto__||Object.getPrototypeOf(AnimatedMultiplication)).call(this));
	
	_this._a=typeof a==='number'?new AnimatedValue(a):a;
	_this._b=typeof b==='number'?new AnimatedValue(b):b;
	_this._listeners={};return _this;
	}_createClass(AnimatedMultiplication,[{key:'__getValue',value:function __getValue()
	
	{
	return this._a.__getValue()*this._b.__getValue();
	}},{key:'addListener',value:function addListener(
	
	callback){var _this2=this;
	if(!this._aListener&&this._a.addListener){
	this._aListener=this._a.addListener(function(){
	for(var key in _this2._listeners){
	_this2._listeners[key]({value:_this2.__getValue()});
	}
	});
	}
	if(!this._bListener&&this._b.addListener){
	this._bListener=this._b.addListener(function(){
	for(var key in _this2._listeners){
	_this2._listeners[key]({value:_this2.__getValue()});
	}
	});
	}
	var id=guid();
	this._listeners[id]=callback;
	return id;
	}},{key:'removeListener',value:function removeListener(
	
	id){
	delete this._listeners[id];
	}},{key:'interpolate',value:function interpolate(
	
	config){
	return new AnimatedInterpolation(this,Interpolation.create(config));
	}},{key:'__attach',value:function __attach()
	
	{
	this._a.__addChild(this);
	this._b.__addChild(this);
	}},{key:'__detach',value:function __detach()
	
	{
	this._a.__removeChild(this);
	this._b.__removeChild(this);
	}}]);return AnimatedMultiplication;}(AnimatedWithChildren);
	
	
	module.exports=AnimatedMultiplication;

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	
	
	
	
	
	
	
	
	
	
	'use strict';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var Animated=__webpack_require__(13);
	var AnimatedStyle=__webpack_require__(164);var
	
	AnimatedProps=function(_Animated){_inherits(AnimatedProps,_Animated);
	
	
	
	function AnimatedProps(
	props,
	callback)
	{_classCallCheck(this,AnimatedProps);var _this=_possibleConstructorReturn(this,(AnimatedProps.__proto__||Object.getPrototypeOf(AnimatedProps)).call(this));
	
	if(props.style){
	props=_extends({},
	props,{
	style:new AnimatedStyle(props.style)});
	
	}
	_this._props=props;
	_this._callback=callback;
	_this.__attach();return _this;
	}_createClass(AnimatedProps,[{key:'__getValue',value:function __getValue()
	
	{
	var props={};
	for(var key in this._props){
	var value=this._props[key];
	if(value instanceof Animated){
	props[key]=value.__getValue();
	}else{
	props[key]=value;
	}
	}
	return props;
	}},{key:'__getAnimatedValue',value:function __getAnimatedValue()
	
	{
	var props={};
	for(var key in this._props){
	var value=this._props[key];
	if(value instanceof Animated){
	props[key]=value.__getAnimatedValue();
	}
	}
	return props;
	}},{key:'__attach',value:function __attach()
	
	{
	for(var key in this._props){
	var value=this._props[key];
	if(value instanceof Animated){
	value.__addChild(this);
	}
	}
	}},{key:'__detach',value:function __detach()
	
	{
	for(var key in this._props){
	var value=this._props[key];
	if(value instanceof Animated){
	value.__removeChild(this);
	}
	}
	}},{key:'update',value:function update()
	
	{
	this._callback();
	}}]);return AnimatedProps;}(Animated);
	
	
	module.exports=AnimatedProps;

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	
	
	
	
	
	
	
	
	
	
	'use strict';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var Animated=__webpack_require__(13);
	var AnimatedWithChildren=__webpack_require__(19);
	var AnimatedTransform=__webpack_require__(167);
	var FlattenStyle=__webpack_require__(97);var
	
	AnimatedStyle=function(_AnimatedWithChildren){_inherits(AnimatedStyle,_AnimatedWithChildren);
	
	
	function AnimatedStyle(style){_classCallCheck(this,AnimatedStyle);var _this=_possibleConstructorReturn(this,(AnimatedStyle.__proto__||Object.getPrototypeOf(AnimatedStyle)).call(this));
	
	style=FlattenStyle.current(style)||{};
	if(style.transform&&!(style.transform instanceof Animated)){
	style=_extends({},
	style,{
	transform:new AnimatedTransform(style.transform)});
	
	}
	_this._style=style;return _this;
	}_createClass(AnimatedStyle,[{key:'__getValue',value:function __getValue()
	
	{
	var style={};
	for(var key in this._style){
	var value=this._style[key];
	if(value instanceof Animated){
	style[key]=value.__getValue();
	}else{
	style[key]=value;
	}
	}
	return style;
	}},{key:'__getAnimatedValue',value:function __getAnimatedValue()
	
	{
	var style={};
	for(var key in this._style){
	var value=this._style[key];
	if(value instanceof Animated){
	style[key]=value.__getAnimatedValue();
	}
	}
	return style;
	}},{key:'__attach',value:function __attach()
	
	{
	for(var key in this._style){
	var value=this._style[key];
	if(value instanceof Animated){
	value.__addChild(this);
	}
	}
	}},{key:'__detach',value:function __detach()
	
	{
	for(var key in this._style){
	var value=this._style[key];
	if(value instanceof Animated){
	value.__removeChild(this);
	}
	}
	}}]);return AnimatedStyle;}(AnimatedWithChildren);
	
	
	module.exports=AnimatedStyle;

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	
	
	
	
	
	
	
	
	
	
	'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var Animated=__webpack_require__(13);
	var AnimatedWithChildren=__webpack_require__(19);var
	
	AnimatedTemplate=function(_AnimatedWithChildren){_inherits(AnimatedTemplate,_AnimatedWithChildren);
	
	
	
	function AnimatedTemplate(strings,values){_classCallCheck(this,AnimatedTemplate);var _this=_possibleConstructorReturn(this,(AnimatedTemplate.__proto__||Object.getPrototypeOf(AnimatedTemplate)).call(this));
	
	_this._strings=strings;
	_this._values=values;return _this;
	}_createClass(AnimatedTemplate,[{key:'__transformValue',value:function __transformValue(
	
	value){
	if(value instanceof Animated){
	return value.__getValue();
	}else{
	return value;
	}
	}},{key:'__getValue',value:function __getValue()
	
	{
	var value=this._strings[0];
	for(var i=0;i<this._values.length;++i){
	value+=this.__transformValue(this._values[i])+this._strings[1+i];
	}
	return value;
	}},{key:'__attach',value:function __attach()
	
	{
	for(var i=0;i<this._values.length;++i){
	if(this._values[i]instanceof Animated){
	this._values[i].__addChild(this);
	}
	}
	}},{key:'__detach',value:function __detach()
	
	{
	for(var i=0;i<this._values.length;++i){
	if(this._values[i]instanceof Animated){
	this._values[i].__removeChild(this);
	}
	}
	}}]);return AnimatedTemplate;}(AnimatedWithChildren);
	
	
	module.exports=AnimatedTemplate;

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	
	
	
	
	
	
	
	
	
	
	'use strict';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var Animated=__webpack_require__(13);
	var AnimatedValue=__webpack_require__(25);var
	
	
	
	AnimatedTracking=function(_Animated){_inherits(AnimatedTracking,_Animated);
	
	
	
	
	
	
	function AnimatedTracking(
	value,
	parent,
	animationClass,
	animationConfig,
	callback)
	{_classCallCheck(this,AnimatedTracking);var _this=_possibleConstructorReturn(this,(AnimatedTracking.__proto__||Object.getPrototypeOf(AnimatedTracking)).call(this));
	
	_this._value=value;
	_this._parent=parent;
	_this._animationClass=animationClass;
	_this._animationConfig=animationConfig;
	_this._callback=callback;
	_this.__attach();return _this;
	}_createClass(AnimatedTracking,[{key:'__getValue',value:function __getValue()
	
	{
	return this._parent.__getValue();
	}},{key:'__attach',value:function __attach()
	
	{
	this._parent.__addChild(this);
	}},{key:'__detach',value:function __detach()
	
	{
	this._parent.__removeChild(this);
	}},{key:'update',value:function update()
	
	{
	this._value.animate(new this._animationClass(_extends({},
	this._animationConfig,{
	toValue:this._animationConfig.toValue.__getValue()})),
	this._callback);
	}}]);return AnimatedTracking;}(Animated);
	
	
	module.exports=AnimatedTracking;

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	
	
	
	
	
	
	
	
	
	
	'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var Animated=__webpack_require__(13);
	var AnimatedWithChildren=__webpack_require__(19);var
	
	AnimatedTransform=function(_AnimatedWithChildren){_inherits(AnimatedTransform,_AnimatedWithChildren);
	
	
	function AnimatedTransform(transforms){_classCallCheck(this,AnimatedTransform);var _this=_possibleConstructorReturn(this,(AnimatedTransform.__proto__||Object.getPrototypeOf(AnimatedTransform)).call(this));
	
	_this._transforms=transforms;return _this;
	}_createClass(AnimatedTransform,[{key:'__getValue',value:function __getValue()
	
	{
	return this._transforms.map(function(transform){
	var result={};
	for(var key in transform){
	var value=transform[key];
	if(value instanceof Animated){
	result[key]=value.__getValue();
	}else{
	result[key]=value;
	}
	}
	return result;
	});
	}},{key:'__getAnimatedValue',value:function __getAnimatedValue()
	
	{
	return this._transforms.map(function(transform){
	var result={};
	for(var key in transform){
	var value=transform[key];
	if(value instanceof Animated){
	result[key]=value.__getAnimatedValue();
	}else{
	
	result[key]=value;
	}
	}
	return result;
	});
	}},{key:'__attach',value:function __attach()
	
	{var _this2=this;
	this._transforms.forEach(function(transform){
	for(var key in transform){
	var value=transform[key];
	if(value instanceof Animated){
	value.__addChild(_this2);
	}
	}
	});
	}},{key:'__detach',value:function __detach()
	
	{var _this3=this;
	this._transforms.forEach(function(transform){
	for(var key in transform){
	var value=transform[key];
	if(value instanceof Animated){
	value.__removeChild(_this3);
	}
	}
	});
	}}]);return AnimatedTransform;}(AnimatedWithChildren);
	
	
	module.exports=AnimatedTransform;

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	
	
	
	
	
	
	
	
	
	'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var AnimatedWithChildren=__webpack_require__(19);
	var InteractionManager=__webpack_require__(98);
	var AnimatedInterpolation=__webpack_require__(45);
	var Interpolation=__webpack_require__(33);
	var Animation=__webpack_require__(32);
	var guid=__webpack_require__(63);
	var Set=global.Set||__webpack_require__(171);
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	function _flush(rootNode){
	var animatedStyles=new Set();
	function findAnimatedStyles(node){
	if(typeof node.update==='function'){
	animatedStyles.add(node);
	}else{
	node.__getChildren().forEach(findAnimatedStyles);
	}
	}
	findAnimatedStyles(rootNode);
	animatedStyles.forEach(function(animatedStyle){return animatedStyle.update();});
	}var
	
	
	
	
	
	
	
	AnimatedValue=function(_AnimatedWithChildren){_inherits(AnimatedValue,_AnimatedWithChildren);
	
	
	
	
	
	
	function AnimatedValue(value){_classCallCheck(this,AnimatedValue);var _this=_possibleConstructorReturn(this,(AnimatedValue.__proto__||Object.getPrototypeOf(AnimatedValue)).call(this));
	
	_this._value=value;
	_this._offset=0;
	_this._animation=null;
	_this._listeners={};return _this;
	}_createClass(AnimatedValue,[{key:'__detach',value:function __detach()
	
	{
	this.stopAnimation();
	}},{key:'__getValue',value:function __getValue()
	
	{
	return this._value+this._offset;
	}},{key:'setValue',value:function setValue(
	
	
	
	
	
	value){
	if(this._animation){
	this._animation.stop();
	this._animation=null;
	}
	this._updateValue(value);
	}},{key:'setOffset',value:function setOffset(
	
	
	
	
	
	
	offset){
	this._offset=offset;
	}},{key:'flattenOffset',value:function flattenOffset()
	
	
	
	
	
	{
	this._value+=this._offset;
	this._offset=0;
	}},{key:'addListener',value:function addListener(
	
	
	
	
	
	
	callback){
	var id=guid();
	this._listeners[id]=callback;
	return id;
	}},{key:'removeListener',value:function removeListener(
	
	id){
	delete this._listeners[id];
	}},{key:'removeAllListeners',value:function removeAllListeners()
	
	{
	this._listeners={};
	}},{key:'stopAnimation',value:function stopAnimation(
	
	
	
	
	
	
	callback){
	this.stopTracking();
	this._animation&&this._animation.stop();
	this._animation=null;
	callback&&callback(this.__getValue());
	}},{key:'interpolate',value:function interpolate(
	
	
	
	
	
	config){
	return new AnimatedInterpolation(this,Interpolation.create(config));
	}},{key:'animate',value:function animate(
	
	
	
	
	
	animation,callback){var _this2=this;
	var handle=null;
	if(animation.__isInteraction){
	handle=InteractionManager.current.createInteractionHandle();
	}
	var previousAnimation=this._animation;
	this._animation&&this._animation.stop();
	this._animation=animation;
	animation.start(
	this._value,
	function(value){
	_this2._updateValue(value);
	},
	function(result){
	_this2._animation=null;
	if(handle!==null){
	InteractionManager.current.clearInteractionHandle(handle);
	}
	callback&&callback(result);
	},
	previousAnimation);
	
	}},{key:'stopTracking',value:function stopTracking()
	
	
	
	
	{
	this._tracking&&this._tracking.__detach();
	this._tracking=null;
	}},{key:'track',value:function track(
	
	
	
	
	tracking){
	this.stopTracking();
	this._tracking=tracking;
	}},{key:'_updateValue',value:function _updateValue(
	
	value){
	this._value=value;
	_flush(this);
	for(var key in this._listeners){
	this._listeners[key]({value:this.__getValue()});
	}
	}}]);return AnimatedValue;}(AnimatedWithChildren);
	
	
	module.exports=AnimatedValue;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	
	
	
	
	
	
	
	
	
	
	'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var Animated=__webpack_require__(13);
	var AnimatedValue=__webpack_require__(25);
	var AnimatedWithChildren=__webpack_require__(19);
	var invariant=__webpack_require__(21);
	var guid=__webpack_require__(63);var
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	AnimatedValueXY=function(_AnimatedWithChildren){_inherits(AnimatedValueXY,_AnimatedWithChildren);
	
	
	
	
	function AnimatedValueXY(valueIn){_classCallCheck(this,AnimatedValueXY);var _this=_possibleConstructorReturn(this,(AnimatedValueXY.__proto__||Object.getPrototypeOf(AnimatedValueXY)).call(this));
	
	var value=valueIn||{x:0,y:0};
	if(typeof value.x==='number'&&typeof value.y==='number'){
	_this.x=new AnimatedValue(value.x);
	_this.y=new AnimatedValue(value.y);
	}else{
	invariant(
	value.x instanceof AnimatedValue&&
	value.y instanceof AnimatedValue,
	'AnimatedValueXY must be initalized with an object of numbers or '+
	'AnimatedValues.');
	
	_this.x=value.x;
	_this.y=value.y;
	}
	_this._listeners={};return _this;
	}_createClass(AnimatedValueXY,[{key:'setValue',value:function setValue(
	
	value){
	this.x.setValue(value.x);
	this.y.setValue(value.y);
	}},{key:'setOffset',value:function setOffset(
	
	offset){
	this.x.setOffset(offset.x);
	this.y.setOffset(offset.y);
	}},{key:'flattenOffset',value:function flattenOffset()
	
	{
	this.x.flattenOffset();
	this.y.flattenOffset();
	}},{key:'__getValue',value:function __getValue()
	
	{
	return{
	x:this.x.__getValue(),
	y:this.y.__getValue()};
	
	}},{key:'stopAnimation',value:function stopAnimation(
	
	callback){
	this.x.stopAnimation();
	this.y.stopAnimation();
	callback&&callback(this.__getValue());
	}},{key:'addListener',value:function addListener(
	
	callback){var _this2=this;
	var id=guid();
	var jointCallback=function jointCallback(_ref){var number=_ref.value;
	callback(_this2.__getValue());
	};
	this._listeners[id]={
	x:this.x.addListener(jointCallback),
	y:this.y.addListener(jointCallback)};
	
	return id;
	}},{key:'removeListener',value:function removeListener(
	
	id){
	this.x.removeListener(this._listeners[id].x);
	this.y.removeListener(this._listeners[id].y);
	delete this._listeners[id];
	}},{key:'getLayout',value:function getLayout()
	
	
	
	
	
	
	
	
	{
	return{
	left:this.x,
	top:this.y};
	
	}},{key:'getTranslateTransform',value:function getTranslateTransform()
	
	
	
	
	
	
	
	
	
	
	{
	return[
	{translateX:this.x},
	{translateY:this.y}];
	
	}}]);return AnimatedValueXY;}(AnimatedWithChildren);
	
	
	module.exports=AnimatedValueXY;

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	
	
	
	
	
	
	
	
	
	
	'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var Animated=__webpack_require__(13);var
	
	AnimatedWithChildren=function(_Animated){_inherits(AnimatedWithChildren,_Animated);
	
	
	function AnimatedWithChildren(){_classCallCheck(this,AnimatedWithChildren);var _this=_possibleConstructorReturn(this,(AnimatedWithChildren.__proto__||Object.getPrototypeOf(AnimatedWithChildren)).call(this));
	
	_this._children=[];return _this;
	}_createClass(AnimatedWithChildren,[{key:'__addChild',value:function __addChild(
	
	child){
	if(this._children.length===0){
	this.__attach();
	}
	this._children.push(child);
	}},{key:'__removeChild',value:function __removeChild(
	
	child){
	var index=this._children.indexOf(child);
	if(index===-1){
	console.warn('Trying to remove a child that doesn\'t exist');
	return;
	}
	this._children.splice(index,1);
	if(this._children.length===0){
	this.__detach();
	}
	}},{key:'__getChildren',value:function __getChildren()
	
	{
	return this._children;
	}}]);return AnimatedWithChildren;}(Animated);
	
	
	module.exports=AnimatedWithChildren;

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

	
	
	
	
	
	
	
	
	
	
	'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var
	
	
	
	
	
	
	
	
	
	
	Animation=function(){function Animation(){_classCallCheck(this,Animation);}_createClass(Animation,[{key:'start',value:function start(
	
	
	
	
	fromValue,
	onUpdate,
	onEnd,
	previousAnimation)
	{}},{key:'stop',value:function stop()
	{}},{key:'__debouncedOnEnd',value:function __debouncedOnEnd(
	
	result){
	var onEnd=this.__onEnd;
	this.__onEnd=null;
	onEnd&&onEnd(result);
	}}]);return Animation;}();
	
	
	module.exports=Animation;

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	
	
	
	
	
	
	
	
	
	
	'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var Animation=__webpack_require__(32);
	var RequestAnimationFrame=__webpack_require__(47);
	var CancelAnimationFrame=__webpack_require__(46);var
	
	
	
	
	
	
	
	
	DecayAnimation=function(_Animation){_inherits(DecayAnimation,_Animation);
	
	
	
	
	
	
	
	
	function DecayAnimation(
	config)
	{_classCallCheck(this,DecayAnimation);var _this=_possibleConstructorReturn(this,(DecayAnimation.__proto__||Object.getPrototypeOf(DecayAnimation)).call(this));
	
	_this._deceleration=config.deceleration!==undefined?config.deceleration:0.998;
	_this._velocity=config.velocity;
	_this.__isInteraction=config.isInteraction!==undefined?config.isInteraction:true;return _this;
	}_createClass(DecayAnimation,[{key:'start',value:function start(
	
	
	fromValue,
	onUpdate,
	onEnd)
	{
	this.__active=true;
	this._lastValue=fromValue;
	this._fromValue=fromValue;
	this._onUpdate=onUpdate;
	this.__onEnd=onEnd;
	this._startTime=Date.now();
	this._animationFrame=RequestAnimationFrame.current(this.onUpdate.bind(this));
	}},{key:'onUpdate',value:function onUpdate()
	
	{
	var now=Date.now();
	
	var value=this._fromValue+
	this._velocity/(1-this._deceleration)*(
	1-Math.exp(-(1-this._deceleration)*(now-this._startTime)));
	
	this._onUpdate(value);
	
	if(Math.abs(this._lastValue-value)<0.1){
	this.__debouncedOnEnd({finished:true});
	return;
	}
	
	this._lastValue=value;
	if(this.__active){
	this._animationFrame=RequestAnimationFrame.current(this.onUpdate.bind(this));
	}
	}},{key:'stop',value:function stop()
	
	{
	this.__active=false;
	CancelAnimationFrame.current(this._animationFrame);
	this.__debouncedOnEnd({finished:false});
	}}]);return DecayAnimation;}(Animation);
	
	
	module.exports=DecayAnimation;

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	
	
	
	
	
	
	
	
	
	
	'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}
	
	var _bezier=__webpack_require__(175);var
	
	
	
	
	
	
	Easing=function(){function Easing(){_classCallCheck(this,Easing);}_createClass(Easing,null,[{key:'step0',value:function step0(
	n){
	return n>0?1:0;
	}},{key:'step1',value:function step1(
	
	n){
	return n>=1?1:0;
	}},{key:'linear',value:function linear(
	
	t){
	return t;
	}},{key:'ease',value:function ease(
	
	t){
	return _ease(t);
	}},{key:'quad',value:function quad(
	
	t){
	return t*t;
	}},{key:'cubic',value:function cubic(
	
	t){
	return t*t*t;
	}},{key:'poly',value:function poly(
	
	n){
	return function(t){return Math.pow(t,n);};
	}},{key:'sin',value:function sin(
	
	t){
	return 1-Math.cos(t*Math.PI/2);
	}},{key:'circle',value:function circle(
	
	t){
	return 1-Math.sqrt(1-t*t);
	}},{key:'exp',value:function exp(
	
	t){
	return Math.pow(2,10*(t-1));
	}},{key:'elastic',value:function elastic()
	
	
	
	
	
	
	
	
	
	
	
	{var bounciness=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;
	var p=bounciness*Math.PI;
	return function(t){return 1-Math.pow(Math.cos(t*Math.PI/2),3)*Math.cos(t*p);};
	}},{key:'back',value:function back(
	
	s){
	if(s===undefined){
	s=1.70158;
	}
	return function(t){return t*t*((s+1)*t-s);};
	}},{key:'bounce',value:function bounce(
	
	t){
	if(t<1/2.75){
	return 7.5625*t*t;
	}
	
	if(t<2/2.75){
	t-=1.5/2.75;
	return 7.5625*t*t+0.75;
	}
	
	if(t<2.5/2.75){
	t-=2.25/2.75;
	return 7.5625*t*t+0.9375;
	}
	
	t-=2.625/2.75;
	return 7.5625*t*t+0.984375;
	}},{key:'bezier',value:function bezier(
	
	
	x1,
	y1,
	x2,
	y2)
	{
	return _bezier(x1,y1,x2,y2);
	}},{key:'in',value:function _in(
	
	
	easing)
	{
	return easing;
	}},{key:'out',value:function out(
	
	
	
	
	
	easing)
	{
	return function(t){return 1-easing(1-t);};
	}},{key:'inOut',value:function inOut(
	
	
	
	
	
	easing)
	{
	return function(t){
	if(t<0.5){
	return easing(t*2)/2;
	}
	return 1-easing((1-t)*2)/2;
	};
	}}]);return Easing;}();
	
	
	var _ease=Easing.bezier(0.42,0,1,1);
	
	
	
	module.exports=Easing;

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	
	
	
	
	
	
	
	
	
	
	
	'use strict';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}
	
	var normalizeColor=__webpack_require__(211);
	
	var invariant=__webpack_require__(21);
	
	
	
	
	
	
	
	
	
	
	
	
	var linear=function linear(t){return t;};var
	
	
	
	
	
	Interpolation=function(){function Interpolation(){_classCallCheck(this,Interpolation);}_createClass(Interpolation,null,[{key:'create',value:function create(
	config){
	
	if(config.outputRange&&typeof config.outputRange[0]==='string'){
	return createInterpolationFromStringOutputRange(config);
	}
	
	var outputRange=config.outputRange;
	checkInfiniteRange('outputRange',outputRange);
	
	var inputRange=config.inputRange;
	checkInfiniteRange('inputRange',inputRange);
	checkValidInputRange(inputRange);
	
	invariant(
	inputRange.length===outputRange.length,
	'inputRange ('+inputRange.length+') and outputRange ('+
	outputRange.length+') must have the same length');
	
	
	var easing=config.easing||linear;
	
	var extrapolateLeft='extend';
	if(config.extrapolateLeft!==undefined){
	extrapolateLeft=config.extrapolateLeft;
	}else if(config.extrapolate!==undefined){
	extrapolateLeft=config.extrapolate;
	}
	
	var extrapolateRight='extend';
	if(config.extrapolateRight!==undefined){
	extrapolateRight=config.extrapolateRight;
	}else if(config.extrapolate!==undefined){
	extrapolateRight=config.extrapolate;
	}
	
	return function(input){
	invariant(
	typeof input==='number',
	'Cannot interpolation an input which is not a number');
	
	
	var range=findRange(input,inputRange);
	return interpolate(
	input,
	inputRange[range],
	inputRange[range+1],
	outputRange[range],
	outputRange[range+1],
	easing,
	extrapolateLeft,
	extrapolateRight);
	
	};
	}}]);return Interpolation;}();
	
	
	function interpolate(
	input,
	inputMin,
	inputMax,
	outputMin,
	outputMax,
	easing,
	extrapolateLeft,
	extrapolateRight)
	{
	var result=input;
	
	
	if(result<inputMin){
	if(extrapolateLeft==='identity'){
	return result;
	}else if(extrapolateLeft==='clamp'){
	result=inputMin;
	}else if(extrapolateLeft==='extend'){
	
	}
	}
	
	if(result>inputMax){
	if(extrapolateRight==='identity'){
	return result;
	}else if(extrapolateRight==='clamp'){
	result=inputMax;
	}else if(extrapolateRight==='extend'){
	
	}
	}
	
	if(outputMin===outputMax){
	return outputMin;
	}
	
	if(inputMin===inputMax){
	if(input<=inputMin){
	return outputMin;
	}
	return outputMax;
	}
	
	
	if(inputMin===-Infinity){
	result=-result;
	}else if(inputMax===Infinity){
	result=result-inputMin;
	}else{
	result=(result-inputMin)/(inputMax-inputMin);
	}
	
	
	result=easing(result);
	
	
	if(outputMin===-Infinity){
	result=-result;
	}else if(outputMax===Infinity){
	result=result+outputMin;
	}else{
	result=result*(outputMax-outputMin)+outputMin;
	}
	
	return result;
	}
	
	function colorToRgba(input){
	var int32Color=normalizeColor(input);
	if(int32Color===null){
	return input;
	}
	
	int32Color=int32Color||0;
	
	var r=(int32Color&0xff000000)>>>24;
	var g=(int32Color&0x00ff0000)>>>16;
	var b=(int32Color&0x0000ff00)>>>8;
	var a=(int32Color&0x000000ff)/255;
	
	return'rgba('+r+', '+g+', '+b+', '+a+')';
	}
	
	var stringShapeRegex=/[0-9\.-]+/g;
	
	
	
	
	
	
	
	
	
	function createInterpolationFromStringOutputRange(
	config)
	{
	var outputRange=config.outputRange;
	invariant(outputRange.length>=2,'Bad output range');
	outputRange=outputRange.map(colorToRgba);
	checkPattern(outputRange);
	
	
	
	
	
	
	
	
	
	
	
	
	var outputRanges=outputRange[0].match(stringShapeRegex).map(function(){return[];});
	outputRange.forEach(function(value){
	
	
	
	value.match(stringShapeRegex).forEach(function(number,i){
	outputRanges[i].push(+number);
	});
	});
	
	
	
	
	var interpolations=outputRange[0].match(stringShapeRegex).map(function(value,i){
	return Interpolation.create(_extends({},
	config,{
	outputRange:outputRanges[i]}));
	
	});
	
	
	
	var shouldRound=/^rgb/.test(outputRange[0]);
	
	return function(input){
	var i=0;
	
	
	
	return outputRange[0].replace(stringShapeRegex,function(){
	var val=interpolations[i++](input);
	return String(shouldRound&&i<4?Math.round(val):val);
	});
	};
	}
	
	function checkPattern(arr){
	var pattern=arr[0].replace(stringShapeRegex,'');
	for(var i=1;i<arr.length;++i){
	invariant(
	pattern===arr[i].replace(stringShapeRegex,''),
	'invalid pattern '+arr[0]+' and '+arr[i]);
	
	}
	}
	
	function findRange(input,inputRange){
	for(var i=1;i<inputRange.length-1;++i){
	if(inputRange[i]>=input){
	break;
	}
	}
	return i-1;
	}
	
	function checkValidInputRange(arr){
	invariant(arr.length>=2,'inputRange must have at least 2 elements');
	for(var i=1;i<arr.length;++i){
	invariant(
	arr[i]>=arr[i-1],
	
	
	
	
	
	
	'inputRange must be monotonically increasing '+arr);
	
	}
	}
	
	function checkInfiniteRange(name,arr){
	invariant(arr.length>=2,name+' must have at least 2 elements');
	invariant(
	arr.length!==2||arr[0]!==-Infinity||arr[1]!==Infinity,
	
	
	
	
	
	
	name+'cannot be ]-infinity;+infinity[ '+arr);
	
	}
	
	module.exports=Interpolation;

/***/ }),

/***/ 171:
/***/ (function(module, exports) {

	
	
	
	
	
	
	
	
	
	'use strict';
	
	function SetPolyfill(){
	this._cache=[];
	}
	
	SetPolyfill.prototype.add=function(e){
	if(this._cache.indexOf(e)===-1){
	this._cache.push(e);
	}
	};
	
	SetPolyfill.prototype.forEach=function(cb){
	this._cache.forEach(cb);
	};
	
	module.exports=SetPolyfill;

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

	
	
	
	
	
	
	
	
	
	
	'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var Animation=__webpack_require__(32);
	var AnimatedValue=__webpack_require__(25);
	var RequestAnimationFrame=__webpack_require__(47);
	var CancelAnimationFrame=__webpack_require__(46);
	var invariant=__webpack_require__(21);
	var SpringConfig=__webpack_require__(173);
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	function withDefault(value,defaultValue){
	if(value===undefined||value===null){
	return defaultValue;
	}
	return value;
	}var
	
	SpringAnimation=function(_Animation){_inherits(SpringAnimation,_Animation);
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	function SpringAnimation(
	config)
	{_classCallCheck(this,SpringAnimation);var _this=_possibleConstructorReturn(this,(SpringAnimation.__proto__||Object.getPrototypeOf(SpringAnimation)).call(this));
	
	
	_this._overshootClamping=withDefault(config.overshootClamping,false);
	_this._restDisplacementThreshold=withDefault(config.restDisplacementThreshold,0.001);
	_this._restSpeedThreshold=withDefault(config.restSpeedThreshold,0.001);
	_this._initialVelocity=config.velocity;
	_this._lastVelocity=withDefault(config.velocity,0);
	_this._toValue=config.toValue;
	_this.__isInteraction=config.isInteraction!==undefined?config.isInteraction:true;
	
	var springConfig;
	if(config.bounciness!==undefined||config.speed!==undefined){
	invariant(
	config.tension===undefined&&config.friction===undefined,
	'You can only define bounciness/speed or tension/friction but not both');
	
	springConfig=SpringConfig.fromBouncinessAndSpeed(
	withDefault(config.bounciness,8),
	withDefault(config.speed,12));
	
	}else{
	springConfig=SpringConfig.fromOrigamiTensionAndFriction(
	withDefault(config.tension,40),
	withDefault(config.friction,7));
	
	}
	_this._tension=springConfig.tension;
	_this._friction=springConfig.friction;return _this;
	}_createClass(SpringAnimation,[{key:'start',value:function start(
	
	
	fromValue,
	onUpdate,
	onEnd,
	previousAnimation)
	{
	this.__active=true;
	this._startPosition=fromValue;
	this._lastPosition=this._startPosition;
	
	this._onUpdate=onUpdate;
	this.__onEnd=onEnd;
	this._lastTime=Date.now();
	
	if(previousAnimation instanceof SpringAnimation){
	var internalState=previousAnimation.getInternalState();
	this._lastPosition=internalState.lastPosition;
	this._lastVelocity=internalState.lastVelocity;
	this._lastTime=internalState.lastTime;
	}
	if(this._initialVelocity!==undefined&&
	this._initialVelocity!==null){
	this._lastVelocity=this._initialVelocity;
	}
	this.onUpdate();
	}},{key:'getInternalState',value:function getInternalState()
	
	{
	return{
	lastPosition:this._lastPosition,
	lastVelocity:this._lastVelocity,
	lastTime:this._lastTime};
	
	}},{key:'onUpdate',value:function onUpdate()
	
	{
	var position=this._lastPosition;
	var velocity=this._lastVelocity;
	
	var tempPosition=this._lastPosition;
	var tempVelocity=this._lastVelocity;
	
	
	
	
	
	var MAX_STEPS=64;
	var now=Date.now();
	if(now>this._lastTime+MAX_STEPS){
	now=this._lastTime+MAX_STEPS;
	}
	
	
	
	
	var TIMESTEP_MSEC=1;
	var numSteps=Math.floor((now-this._lastTime)/TIMESTEP_MSEC);
	
	for(var i=0;i<numSteps;++i){
	
	var step=TIMESTEP_MSEC/1000;
	
	
	
	var aVelocity=velocity;
	var aAcceleration=this._tension*(this._toValue-tempPosition)-this._friction*tempVelocity;
	var tempPosition=position+aVelocity*step/2;
	var tempVelocity=velocity+aAcceleration*step/2;
	
	var bVelocity=tempVelocity;
	var bAcceleration=this._tension*(this._toValue-tempPosition)-this._friction*tempVelocity;
	tempPosition=position+bVelocity*step/2;
	tempVelocity=velocity+bAcceleration*step/2;
	
	var cVelocity=tempVelocity;
	var cAcceleration=this._tension*(this._toValue-tempPosition)-this._friction*tempVelocity;
	tempPosition=position+cVelocity*step/2;
	tempVelocity=velocity+cAcceleration*step/2;
	
	var dVelocity=tempVelocity;
	var dAcceleration=this._tension*(this._toValue-tempPosition)-this._friction*tempVelocity;
	tempPosition=position+cVelocity*step/2;
	tempVelocity=velocity+cAcceleration*step/2;
	
	var dxdt=(aVelocity+2*(bVelocity+cVelocity)+dVelocity)/6;
	var dvdt=(aAcceleration+2*(bAcceleration+cAcceleration)+dAcceleration)/6;
	
	position+=dxdt*step;
	velocity+=dvdt*step;
	}
	
	this._lastTime=now;
	this._lastPosition=position;
	this._lastVelocity=velocity;
	
	this._onUpdate(position);
	if(!this.__active){
	return;
	}
	
	
	var isOvershooting=false;
	if(this._overshootClamping&&this._tension!==0){
	if(this._startPosition<this._toValue){
	isOvershooting=position>this._toValue;
	}else{
	isOvershooting=position<this._toValue;
	}
	}
	var isVelocity=Math.abs(velocity)<=this._restSpeedThreshold;
	var isDisplacement=true;
	if(this._tension!==0){
	isDisplacement=Math.abs(this._toValue-position)<=this._restDisplacementThreshold;
	}
	
	if(isOvershooting||isVelocity&&isDisplacement){
	if(this._tension!==0){
	
	this._onUpdate(this._toValue);
	}
	
	this.__debouncedOnEnd({finished:true});
	return;
	}
	this._animationFrame=RequestAnimationFrame.current(this.onUpdate.bind(this));
	}},{key:'stop',value:function stop()
	
	{
	this.__active=false;
	CancelAnimationFrame.current(this._animationFrame);
	this.__debouncedOnEnd({finished:false});
	}}]);return SpringAnimation;}(Animation);
	
	
	module.exports=SpringAnimation;

/***/ }),

/***/ 173:
/***/ (function(module, exports) {

	
	
	
	
	
	
	
	
	
	
	
	'use strict';
	
	
	
	
	
	
	function tensionFromOrigamiValue(oValue){
	return(oValue-30)*3.62+194;
	}
	
	function frictionFromOrigamiValue(oValue){
	return(oValue-8)*3+25;
	}
	
	function fromOrigamiTensionAndFriction(
	tension,
	friction)
	{
	return{
	tension:tensionFromOrigamiValue(tension),
	friction:frictionFromOrigamiValue(friction)};
	
	}
	
	function fromBouncinessAndSpeed(
	bounciness,
	speed)
	{
	function normalize(value,startValue,endValue){
	return(value-startValue)/(endValue-startValue);
	}
	
	function projectNormal(n,start,end){
	return start+n*(end-start);
	}
	
	function linearInterpolation(t,start,end){
	return t*end+(1-t)*start;
	}
	
	function quadraticOutInterpolation(t,start,end){
	return linearInterpolation(2*t-t*t,start,end);
	}
	
	function b3Friction1(x){
	return 0.0007*Math.pow(x,3)-
	0.031*Math.pow(x,2)+0.64*x+1.28;
	}
	
	function b3Friction2(x){
	return 0.000044*Math.pow(x,3)-
	0.006*Math.pow(x,2)+0.36*x+2;
	}
	
	function b3Friction3(x){
	return 0.00000045*Math.pow(x,3)-
	0.000332*Math.pow(x,2)+0.1078*x+5.84;
	}
	
	function b3Nobounce(tension){
	if(tension<=18){
	return b3Friction1(tension);
	}else if(tension>18&&tension<=44){
	return b3Friction2(tension);
	}else{
	return b3Friction3(tension);
	}
	}
	
	var b=normalize(bounciness/1.7,0,20);
	b=projectNormal(b,0,0.8);
	var s=normalize(speed/1.7,0,20);
	var bouncyTension=projectNormal(s,0.5,200);
	var bouncyFriction=quadraticOutInterpolation(
	b,
	b3Nobounce(bouncyTension),
	0.01);
	
	
	return{
	tension:tensionFromOrigamiValue(bouncyTension),
	friction:frictionFromOrigamiValue(bouncyFriction)};
	
	}
	
	module.exports={
	fromOrigamiTensionAndFriction:fromOrigamiTensionAndFriction,
	fromBouncinessAndSpeed:fromBouncinessAndSpeed};

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	
	
	
	
	
	
	
	
	
	
	'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var Animation=__webpack_require__(32);
	var AnimatedValue=__webpack_require__(25);
	var Easing=__webpack_require__(170);
	var RequestAnimationFrame=__webpack_require__(47);
	var CancelAnimationFrame=__webpack_require__(46);
	
	
	
	var easeInOut=Easing.inOut(Easing.ease);var
	
	
	
	
	
	
	
	
	TimingAnimation=function(_Animation){_inherits(TimingAnimation,_Animation);
	
	
	
	
	
	
	
	
	
	
	function TimingAnimation(
	config)
	{_classCallCheck(this,TimingAnimation);var _this=_possibleConstructorReturn(this,(TimingAnimation.__proto__||Object.getPrototypeOf(TimingAnimation)).call(this));
	
	_this._toValue=config.toValue;
	_this._easing=config.easing!==undefined?config.easing:easeInOut;
	_this._duration=config.duration!==undefined?config.duration:500;
	_this._delay=config.delay!==undefined?config.delay:0;
	_this.__isInteraction=config.isInteraction!==undefined?config.isInteraction:true;return _this;
	}_createClass(TimingAnimation,[{key:'start',value:function start(
	
	
	fromValue,
	onUpdate,
	onEnd)
	{var _this2=this;
	this.__active=true;
	this._fromValue=fromValue;
	this._onUpdate=onUpdate;
	this.__onEnd=onEnd;
	
	var start=function start(){
	if(_this2._duration===0){
	_this2._onUpdate(_this2._toValue);
	_this2.__debouncedOnEnd({finished:true});
	}else{
	_this2._startTime=Date.now();
	_this2._animationFrame=RequestAnimationFrame.current(_this2.onUpdate.bind(_this2));
	}
	};
	if(this._delay){
	this._timeout=setTimeout(start,this._delay);
	}else{
	start();
	}
	}},{key:'onUpdate',value:function onUpdate()
	
	{
	var now=Date.now();
	if(now>=this._startTime+this._duration){
	if(this._duration===0){
	this._onUpdate(this._toValue);
	}else{
	this._onUpdate(
	this._fromValue+this._easing(1)*(this._toValue-this._fromValue));
	
	}
	this.__debouncedOnEnd({finished:true});
	return;
	}
	
	this._onUpdate(
	this._fromValue+
	this._easing((now-this._startTime)/this._duration)*(
	this._toValue-this._fromValue));
	
	if(this.__active){
	this._animationFrame=RequestAnimationFrame.current(this.onUpdate.bind(this));
	}
	}},{key:'stop',value:function stop()
	
	{
	this.__active=false;
	clearTimeout(this._timeout);
	CancelAnimationFrame.current(this._animationFrame);
	this.__debouncedOnEnd({finished:false});
	}}]);return TimingAnimation;}(Animation);
	
	
	module.exports=TimingAnimation;

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

	
	
	
	
	
	
	
	
	var NEWTON_ITERATIONS=4;
	var NEWTON_MIN_SLOPE=0.001;
	var SUBDIVISION_PRECISION=0.0000001;
	var SUBDIVISION_MAX_ITERATIONS=10;
	
	var kSplineTableSize=11;
	var kSampleStepSize=1.0/(kSplineTableSize-1.0);
	
	var float32ArraySupported=typeof Float32Array==='function';
	
	function A(aA1,aA2){return 1.0-3.0*aA2+3.0*aA1;}
	function B(aA1,aA2){return 3.0*aA2-6.0*aA1;}
	function C(aA1){return 3.0*aA1;}
	
	
	function calcBezier(aT,aA1,aA2){return((A(aA1,aA2)*aT+B(aA1,aA2))*aT+C(aA1))*aT;}
	
	
	function getSlope(aT,aA1,aA2){return 3.0*A(aA1,aA2)*aT*aT+2.0*B(aA1,aA2)*aT+C(aA1);}
	
	function binarySubdivide(aX,aA,aB,mX1,mX2){
	var currentX,currentT,i=0;
	do{
	currentT=aA+(aB-aA)/2.0;
	currentX=calcBezier(currentT,mX1,mX2)-aX;
	if(currentX>0.0){
	aB=currentT;
	}else{
	aA=currentT;
	}
	}while(Math.abs(currentX)>SUBDIVISION_PRECISION&&++i<SUBDIVISION_MAX_ITERATIONS);
	return currentT;
	}
	
	function newtonRaphsonIterate(aX,aGuessT,mX1,mX2){
	for(var i=0;i<NEWTON_ITERATIONS;++i){
	var currentSlope=getSlope(aGuessT,mX1,mX2);
	if(currentSlope===0.0){
	return aGuessT;
	}
	var currentX=calcBezier(aGuessT,mX1,mX2)-aX;
	aGuessT-=currentX/currentSlope;
	}
	return aGuessT;
	}
	
	module.exports=function bezier(mX1,mY1,mX2,mY2){
	if(!(0<=mX1&&mX1<=1&&0<=mX2&&mX2<=1)){
	throw new Error('bezier x values must be in [0, 1] range');
	}
	
	
	var sampleValues=float32ArraySupported?new Float32Array(kSplineTableSize):new Array(kSplineTableSize);
	if(mX1!==mY1||mX2!==mY2){
	for(var i=0;i<kSplineTableSize;++i){
	sampleValues[i]=calcBezier(i*kSampleStepSize,mX1,mX2);
	}
	}
	
	function getTForX(aX){
	var intervalStart=0.0;
	var currentSample=1;
	var lastSample=kSplineTableSize-1;
	
	for(;currentSample!==lastSample&&sampleValues[currentSample]<=aX;++currentSample){
	intervalStart+=kSampleStepSize;
	}
	--currentSample;
	
	
	var dist=(aX-sampleValues[currentSample])/(sampleValues[currentSample+1]-sampleValues[currentSample]);
	var guessForT=intervalStart+dist*kSampleStepSize;
	
	var initialSlope=getSlope(guessForT,mX1,mX2);
	if(initialSlope>=NEWTON_MIN_SLOPE){
	return newtonRaphsonIterate(aX,guessForT,mX1,mX2);
	}else if(initialSlope===0.0){
	return guessForT;
	}else{
	return binarySubdivide(aX,intervalStart,intervalStart+kSampleStepSize,mX1,mX2);
	}
	}
	
	return function BezierEasing(x){
	if(mX1===mY1&&mX2===mY2){
	return x;
	}
	
	if(x===0){
	return 0;
	}
	if(x===1){
	return 1;
	}
	return calcBezier(getTForX(x),mY1,mY2);
	};
	};

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

	
	
	
	
	
	
	
	
	
	
	'use strict';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='src/createAnimatedComponent.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}
	
	var React=__webpack_require__(2);
	var AnimatedProps=__webpack_require__(94);
	var ApplyAnimatedValues=__webpack_require__(96);
	
	function createAnimatedComponent(Component){
	var refName='node';var
	
	AnimatedComponent=function(_React$Component){_inherits(AnimatedComponent,_React$Component);function AnimatedComponent(){_classCallCheck(this,AnimatedComponent);return _possibleConstructorReturn(this,(AnimatedComponent.__proto__||Object.getPrototypeOf(AnimatedComponent)).apply(this,arguments));}_createClass(AnimatedComponent,[{key:'componentWillUnmount',value:function componentWillUnmount()
	
	
	{
	this._propsAnimated&&this._propsAnimated.__detach();
	}},{key:'setNativeProps',value:function setNativeProps(
	
	props){
	var didUpdate=ApplyAnimatedValues.current(this.refs[refName],props,this);
	if(didUpdate===false){
	this.forceUpdate();
	}
	}},{key:'componentWillMount',value:function componentWillMount()
	
	{
	this.attachProps(this.props);
	}},{key:'attachProps',value:function attachProps(
	
	nextProps){var _this2=this;
	var oldPropsAnimated=this._propsAnimated;
	
	
	
	
	
	
	
	var callback=function callback(){
	var didUpdate=ApplyAnimatedValues.current(_this2.refs[refName],_this2._propsAnimated.__getAnimatedValue(),_this2);
	if(didUpdate===false){
	_this2.forceUpdate();
	}
	};
	
	this._propsAnimated=new AnimatedProps(
	nextProps,
	callback);
	
	
	
	
	
	
	
	
	
	
	oldPropsAnimated&&oldPropsAnimated.__detach();
	}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(
	
	nextProps){
	this.attachProps(nextProps);
	}},{key:'render',value:function render()
	
	{
	return(
	React.createElement(Component,_extends({},
	this._propsAnimated.__getValue(),{
	ref:refName,__source:{fileName:_jsxFileName,lineNumber:76}})));
	
	
	}}]);return AnimatedComponent;}(React.Component);
	
	AnimatedComponent.propTypes={
	style:function style(props,propName,componentName){
	if(!Component.propTypes){
	return;
	}
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	}};
	
	
	return AnimatedComponent;
	}
	
	module.exports=createAnimatedComponent;

/***/ }),

/***/ 63:
/***/ (function(module, exports) {

	
	
	
	
	
	
	
	
	
	
	'use strict';
	
	var _uniqueId=0;
	
	module.exports=function uniqueId(){
	return String(_uniqueId++);
	};

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	
	
	
	
	
	
	
	
	
	
	'use strict';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};
	
	var invariant=__webpack_require__(21);
	
	var Animated=__webpack_require__(13);
	var AnimatedValue=__webpack_require__(25);
	var AnimatedValueXY=__webpack_require__(168);
	var AnimatedAddition=__webpack_require__(161);
	var AnimatedMultiplication=__webpack_require__(163);
	var AnimatedModulo=__webpack_require__(162);
	var AnimatedTemplate=__webpack_require__(165);
	var AnimatedTracking=__webpack_require__(166);
	var isAnimated=__webpack_require__(177);
	
	var Animation=__webpack_require__(32);
	var TimingAnimation=__webpack_require__(174);
	var DecayAnimation=__webpack_require__(169);
	var SpringAnimation=__webpack_require__(172);
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var maybeVectorAnim=function maybeVectorAnim(
	value,
	config,
	anim)
	{
	if(value instanceof AnimatedValueXY){
	var configX=_extends({},config);
	var configY=_extends({},config);
	for(var key in config){var _config$key=
	config[key],x=_config$key.x,y=_config$key.y;
	if(x!==undefined&&y!==undefined){
	configX[key]=x;
	configY[key]=y;
	}
	}
	var aX=anim(value.x,configX);
	var aY=anim(value.y,configY);
	
	
	return parallel([aX,aY],{stopTogether:false});
	}
	return null;
	};
	
	var spring=function spring(
	value,
	config)
	{
	return maybeVectorAnim(value,config,spring)||{
	start:function start(callback){
	var singleValue=value;
	var singleConfig=config;
	singleValue.stopTracking();
	if(config.toValue instanceof Animated){
	singleValue.track(new AnimatedTracking(
	singleValue,
	config.toValue,
	SpringAnimation,
	singleConfig,
	callback));
	
	}else{
	singleValue.animate(new SpringAnimation(singleConfig),callback);
	}
	},
	
	stop:function stop(){
	value.stopAnimation();
	}};
	
	};
	
	var timing=function timing(
	value,
	config)
	{
	return maybeVectorAnim(value,config,timing)||{
	start:function start(callback){
	var singleValue=value;
	var singleConfig=config;
	singleValue.stopTracking();
	if(config.toValue instanceof Animated){
	singleValue.track(new AnimatedTracking(
	singleValue,
	config.toValue,
	TimingAnimation,
	singleConfig,
	callback));
	
	}else{
	singleValue.animate(new TimingAnimation(singleConfig),callback);
	}
	},
	
	stop:function stop(){
	value.stopAnimation();
	}};
	
	};
	
	var decay=function decay(
	value,
	config)
	{
	return maybeVectorAnim(value,config,decay)||{
	start:function start(callback){
	var singleValue=value;
	var singleConfig=config;
	singleValue.stopTracking();
	singleValue.animate(new DecayAnimation(singleConfig),callback);
	},
	
	stop:function stop(){
	value.stopAnimation();
	}};
	
	};
	
	var sequence=function sequence(
	animations)
	{
	var current=0;
	return{
	start:function start(callback){
	var onComplete=function onComplete(result){
	if(!result.finished){
	callback&&callback(result);
	return;
	}
	
	current++;
	
	if(current===animations.length){
	callback&&callback(result);
	return;
	}
	
	animations[current].start(onComplete);
	};
	
	if(animations.length===0){
	callback&&callback({finished:true});
	}else{
	animations[current].start(onComplete);
	}
	},
	
	stop:function stop(){
	if(current<animations.length){
	animations[current].stop();
	}
	}};
	
	};
	
	
	
	
	var parallel=function parallel(
	animations,
	config)
	{
	var doneCount=0;
	
	var hasEnded={};
	var stopTogether=!(config&&config.stopTogether===false);
	
	var result={
	start:function start(callback){
	if(doneCount===animations.length){
	callback&&callback({finished:true});
	return;
	}
	
	animations.forEach(function(animation,idx){
	var cb=function cb(endResult){
	hasEnded[idx]=true;
	doneCount++;
	if(doneCount===animations.length){
	doneCount=0;
	callback&&callback(endResult);
	return;
	}
	
	if(!endResult.finished&&stopTogether){
	result.stop();
	}
	};
	
	if(!animation){
	cb({finished:true});
	}else{
	animation.start(cb);
	}
	});
	},
	
	stop:function stop(){
	animations.forEach(function(animation,idx){
	!hasEnded[idx]&&animation.stop();
	hasEnded[idx]=true;
	});
	}};
	
	
	return result;
	};
	
	var delay=function delay(time){
	
	return timing(new AnimatedValue(0),{toValue:0,delay:time,duration:0});
	};
	
	var stagger=function stagger(
	time,
	animations)
	{
	return parallel(animations.map(function(animation,i){
	return sequence([
	delay(time*i),
	animation]);
	
	}));
	};
	
	
	
	
	var event=function event(
	argMapping,
	config)
	{
	return function(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}
	var traverse=function traverse(recMapping,recEvt,key){
	if(typeof recEvt==='number'){
	invariant(
	recMapping instanceof AnimatedValue,
	'Bad mapping of type '+typeof recMapping+' for key '+key+
	', event value must map to AnimatedValue');
	
	recMapping.setValue(recEvt);
	return;
	}
	invariant(
	typeof recMapping==='object',
	'Bad mapping of type '+typeof recMapping+' for key '+key);
	
	invariant(
	typeof recEvt==='object',
	'Bad event of type '+typeof recEvt+' for key '+key);
	
	for(var key in recMapping){
	traverse(recMapping[key],recEvt[key],key);
	}
	};
	argMapping.forEach(function(mapping,idx){
	traverse(mapping,args[idx],'arg'+idx);
	});
	if(config&&config.listener){
	config.listener.apply(null,args);
	}
	};
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	module.exports={
	
	
	
	
	Value:AnimatedValue,
	
	
	
	ValueXY:AnimatedValueXY,
	
	
	
	
	
	decay:decay,
	
	
	
	
	timing:timing,
	
	
	
	
	spring:spring,
	
	
	
	
	
	add:function add(a,b){
	return new AnimatedAddition(a,b);
	},
	
	
	
	
	multiply:function multiply(a,b){
	return new AnimatedMultiplication(a,b);
	},
	
	
	
	
	
	modulo:function modulo(a,modulus){
	return new AnimatedModulo(a,modulus);
	},
	
	
	
	
	
	template:function template(strings){for(var _len2=arguments.length,values=Array(_len2>1?_len2-1:0),_key2=1;_key2<_len2;_key2++){values[_key2-1]=arguments[_key2];}
	return new AnimatedTemplate(strings,values);
	},
	
	
	
	
	delay:delay,
	
	
	
	
	
	sequence:sequence,
	
	
	
	
	
	parallel:parallel,
	
	
	
	
	stagger:stagger,
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	event:event,
	
	
	
	
	
	isAnimated:isAnimated,
	
	
	
	
	createAnimatedComponent:__webpack_require__(176),
	
	inject:{
	ApplyAnimatedValues:__webpack_require__(96).inject,
	InteractionManager:__webpack_require__(98).inject,
	FlattenStyle:__webpack_require__(97).inject,
	RequestAnimationFrame:__webpack_require__(47).inject,
	CancelAnimationFrame:__webpack_require__(46).inject},
	
	
	__PropsOnlyForTests:__webpack_require__(94)};

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

	
	
	
	
	
	
	
	
	
	
	'use strict';
	
	var ApplyAnimatedValues={
	current:function ApplyAnimatedValues(instance,props){
	if(instance.setNativeProps){
	instance.setNativeProps(props);
	}else{
	return false;
	}
	},
	inject:function inject(apply){
	ApplyAnimatedValues.current=apply;
	}};
	
	
	module.exports=ApplyAnimatedValues;

/***/ }),

/***/ 46:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	
	
	
	
	
	
	
	
	
	'use strict';
	
	var CancelAnimationFrame={
	current:function current(id){return global.cancelAnimationFrame(id);},
	inject:function inject(injected){
	CancelAnimationFrame.current=injected;
	}};
	
	
	module.exports=CancelAnimationFrame;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

	
	
	
	
	
	
	
	
	
	
	'use strict';
	
	var FlattenStyle={
	current:function current(style){return style;},
	inject:function inject(flatten){
	FlattenStyle.current=flatten;
	}};
	
	
	module.exports=FlattenStyle;

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

	
	
	
	
	
	
	
	
	
	
	'use strict';
	
	var InteractionManager={
	current:{
	createInteractionHandle:function createInteractionHandle(){},
	clearInteractionHandle:function clearInteractionHandle(){}},
	
	inject:function inject(manager){
	InteractionManager.current=manager;
	}};
	
	
	module.exports=InteractionManager;

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	
	
	
	
	
	
	
	
	
	'use strict';
	
	var RequestAnimationFrame={
	current:function current(cb){return global.requestAnimationFrame(cb);},
	inject:function inject(injected){
	RequestAnimationFrame.current=injected;
	}};
	
	
	module.exports=RequestAnimationFrame;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	
	
	
	
	
	
	
	
	
	
	'use strict';
	
	var Animated=__webpack_require__(13);
	
	function isAnimated(obj){
	return obj instanceof Animated;
	}
	
	module.exports=isAnimated;

/***/ }),

/***/ 195:
/***/ (function(module, exports) {

	'use strict';
	
	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};
	
	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}
	
	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);
	
		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}
	
	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
	
	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}
	
	function emptyTarget(val) {
	    return Array.isArray(val) ? [] : {}
	}
	
	function cloneIfNecessary(value, optionsArgument) {
	    var clone = optionsArgument && optionsArgument.clone === true;
	    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
	    var destination = target.slice();
	    source.forEach(function(e, i) {
	        if (typeof destination[i] === 'undefined') {
	            destination[i] = cloneIfNecessary(e, optionsArgument);
	        } else if (isMergeableObject(e)) {
	            destination[i] = deepmerge(target[i], e, optionsArgument);
	        } else if (target.indexOf(e) === -1) {
	            destination.push(cloneIfNecessary(e, optionsArgument));
	        }
	    });
	    return destination
	}
	
	function mergeObject(target, source, optionsArgument) {
	    var destination = {};
	    if (isMergeableObject(target)) {
	        Object.keys(target).forEach(function(key) {
	            destination[key] = cloneIfNecessary(target[key], optionsArgument);
	        });
	    }
	    Object.keys(source).forEach(function(key) {
	        if (!isMergeableObject(source[key]) || !target[key]) {
	            destination[key] = cloneIfNecessary(source[key], optionsArgument);
	        } else {
	            destination[key] = deepmerge(target[key], source[key], optionsArgument);
	        }
	    });
	    return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
	    var sourceIsArray = Array.isArray(source);
	    var targetIsArray = Array.isArray(target);
	    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
	
	    if (!sourceAndTargetTypesMatch) {
	        return cloneIfNecessary(source, optionsArgument)
	    } else if (sourceIsArray) {
	        var arrayMerge = options.arrayMerge || defaultArrayMerge;
	        return arrayMerge(target, source, optionsArgument)
	    } else {
	        return mergeObject(target, source, optionsArgument)
	    }
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
	    if (!Array.isArray(array) || array.length < 2) {
	        throw new Error('first argument should be an array with at least two elements')
	    }
	
	    // we are sure there are at least 2 values, so it is safe to have no initial value
	    return array.reduce(function(prev, next) {
	        return deepmerge(prev, next, optionsArgument)
	    })
	};
	
	var deepmerge_1 = deepmerge;
	
	module.exports = deepmerge_1;


/***/ }),

/***/ 600:
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = direction
	
	var RTL = '\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC'
	var LTR =
	  'A-Za-z\u00C0-\u00D6\u00D8-\u00F6' +
	  '\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF\u200E\u2C00-\uFB1C' +
	  '\uFE00-\uFE6F\uFEFD-\uFFFF'
	
	var rtl = new RegExp('^[^' + LTR + ']*[' + RTL + ']')
	var ltr = new RegExp('^[^' + RTL + ']*[' + LTR + ']')
	
	function direction(value) {
	  value = String(value || '')
	
	  if (rtl.test(value)) {
	    return 'rtl'
	  }
	
	  if (ltr.test(value)) {
	    return 'ltr'
	  }
	
	  return 'neutral'
	}


/***/ }),

/***/ 211:
/***/ (function(module, exports) {

	/*
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	function normalizeColor(color) {
	  var match;
	
	  if (typeof color === 'number') {
	    if (color >>> 0 === color && color >= 0 && color <= 0xffffffff) {
	      return color;
	    }
	    return null;
	  }
	
	  // Ordered based on occurrences on Facebook codebase
	  if ((match = matchers.hex6.exec(color))) {
	    return parseInt(match[1] + 'ff', 16) >>> 0;
	  }
	
	  if (names.hasOwnProperty(color)) {
	    return names[color];
	  }
	
	  if ((match = matchers.rgb.exec(color))) {
	    return (
	        parse255(match[1]) << 24 | // r
	        parse255(match[2]) << 16 | // g
	        parse255(match[3]) << 8 | // b
	        0x000000ff // a
	      ) >>> 0;
	  }
	
	  if ((match = matchers.rgba.exec(color))) {
	    return (
	        parse255(match[1]) << 24 | // r
	        parse255(match[2]) << 16 | // g
	        parse255(match[3]) << 8 | // b
	        parse1(match[4]) // a
	      ) >>> 0;
	  }
	
	  if ((match = matchers.hex3.exec(color))) {
	    return parseInt(
	        match[1] + match[1] + // r
	        match[2] + match[2] + // g
	        match[3] + match[3] + // b
	        'ff', // a
	        16
	      ) >>> 0;
	  }
	
	  // https://drafts.csswg.org/css-color-4/#hex-notation
	  if ((match = matchers.hex8.exec(color))) {
	    return parseInt(match[1], 16) >>> 0;
	  }
	
	  if ((match = matchers.hex4.exec(color))) {
	    return parseInt(
	        match[1] + match[1] + // r
	        match[2] + match[2] + // g
	        match[3] + match[3] + // b
	        match[4] + match[4], // a
	        16
	      ) >>> 0;
	  }
	
	  if ((match = matchers.hsl.exec(color))) {
	    return (
	        hslToRgb(
	          parse360(match[1]), // h
	          parsePercentage(match[2]), // s
	          parsePercentage(match[3]) // l
	        ) |
	        0x000000ff // a
	      ) >>> 0;
	  }
	
	  if ((match = matchers.hsla.exec(color))) {
	    return (
	        hslToRgb(
	          parse360(match[1]), // h
	          parsePercentage(match[2]), // s
	          parsePercentage(match[3]) // l
	        ) |
	        parse1(match[4]) // a
	      ) >>> 0;
	  }
	
	  return null;
	}
	
	function hue2rgb(p, q, t) {
	  if (t < 0) {
	    t += 1;
	  }
	  if (t > 1) {
	    t -= 1;
	  }
	  if (t < 1 / 6) {
	    return p + (q - p) * 6 * t;
	  }
	  if (t < 1 / 2) {
	    return q;
	  }
	  if (t < 2 / 3) {
	    return p + (q - p) * (2 / 3 - t) * 6;
	  }
	  return p;
	}
	
	function hslToRgb(h, s, l) {
	  var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	  var p = 2 * l - q;
	  var r = hue2rgb(p, q, h + 1 / 3);
	  var g = hue2rgb(p, q, h);
	  var b = hue2rgb(p, q, h - 1 / 3);
	
	  return (
	    Math.round(r * 255) << 24 |
	    Math.round(g * 255) << 16 |
	    Math.round(b * 255) << 8
	  );
	}
	
	// var INTEGER = '[-+]?\\d+';
	var NUMBER = '[-+]?\\d*\\.?\\d+';
	var PERCENTAGE = NUMBER + '%';
	
	function toArray(arrayLike) {
	  return Array.prototype.slice.call(arrayLike, 0);
	}
	
	function call() {
	  return '\\(\\s*(' + toArray(arguments).join(')\\s*,\\s*(') + ')\\s*\\)';
	}
	
	var matchers = {
	  rgb: new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER)),
	  rgba: new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER)),
	  hsl: new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE)),
	  hsla: new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER)),
	  hex3: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	  hex4: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	  hex6: /^#([0-9a-fA-F]{6})$/,
	  hex8: /^#([0-9a-fA-F]{8})$/,
	};
	
	function parse255(str) {
	  var int = parseInt(str, 10);
	  if (int < 0) {
	    return 0;
	  }
	  if (int > 255) {
	    return 255;
	  }
	  return int;
	}
	
	function parse360(str) {
	  var int = parseFloat(str);
	  return (((int % 360) + 360) % 360) / 360;
	}
	
	function parse1(str) {
	  var num = parseFloat(str);
	  if (num < 0) {
	    return 0;
	  }
	  if (num > 1) {
	    return 255;
	  }
	  return Math.round(num * 255);
	}
	
	function parsePercentage(str) {
	  // parseFloat conveniently ignores the final %
	  var int = parseFloat(str, 10);
	  if (int < 0) {
	    return 0;
	  }
	  if (int > 100) {
	    return 1;
	  }
	  return int / 100;
	}
	
	var names = {
	  transparent: 0x00000000,
	
	  // http://www.w3.org/TR/css3-color/#svg-color
	  aliceblue: 0xf0f8ffff,
	  antiquewhite: 0xfaebd7ff,
	  aqua: 0x00ffffff,
	  aquamarine: 0x7fffd4ff,
	  azure: 0xf0ffffff,
	  beige: 0xf5f5dcff,
	  bisque: 0xffe4c4ff,
	  black: 0x000000ff,
	  blanchedalmond: 0xffebcdff,
	  blue: 0x0000ffff,
	  blueviolet: 0x8a2be2ff,
	  brown: 0xa52a2aff,
	  burlywood: 0xdeb887ff,
	  burntsienna: 0xea7e5dff,
	  cadetblue: 0x5f9ea0ff,
	  chartreuse: 0x7fff00ff,
	  chocolate: 0xd2691eff,
	  coral: 0xff7f50ff,
	  cornflowerblue: 0x6495edff,
	  cornsilk: 0xfff8dcff,
	  crimson: 0xdc143cff,
	  cyan: 0x00ffffff,
	  darkblue: 0x00008bff,
	  darkcyan: 0x008b8bff,
	  darkgoldenrod: 0xb8860bff,
	  darkgray: 0xa9a9a9ff,
	  darkgreen: 0x006400ff,
	  darkgrey: 0xa9a9a9ff,
	  darkkhaki: 0xbdb76bff,
	  darkmagenta: 0x8b008bff,
	  darkolivegreen: 0x556b2fff,
	  darkorange: 0xff8c00ff,
	  darkorchid: 0x9932ccff,
	  darkred: 0x8b0000ff,
	  darksalmon: 0xe9967aff,
	  darkseagreen: 0x8fbc8fff,
	  darkslateblue: 0x483d8bff,
	  darkslategray: 0x2f4f4fff,
	  darkslategrey: 0x2f4f4fff,
	  darkturquoise: 0x00ced1ff,
	  darkviolet: 0x9400d3ff,
	  deeppink: 0xff1493ff,
	  deepskyblue: 0x00bfffff,
	  dimgray: 0x696969ff,
	  dimgrey: 0x696969ff,
	  dodgerblue: 0x1e90ffff,
	  firebrick: 0xb22222ff,
	  floralwhite: 0xfffaf0ff,
	  forestgreen: 0x228b22ff,
	  fuchsia: 0xff00ffff,
	  gainsboro: 0xdcdcdcff,
	  ghostwhite: 0xf8f8ffff,
	  gold: 0xffd700ff,
	  goldenrod: 0xdaa520ff,
	  gray: 0x808080ff,
	  green: 0x008000ff,
	  greenyellow: 0xadff2fff,
	  grey: 0x808080ff,
	  honeydew: 0xf0fff0ff,
	  hotpink: 0xff69b4ff,
	  indianred: 0xcd5c5cff,
	  indigo: 0x4b0082ff,
	  ivory: 0xfffff0ff,
	  khaki: 0xf0e68cff,
	  lavender: 0xe6e6faff,
	  lavenderblush: 0xfff0f5ff,
	  lawngreen: 0x7cfc00ff,
	  lemonchiffon: 0xfffacdff,
	  lightblue: 0xadd8e6ff,
	  lightcoral: 0xf08080ff,
	  lightcyan: 0xe0ffffff,
	  lightgoldenrodyellow: 0xfafad2ff,
	  lightgray: 0xd3d3d3ff,
	  lightgreen: 0x90ee90ff,
	  lightgrey: 0xd3d3d3ff,
	  lightpink: 0xffb6c1ff,
	  lightsalmon: 0xffa07aff,
	  lightseagreen: 0x20b2aaff,
	  lightskyblue: 0x87cefaff,
	  lightslategray: 0x778899ff,
	  lightslategrey: 0x778899ff,
	  lightsteelblue: 0xb0c4deff,
	  lightyellow: 0xffffe0ff,
	  lime: 0x00ff00ff,
	  limegreen: 0x32cd32ff,
	  linen: 0xfaf0e6ff,
	  magenta: 0xff00ffff,
	  maroon: 0x800000ff,
	  mediumaquamarine: 0x66cdaaff,
	  mediumblue: 0x0000cdff,
	  mediumorchid: 0xba55d3ff,
	  mediumpurple: 0x9370dbff,
	  mediumseagreen: 0x3cb371ff,
	  mediumslateblue: 0x7b68eeff,
	  mediumspringgreen: 0x00fa9aff,
	  mediumturquoise: 0x48d1ccff,
	  mediumvioletred: 0xc71585ff,
	  midnightblue: 0x191970ff,
	  mintcream: 0xf5fffaff,
	  mistyrose: 0xffe4e1ff,
	  moccasin: 0xffe4b5ff,
	  navajowhite: 0xffdeadff,
	  navy: 0x000080ff,
	  oldlace: 0xfdf5e6ff,
	  olive: 0x808000ff,
	  olivedrab: 0x6b8e23ff,
	  orange: 0xffa500ff,
	  orangered: 0xff4500ff,
	  orchid: 0xda70d6ff,
	  palegoldenrod: 0xeee8aaff,
	  palegreen: 0x98fb98ff,
	  paleturquoise: 0xafeeeeff,
	  palevioletred: 0xdb7093ff,
	  papayawhip: 0xffefd5ff,
	  peachpuff: 0xffdab9ff,
	  peru: 0xcd853fff,
	  pink: 0xffc0cbff,
	  plum: 0xdda0ddff,
	  powderblue: 0xb0e0e6ff,
	  purple: 0x800080ff,
	  rebeccapurple: 0x663399ff,
	  red: 0xff0000ff,
	  rosybrown: 0xbc8f8fff,
	  royalblue: 0x4169e1ff,
	  saddlebrown: 0x8b4513ff,
	  salmon: 0xfa8072ff,
	  sandybrown: 0xf4a460ff,
	  seagreen: 0x2e8b57ff,
	  seashell: 0xfff5eeff,
	  sienna: 0xa0522dff,
	  silver: 0xc0c0c0ff,
	  skyblue: 0x87ceebff,
	  slateblue: 0x6a5acdff,
	  slategray: 0x708090ff,
	  slategrey: 0x708090ff,
	  snow: 0xfffafaff,
	  springgreen: 0x00ff7fff,
	  steelblue: 0x4682b4ff,
	  tan: 0xd2b48cff,
	  teal: 0x008080ff,
	  thistle: 0xd8bfd8ff,
	  tomato: 0xff6347ff,
	  turquoise: 0x40e0d0ff,
	  violet: 0xee82eeff,
	  wheat: 0xf5deb3ff,
	  white: 0xffffffff,
	  whitesmoke: 0xf5f5f5ff,
	  yellow: 0xffff00ff,
	  yellowgreen: 0x9acd32ff,
	};
	
	function rgba(colorInt) {
	  var r = Math.round(((colorInt & 0xff000000) >>> 24));
	  var g = Math.round(((colorInt & 0x00ff0000) >>> 16));
	  var b = Math.round(((colorInt & 0x0000ff00) >>> 8));
	  var a = ((colorInt & 0x000000ff) >>> 0) / 255;
	  return {
	    r: r,
	    g: g,
	    b: b,
	    a: a,
	  };
	};
	
	normalizeColor.rgba = rgba;
	
	module.exports = normalizeColor;


/***/ }),

/***/ 1574:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	var _direction = __webpack_require__(600);
	
	var _direction2 = _interopRequireDefault(_direction);
	
	var _direction3 = __webpack_require__(71);
	
	var _direction4 = _interopRequireDefault(_direction3);
	
	var _DirectionProvider = __webpack_require__(1575);
	
	var _DirectionProvider2 = _interopRequireDefault(_DirectionProvider);
	
	var _withDirection = __webpack_require__(84);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
	  children: _propTypes2['default'].node.isRequired,
	  direction: _direction4['default'].isRequired,
	  inline: _propTypes2['default'].bool,
	  text: _propTypes2['default'].string.isRequired
	});
	
	var defaultProps = {
	  inline: false
	};
	
	function AutoDirectionProvider(_ref) {
	  var children = _ref.children,
	      direction = _ref.direction,
	      inline = _ref.inline,
	      text = _ref.text;
	
	  var textDirection = (0, _direction2['default'])(text);
	  var dir = textDirection === 'neutral' ? direction : textDirection;
	
	  return _react2['default'].createElement(
	    _DirectionProvider2['default'],
	    {
	      direction: dir,
	      inline: inline
	    },
	    _react2['default'].Children.only(children)
	  );
	}
	
	AutoDirectionProvider.propTypes = propTypes;
	AutoDirectionProvider.defaultProps = defaultProps;
	
	exports['default'] = (0, _withDirection2['default'])(AutoDirectionProvider);

/***/ }),

/***/ 1575:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DIRECTIONS = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _airbnbPropTypes = __webpack_require__(4);
	
	var _brcast = __webpack_require__(102);
	
	var _brcast2 = _interopRequireDefault(_brcast);
	
	var _brcast3 = __webpack_require__(141);
	
	var _brcast4 = _interopRequireDefault(_brcast3);
	
	var _direction = __webpack_require__(71);
	
	var _direction2 = _interopRequireDefault(_direction);
	
	var _constants = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // This component provides a string to React context that is consumed by the
	// withDirection higher-order component. We can use this to give access to
	// the current layout direction for components to use.
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
	  children: _propTypes2['default'].node.isRequired,
	  direction: _direction2['default'].isRequired,
	  inline: _propTypes2['default'].bool
	});
	
	var defaultProps = {
	  inline: false
	};
	
	var childContextTypes = _defineProperty({}, _constants.CHANNEL, _brcast4['default']);
	
	exports.DIRECTIONS = _constants.DIRECTIONS;
	
	var DirectionProvider = function (_React$Component) {
	  _inherits(DirectionProvider, _React$Component);
	
	  function DirectionProvider(props) {
	    _classCallCheck(this, DirectionProvider);
	
	    var _this = _possibleConstructorReturn(this, (DirectionProvider.__proto__ || Object.getPrototypeOf(DirectionProvider)).call(this, props));
	
	    _this.broadcast = (0, _brcast2['default'])(props.direction);
	    return _this;
	  }
	
	  _createClass(DirectionProvider, [{
	    key: 'getChildContext',
	    value: function () {
	      function getChildContext() {
	        return _defineProperty({}, _constants.CHANNEL, this.broadcast);
	      }
	
	      return getChildContext;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        if (this.props.direction !== nextProps.direction) {
	          this.broadcast.setState(nextProps.direction);
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props = this.props,
	            children = _props.children,
	            direction = _props.direction,
	            inline = _props.inline;
	
	        var Tag = inline ? 'span' : 'div';
	        return _react2['default'].createElement(
	          Tag,
	          { dir: direction },
	          _react2['default'].Children.only(children)
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DirectionProvider;
	}(_react2['default'].Component);
	
	exports['default'] = DirectionProvider;
	
	
	DirectionProvider.propTypes = propTypes;
	DirectionProvider.defaultProps = defaultProps;
	DirectionProvider.childContextTypes = childContextTypes;

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withDirectionPropTypes = exports.DIRECTIONS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports['default'] = withDirection;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(68);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _deepmerge = __webpack_require__(195);
	
	var _deepmerge2 = _interopRequireDefault(_deepmerge);
	
	var _getComponentName = __webpack_require__(57);
	
	var _getComponentName2 = _interopRequireDefault(_getComponentName);
	
	var _constants = __webpack_require__(117);
	
	var _brcast = __webpack_require__(141);
	
	var _brcast2 = _interopRequireDefault(_brcast);
	
	var _direction = __webpack_require__(71);
	
	var _direction2 = _interopRequireDefault(_direction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable react/forbid-foreign-prop-types */
	// This higher-order component consumes a string from React context that is
	// provided by the DirectionProvider component.
	// We can use this to conditionally switch layout/direction for right-to-left layouts.
	
	var contextTypes = _defineProperty({}, _constants.CHANNEL, _brcast2['default']);
	
	exports.DIRECTIONS = _constants.DIRECTIONS;
	
	// set a default direction so that a component wrapped with this HOC can be
	// used even without a DirectionProvider ancestor in its react tree.
	
	var defaultDirection = _constants.DIRECTIONS.LTR;
	
	// export for convenience, in order for components to spread these onto their propTypes
	var withDirectionPropTypes = exports.withDirectionPropTypes = {
	  direction: _direction2['default'].isRequired
	};
	
	function withDirection(WrappedComponent) {
	  var WithDirection = function (_React$Component) {
	    _inherits(WithDirection, _React$Component);
	
	    function WithDirection(props, context) {
	      _classCallCheck(this, WithDirection);
	
	      var _this = _possibleConstructorReturn(this, (WithDirection.__proto__ || Object.getPrototypeOf(WithDirection)).call(this, props, context));
	
	      _this.state = {
	        direction: context[_constants.CHANNEL] ? context[_constants.CHANNEL].getState() : defaultDirection
	      };
	      return _this;
	    }
	
	    _createClass(WithDirection, [{
	      key: 'componentDidMount',
	      value: function () {
	        function componentDidMount() {
	          var _this2 = this;
	
	          if (this.context[_constants.CHANNEL]) {
	            // subscribe to future direction changes
	            this.channelUnsubscribe = this.context[_constants.CHANNEL].subscribe(function (direction) {
	              _this2.setState({ direction: direction });
	            });
	          }
	        }
	
	        return componentDidMount;
	      }()
	    }, {
	      key: 'componentWillUnmount',
	      value: function () {
	        function componentWillUnmount() {
	          if (this.channelUnsubscribe) {
	            this.channelUnsubscribe();
	          }
	        }
	
	        return componentWillUnmount;
	      }()
	    }, {
	      key: 'render',
	      value: function () {
	        function render() {
	          var direction = this.state.direction;
	
	
	          return _react2['default'].createElement(WrappedComponent, _extends({}, this.props, {
	            direction: direction
	          }));
	        }
	
	        return render;
	      }()
	    }]);
	
	    return WithDirection;
	  }(_react2['default'].Component);
	
	  var wrappedComponentName = (0, _getComponentName2['default'])(WrappedComponent) || 'Component';
	
	  WithDirection.WrappedComponent = WrappedComponent;
	  WithDirection.contextTypes = contextTypes;
	  WithDirection.displayName = 'withDirection(' + String(wrappedComponentName) + ')';
	  if (WrappedComponent.propTypes) {
	    WithDirection.propTypes = (0, _deepmerge2['default'])({}, WrappedComponent.propTypes);
	    delete WithDirection.propTypes.direction;
	  }
	  if (WrappedComponent.defaultProps) {
	    WithDirection.defaultProps = (0, _deepmerge2['default'])({}, WrappedComponent.defaultProps);
	  }
	
	  return (0, _hoistNonReactStatics2['default'])(WithDirection, WrappedComponent);
	}

/***/ }),

/***/ 1605:
/***/ (function(module, exports, __webpack_require__) {

	var styleEqual = __webpack_require__(1623);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function type(a) {
	  return Array.isArray(a) ? 'array' : typeof a;
	}
	
	function elementEquals(a, b) {
	  var typeOfA = type(a);
	  var typeOfB = type(b);
	
	  if (typeOfA !== typeOfB) return false;
	
	  switch (typeOfA) {
	    case 'array':
	      if (a.length !== b.length) return false;
	      for (var i = 0; i < a.length; i++) {
	        if (!elementEquals(a[i], b[i])) return false;
	      }
	      return true;
	    case 'object':
	      if (!a || !b) return a === b;
	      if (a.type !== b.type) return false;
	      if (a.key !== b.key) return false;
	      if (a.ref !== b.ref) return false;
	      return shallowElementEquals(a.props, b.props);
	      break;
	    default:
	      return a === b;
	  }
	}
	
	function shallowElementEquals(a, b) {
	  var aCount = 0;
	  var bCount = 0;
	
	  for (var key in a) {
	    if (hasOwnProperty.call(a, key)) {
	      if (key === 'style') {
	        // NOTE(lmr): kind of risky, but i'm assuming that a `style` prop is a React Native style,
	        // and using the `styleEqual` algorithm here.
	        if (!styleEqual(a[key], b[key])) return false;
	      } else if (key === 'children') {
	        // will compare children later
	      } else {
	        if (a[key] !== b[key]) return false;
	      }
	      aCount++;
	    }
	  }
	
	  for (var key in b) {
	    if (hasOwnProperty.call(b, key)) {
	      bCount++;
	    }
	  }
	
	  if (aCount !== bCount) return false;
	
	  // compare children last...
	  return elementEquals(a.children, b.children);
	}
	
	module.exports = shallowElementEquals;


/***/ }),

/***/ 1623:
/***/ (function(module, exports) {

	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function transformEntryEqual(a, b) {
	  for (var k in a) {
	    if (hasOwnProperty.call(a, k)) {
	      return a[k] === b[k];
	    }
	  }
	  return false;
	}
	
	function transformEqual(a, b) {
	  if ((!a && !b) || (a === b)) {
	    return true;
	  }
	  if (!a !== !b) {
	    return false;
	  }
	  if (a.length !== b.length) {
	    return false;
	  }
	  for (var i = 0; i < a.length; i++) {
	    if (!transformEntryEqual(a[i], b[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function shallowObjectEquals(a, b) {
	  var k;
	  var i = 0;
	  var j = 0;
	  for (k in a) {
	    if (hasOwnProperty.call(a, k)) {
	      switch (k) {
	        case 'transform':
	          if (!transformEqual(a[k], b[k])) {
	            return false;
	          }
	          break;
	        case 'shadowOffset':
	          if (!shallowObjectEquals(a[k], b[k])) {
	            return false;
	          }
	          break;
	        default:
	          if (a[k] !== b[k]) {
	            return false;
	          }
	          break;
	      }
	      i++;
	    }
	  }
	  for (k in b) {
	    if (hasOwnProperty.call(b, k)) {
	      j++;
	    }
	  }
	  return i === j;
	}
	
	function styleEqual(a, b) {
	  if ((!a && !b) || (a === b)) {
	    return true;
	  }
	  if (!a !== !b) {
	    return false;
	  }
	  switch (typeof a) {
	    case 'object':
	      if (a instanceof Array) {
	        for (var i = 0; i < a.length; i++) {
	          if (!styleEqual(a[i], b[i])) {
	            return false;
	          }
	        }
	        return a.length === b.length;
	      } else {
	        return shallowObjectEquals(a, b);
	      }
	      break;
	    case 'number':
	    default:
	      return a === b;
	  }
	}
	
	module.exports = styleEqual;


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withStyles = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = _extends({}, _withStyles.withStylesPropTypes, {
	  children: _propTypes2['default'].node.isRequired
	});
	
	function CenterText(_ref) {
	  var children = _ref.children,
	      styles = _ref.styles;
	
	  return _react2['default'].createElement(
	    'div',
	    (0, _withStyles.css)(styles.text),
	    children
	  );
	}
	
	CenterText.propTypes = propTypes;
	
	exports['default'] = (0, _withStyles.withStyles)(function () {
	  return {
	    text: {
	      textAlign: 'center'
	    }
	  };
	})(CenterText);
	module.exports = exports['default'];

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withStyles = __webpack_require__(5);
	
	var _Spacing = __webpack_require__(8);
	
	var _Spacing2 = _interopRequireDefault(_Spacing);
	
	var _Text = __webpack_require__(16);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _VerticalAlignmentContainer = __webpack_require__(147);
	
	var _VerticalAlignmentContainer2 = _interopRequireDefault(_VerticalAlignmentContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = _extends({}, _withStyles.withStylesPropTypes, {
	  event: _propTypes2['default'].object.isRequired
	});
	
	function Event(_ref) {
	  var event = _ref.event,
	      styles = _ref.styles,
	      eventType = _ref.eventType;
	  var title = event.title,
	      video = event.video,
	      date = event.date,
	      slides = event.slides,
	      eventLink = event.eventLink,
	      imageLink = event.imageLink;
	
	
	  var eventImage = imageLink || '/img/events/default/default_event.png';
	  var slideImage = '/img/events/default/default_slides.png';
	
	  // TODO: refactor the following code for different event cards
	  // initial values for regular event cards
	  var eventComponentStyle = {
	    width: '100%',
	    minHeight: 350
	  };
	  var textSection = _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      _Spacing2['default'],
	      { bottom: 2 },
	      _react2['default'].createElement(
	        'div',
	        { style: { minHeight: 60 } },
	        _react2['default'].createElement(
	          _Text2['default'],
	          null,
	          title
	        )
	      ),
	      !!date && _react2['default'].createElement(
	        _Text2['default'],
	        { light: true, micro: true },
	        new Date(date).toLocaleDateString()
	      )
	    )
	  );
	
	  if (eventType === 'promoted') {
	    // overwritten values for promoted event cards
	    eventComponentStyle = {
	      marginLeft: 'auto',
	      marginRight: 'auto',
	      width: '80%',
	      maxHeight: 900,
	      overflow: 'hidden'
	    };
	    textSection = null;
	  }
	
	  var contentThumbnail = void 0;
	  if (video && video.youtube) {
	    contentThumbnail = _react2['default'].createElement(
	      'a',
	      { href: 'https://youtube.com/watch?v=' + video.youtube },
	      _react2['default'].createElement('img', { alt: '', src: 'http://img.youtube.com/vi/' + video.youtube + '/hqdefault.jpg', width: '100%', height: '100%' })
	    );
	  } else if (slides) {
	    contentThumbnail = _react2['default'].createElement(
	      'a',
	      { href: slides, target: '_blank' },
	      _react2['default'].createElement('img', { alt: 'See Slides', src: slideImage, width: '100%', height: '100%' })
	    );
	  } else if (eventImage) {
	    contentThumbnail = _react2['default'].createElement(
	      'a',
	      { href: eventLink, target: '_blank' },
	      _react2['default'].createElement('img', { alt: 'See event', src: eventImage, width: '100%', height: '100%' })
	    );
	  } else if (eventLink) {
	    contentThumbnail = _react2['default'].createElement(
	      'a',
	      _extends({}, (0, _withStyles.css)(styles.rectLink), { href: eventLink }),
	      _react2['default'].createElement(
	        'div',
	        (0, _withStyles.css)(styles.slidesRectangle),
	        _react2['default'].createElement(
	          _VerticalAlignmentContainer2['default'],
	          { fillVertical: true, fillHorizontal: true },
	          _react2['default'].createElement(
	            _VerticalAlignmentContainer.VerticalAlign,
	            { middle: true },
	            _react2['default'].createElement(
	              _Text2['default'],
	              null,
	              'See event'
	            )
	          )
	        )
	      )
	    );
	  }
	
	  return _react2['default'].createElement(
	    'div',
	    (0, _withStyles.css)(eventComponentStyle),
	    _react2['default'].createElement(
	      _Spacing2['default'],
	      { top: 2, bottom: 2, left: 1, right: 1 },
	      textSection,
	      contentThumbnail
	    )
	  );
	}
	
	Event.propTypes = propTypes;
	
	exports['default'] = (0, _withStyles.withStyles)(function (_ref2) {
	  var color = _ref2.color;
	  return {
	    tagsCopy: {
	      color: color.core.babu
	    }
	  };
	})(Event);
	module.exports = exports['default'];

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(73);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Column = __webpack_require__(23);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _ColumnRow = __webpack_require__(31);
	
	var _ColumnRow2 = _interopRequireDefault(_ColumnRow);
	
	var _withStyles = __webpack_require__(5);
	
	var _Rule = __webpack_require__(55);
	
	var _Rule2 = _interopRequireDefault(_Rule);
	
	var _Spacing = __webpack_require__(8);
	
	var _Spacing2 = _interopRequireDefault(_Spacing);
	
	var _Text = __webpack_require__(16);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Title = __webpack_require__(39);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Event = __webpack_require__(180);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = _extends({}, _withStyles.withStylesPropTypes);
	
	function TechTalks(_ref) {
	  var techTalkList = _ref.techTalkList;
	
	  // To handle the case where the teck talks array is empty. However, this is
	  // unlikely to happen in Airbnb.
	  if (!techTalkList || !techTalkList.length) {
	    return null;
	  }
	
	  // Pick all up coming events as promoted events
	  var today = new Date();
	  var todayTimeStamp = today.getTime();
	  var promotedTechTalks = techTalkList.filter(function (talk) {
	    return Date.parse(talk.date) >= todayTimeStamp;
	  }).sort(function (a, b) {
	    return new Date(a.date) - new Date(b.date);
	  });
	
	  // TODO: Ideally, we should promote all upcoming events. But we only promote
	  // the first one for now. Change is expected in the future.
	  var promotedTechTalk = promotedTechTalks[0];
	
	  // Only show the tech talks
	  // 1) after a specific timestamp 'Jan 1, 2016'
	  // 2) with event or image link, for some reason, the vidoe link doesn't show screenshot anymore
	  var timestampForLeastRecentTalk = Date.parse('Jan 1, 2016');
	  var otherTechTalks = techTalkList.slice(promotedTechTalks.length).filter(function (talk) {
	    return Date.parse(talk.date) >= timestampForLeastRecentTalk;
	  }).filter(function (talk) {
	    return !!talk.eventLink || !!talk.imageLink;
	  });
	
	  return _react2['default'].createElement(
	    _Spacing2['default'],
	    { top: 3, left: 3, right: 3 },
	    promotedTechTalks.length == 0 ? null : _react2['default'].createElement(
	      _Spacing2['default'],
	      null,
	      _react2['default'].createElement(
	        _Spacing2['default'],
	        { top: 5, bottom: 2, left: 2 },
	        _react2['default'].createElement(
	          _Title2['default'],
	          { level: 2 },
	          'Upcoming Events'
	        )
	      ),
	      _react2['default'].createElement(_Event2['default'], { event: promotedTechTalk, eventType: 'promoted' }),
	      _react2['default'].createElement(
	        _Spacing2['default'],
	        { top: 5, left: 2 },
	        _react2['default'].createElement(
	          _Spacing2['default'],
	          { top: 1 },
	          _react2['default'].createElement(
	            _Title2['default'],
	            { level: 3 },
	            promotedTechTalk.title
	          )
	        ),
	        _react2['default'].createElement(
	          _Spacing2['default'],
	          { top: 1 },
	          _react2['default'].createElement(
	            _Text2['default'],
	            { light: true },
	            new Date(promotedTechTalk.date).toLocaleString([], {
	              year: 'numeric',
	              month: 'short',
	              day: 'numeric',
	              hour: 'numeric',
	              minute: '2-digit'
	            })
	          )
	        ),
	        !promotedTechTalk.location ? null : _react2['default'].createElement(
	          _Spacing2['default'],
	          { top: 1 },
	          _react2['default'].createElement(
	            _Text2['default'],
	            { light: true },
	            promotedTechTalk.location
	          )
	        ),
	        _react2['default'].createElement(
	          _Spacing2['default'],
	          { top: 2 },
	          _react2['default'].createElement(
	            _Button2['default'],
	            { href: promotedTechTalk.eventLink, openInNewWindow: true },
	            'RSVP'
	          )
	        )
	      )
	    ),
	    _react2['default'].createElement(
	      _Spacing2['default'],
	      { top: 10, left: 2, right: 2 },
	      _react2['default'].createElement(
	        _Title2['default'],
	        { level: 2 },
	        'Past Events'
	      ),
	      _react2['default'].createElement(_Rule2['default'], null)
	    ),
	    _react2['default'].createElement(
	      _Spacing2['default'],
	      { top: 3, left: 2, right: 2 },
	      _react2['default'].createElement(
	        _ColumnRow2['default'],
	        null,
	        otherTechTalks.map(function (event) {
	          return _react2['default'].createElement(
	            _Column2['default'],
	            { sm: 12, md: 4, key: event.title },
	            _react2['default'].createElement(_Event2['default'], { event: event, eventType: 'others' }),
	            _react2['default'].createElement(_Rule2['default'], null)
	          );
	        })
	      )
	    )
	  );
	}
	
	_Event2['default'].propTypes = propTypes;
	
	exports['default'] = (0, _withStyles.withStyles)(function (_ref2) {
	  var color = _ref2.color;
	  return {
	    tagsCopy: {
	      color: color.core.babu
	    }
	  };
	})(TechTalks);
	module.exports = exports['default'];

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Input = __webpack_require__(410);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UncontrolledInput = function (_React$PureComponent) {
	  _inherits(UncontrolledInput, _React$PureComponent);
	
	  function UncontrolledInput(props) {
	    _classCallCheck(this, UncontrolledInput);
	
	    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  UncontrolledInput.prototype.onChange = function () {
	    function onChange(value) {
	      this.setState({ value: value });
	    }
	
	    return onChange;
	  }();
	
	  UncontrolledInput.prototype.render = function () {
	    function render() {
	      var value = this.state.value;
	
	
	      return _react2['default'].createElement(_Input2['default'], _extends({}, this.props, { value: value, onChange: this.onChange }));
	    }
	
	    return render;
	  }();
	
	  return UncontrolledInput;
	}(_react2['default'].PureComponent);
	
	exports['default'] = UncontrolledInput;
	module.exports = exports['default'];

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withStyles = __webpack_require__(5);
	
	var _Title = __webpack_require__(39);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Tabs = __webpack_require__(120);
	
	var _Spacing = __webpack_require__(8);
	
	var _Spacing2 = _interopRequireDefault(_Spacing);
	
	var _Rule = __webpack_require__(55);
	
	var _Rule2 = _interopRequireDefault(_Rule);
	
	var _TabsController = __webpack_require__(416);
	
	var _TabsController2 = _interopRequireDefault(_TabsController);
	
	var _Button = __webpack_require__(73);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Panel = __webpack_require__(143);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _Text = __webpack_require__(16);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _HeadingSection = __webpack_require__(54);
	
	var _HeadingSection2 = _interopRequireDefault(_HeadingSection);
	
	var _TechTalks = __webpack_require__(511);
	
	var _TechTalks2 = _interopRequireDefault(_TechTalks);
	
	var _CenterText = __webpack_require__(99);
	
	var _CenterText2 = _interopRequireDefault(_CenterText);
	
	var _UncontrolledInput = __webpack_require__(512);
	
	var _UncontrolledInput2 = _interopRequireDefault(_UncontrolledInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = _extends({}, _withStyles.withStylesPropTypes);
	
	var SHOW_EMAIL_SIGNUP = false;
	
	function UpcomingEventsEmailSignup() {
	  return _react2['default'].createElement(
	    _Panel2['default'],
	    null,
	    _react2['default'].createElement(
	      _Spacing2['default'],
	      { horizontal: 0, vertical: 2 },
	      _react2['default'].createElement(
	        _CenterText2['default'],
	        null,
	        _react2['default'].createElement(
	          'form',
	          { action: 'http://airbnb3.createsend.com/t/j/s/auhku/', method: 'post' },
	          _react2['default'].createElement(
	            _Text2['default'],
	            { small: true },
	            'Subscribe to get invited to future tech talks'
	          ),
	          _react2['default'].createElement(_UncontrolledInput2['default'], {
	            id: 'fieldEmail',
	            name: 'cm-auhku-auhku',
	            type: 'email',
	            placeholder: 'Enter your email address'
	          }),
	          _react2['default'].createElement(
	            _Button2['default'],
	            { small: true, block: true, type: 'submit' },
	            'Subscribe'
	          )
	        )
	      )
	    )
	  );
	}
	
	function EventSectionHero(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle;
	
	  return _react2['default'].createElement(
	    'div',
	    null,
	    _react2['default'].createElement(
	      _Spacing2['default'],
	      { top: 5, bottom: 5 },
	      _react2['default'].createElement(
	        _Spacing2['default'],
	        { bottom: 1 },
	        _react2['default'].createElement(
	          _Title2['default'],
	          { level: 3 },
	          title
	        )
	      ),
	      _react2['default'].createElement(
	        _Text2['default'],
	        { light: true },
	        subtitle
	      )
	    ),
	    _react2['default'].createElement(_Rule2['default'], { hero: true })
	  );
	}
	
	EventSectionHero.propTypes = {
	  title: _propTypes2['default'].string.isRequired,
	  subtitle: _propTypes2['default'].string.isRequired
	};
	
	var EventsHomepage = function (_React$PureComponent) {
	  _inherits(EventsHomepage, _React$PureComponent);
	
	  function EventsHomepage() {
	    _classCallCheck(this, EventsHomepage);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  EventsHomepage.prototype.render = function () {
	    function render() {
	      var _props = this.props,
	          styles = _props.styles,
	          _props$data = _props.data,
	          allTechTalksYaml = _props$data.allTechTalksYaml,
	          allTakingFlightYaml = _props$data.allTakingFlightYaml,
	          allOpenAirYaml = _props$data.allOpenAirYaml;
	
	
	      var techTalks = allTechTalksYaml.edges.map(function (talk) {
	        return talk.node;
	      });
	
	      // We(tech brand team) decide to hide the "Taking Flight" and "Open Air"
	      // tabs since we haven't organized these events for years. We will uncomment
	      // these codes once there are new events in the futhre.
	      //
	      // const takingFlight = allTakingFlightYaml.edges.map(talk => talk.node);
	      // const openAir = allOpenAirYaml.edges.map(talk => talk.node);
	
	      return _react2['default'].createElement(
	        _HeadingSection2['default'],
	        null,
	        SHOW_EMAIL_SIGNUP && _react2['default'].createElement(
	          _Spacing2['default'],
	          { vertical: 4 },
	          _react2['default'].createElement(
	            'div',
	            (0, _withStyles.css)(styles.emailSignupWrapper),
	            _react2['default'].createElement(UpcomingEventsEmailSignup, null)
	          )
	        ),
	        _react2['default'].createElement(
	          _Spacing2['default'],
	          { right: 2 },
	          _react2['default'].createElement(_TechTalks2['default'], { techTalkList: techTalks })
	        )
	      );
	    }
	
	    return render;
	  }();
	
	  return EventsHomepage;
	}(_react2['default'].PureComponent);
	
	EventsHomepage.propTypes = propTypes;
	
	exports['default'] = (0, _withStyles.withStyles)(function (_ref2) {
	  var _emailSignupWrapper;
	
	  var responsive = _ref2.responsive;
	  return {
	    emailSignupWrapper: (_emailSignupWrapper = {}, _emailSignupWrapper[responsive.mediumAndAbove] = {
	      width: '50%',
	      margin: '0 auto'
	    }, _emailSignupWrapper)
	  };
	})(EventsHomepage);
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-events-index-jsx-8ccf4d2796d8237d7094.js